import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

import { get3wViewerLink, is3wAdvUser, isHpExternal, isProdHpics, isAdvancedExchangeServiceType, isHpUser } from "../common/utils";
import { ShipmentListWidget } from "../common/shipmentListWidget.jsx";
import { ChatbotSandy } from '../common/icons.jsx';

import '../assets/css/q2cui_oss.css';
import '../assets/css/oswidget.css';
import './widget-style.css';

import '../assets/css/daterangepicker.css';
import '../assets/css/uppexternal.css';

import Bill_RGB_gray_NT from '../assets/images/Bill_RGB_gray_NT.png';
import Factory_RGB_gray_NT2 from '../assets/images/Factory_RGB_gray_NT2.png';
import Factory_RGB_green_NT2 from '../assets/images/Factory_RGB_green_NT2.png';
import Shipping_RGB_gray_NT from '../assets/images/Shipping_RGB_gray_NT.png';
import Shipping_RGB_blue_NT from '../assets/images/Shipping_RGB_blue_NT.png';
import Shipping_RGB_green_NT from '../assets/images/Shipping_RGB_green_NT.png';
import escalationUpRight from '../assets/images/escalationUpRight.png';
import exclamation from '../assets/images/exclamation.png';
import Bill_RGB_green_NT from '../assets/images/Bill_RGB_green_NT.png';
import train_icon from '../assets/images/train_icon.png';
import airplane from '../assets/images/airplane.png';
import vessel from '../assets/images/vessel.png';
import house_gray from '../assets/images/house_gray.png';
import house_green from '../assets/images/house_green.png';
import blue_arrow_right_line from '../assets/images/blue_arrow_right_line.png';
import blue_arrow_right_end from '../assets/images/blue_arrow_right_end.png';
import gray_arrow_right_line from '../assets/images/gray_arrow_right_line.png';
import xdock from '../assets/images/xdock.png';
import xdock_blue from '../assets/images/xdock_blue.png';
import factory from '../assets/images/factory.png';
import Dollar_green from '../assets/images/Dollar_green.png';
import Dollar_red from '../assets/images/Dollar_red.png';
import Dollar_blue from '../assets/images/Dollar_blue.png';
import gray_arrow_right_end from '../assets/images/gray_arrow_right_end.png';
import Bill_RGB_blue_NT from '../assets/images/Bill_RGB_blue_NT.png';
import lock_green from '../assets/images/lock_green.png';
import lock_yellow from '../assets/images/lock_yellow.png';
import lock_red from '../assets/images/lock_red.png';
import lock_grey from '../assets/images/lock_grey.png';
import is_leasing_ico from '../assets/images/leasing.png';

import spinning_small from '../assets/images/spinning_small.gif';
import spinning_large from '../assets/images/spinning_large.gif';

import  case_outcomeLogo from '../../int/static/assets/images/case_outcome.png';


//ready js vendors
import '../vendors/q2cui_oss.js';
//import '../vendors/moment.min.js';
var moment = require('moment');

//JOLO_OSS_MOBILE: import '../vendors/daterangepicker.js';

//jsx vendors

//jsx common 

import {ModalWidgetWaiting, ModalWithClose, Modal, ModalTitle, ModalBody, ModalFooter, MaintMsgModal,
        ExportExcelOrder, Restrict, L, Chatbot,
        InitSFDCWorkflow,
        SandyLink, SandyExternalLink,
        Tab, TabBar, StatusElement, OSSAIPersonaModal,
        LabelGrid, SimpleDataGrid, OpenIn, Notification,
        DDLabel, BasicAlert, RefreshOrder, Checkbox, PopupMenu } from '../common/components.jsx';

import {OrderNotes_Open} from '../notes/notes.jsx'

// GEGA TODO MFGListPopUp from components!!!!

//js common
import * as OSWidgetLib from '../common/osWidgetLib.js';
import '../common/plugins.js';

// osWidget_locales.js
//JOLO_OSS_MOBILE: 
import {I18NFile} from '../common/osWidget_locales_HPI.js'

// GEGA T and I18N defined in wepack config as global available
import {fmDate, fmDateTime, fmNum} from '../common/i18n.js';

import { ShipToAddress } from './iShipToAddress.jsx';
import { Dates         } from './hDates.jsx';
import { HPContacts    } from './hHPContacts.jsx';

import { HOrderAnalysis } from './hOrderAnalysis.jsx';
import { IOrderAnalysis } from './iOrderAnalysis.jsx';

/*----------------------------------------------------------------------------
|
|   OSS Widget internal implementation
|
|
|   written by Jochen Loewer and Adolf Krauss
|   July 2014
|
\--------------------------------------------------------------------------*/

jQuery.fn.highlight = function (str, className) {
    var regex = new RegExp(str, "gi");
    return this.each(function () {
        $(this).contents().filter(function() {
            return this.nodeType == 3 && regex.test(this.nodeValue);
        }).replaceWith(function() {
             return (this.nodeValue || "").replace(regex, function(match) {
                return "<span class=\"" + className + "\">" + match + "</span>";
            });
        });
    });
};

function errorHandler(statusText, responseObj, responseText)
{

     if (statusText == "timeout") {
         $('#errorPaneText').html(T('warn_timeout'));
     } else
     if (responseObj) {
        if(responseObj.message.match("SysErr")=="SysErr") {
          var errTxt = "hp_internal_system_error";
          $('#errorPaneText').html(T(errTxt));
        } else {
          $('#errorPaneText').html(T(responseObj.message));
        }
     } else {
         $('#errorPaneText').html(T('warn_error_occured'));
     }
     $('#errorPane').show();
}

function fmAddress ( addressLines  ) {

  if (!addressLines || !(addressLines instanceof Array)) return "";

  return addressLines.map(function(line) {
     return <div className="addressLine">{line}</div>
  });
}

function fmArray (arr) {

    if (!arr || !(arr instanceof Array)) return "";

    return arr.map(function(line) {
        return <div>{line}</div>
    });
}


class StatusElementOld extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var t = this.props.type;
    var id_value = this.props.value_id;
    if (t == "H" || t == "hide") return (<span></span>);
    if (t == "F" || t == "future") return (
      <li id={id_value} className="future"><a>{this.props.children}</a></li>
    );
    if (t == "A" || t == "active") return (
      <li id={id_value} className="active"><a>{this.props.children}</a></li>
    );
    if (t == "S" || t == "seen") return (
      <li id={id_value} className="seen"><a>{this.props.children}</a></li>
    );
  }
};

class TopStatusSection extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      shipment_nos: [],
      packingListToggleEnabled: false
    };

    this.handleDownload         = this.handleDownload.bind(this);
    this.handleShipmentList     = this.handleShipmentList.bind(this); 
    this.handleOpenInvoiceList  = this.handleOpenInvoiceList.bind(this); 
    this.handleDownloadMFGData  = this.handleDownloadMFGData.bind(this); 
    this.handleDownloadPacklist = this.handleDownloadPacklist.bind(this);
    this.handleMfgDataList      = this.handleMfgDataList.bind(this);
    this.handlePackingListToggle = this.handlePackingListToggle.bind(this); 
  }

  handlePackingListToggle  = e => {
    this.setState((prevState) => ({
      packingListToggleEnabled: !prevState.packingListToggleEnabled,
    }));
  };

  handleMassDL = e => {
    e.preventDefault();

    var order_no  = this.props.order.order_no;
    var massDLNos = this.state.shipment_nos;
    var uniqueMassDLNos = []

    for (var i = 0; i < massDLNos.length; i++) {
      if (massDLNos[i].shipment_no && massDLNos[i].shipment_no != "") {
        if(uniqueMassDLNos.indexOf(massDLNos[i].shipment_no) === -1) {
          uniqueMassDLNos.push(massDLNos[i].shipment_no);
        }
      }
    } 

    axios.post('/os/ossui/v1/in/massDL/createSerialReport', {
      id: "", 
      name: "OSWidget_" + order_no, 
      description: "", 
      type: "pod-docs", 
      values: {
                file: "n/a",
                method: "paste",
                values: uniqueMassDLNos
              }
    })
    .then(response => {
      var message = response.data.name + " submitted for processing";
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    });
  };

  handleDownload() {
    //TODO: This is just for testing and the file will be moved later
    if(document.querySelector('.mobile-app')){
      // if mobile
      window.open ( (process.env.REACT_APP_BASENAME === '/' ? '': process.env.REACT_APP_BASENAME)  + "/InvoiceStatusInt?legacy_order_no="+ this.props.order.legacy_order_no,"downloadwindow" ,"menubar=1,resizable=1,width=450,height=450");
    } else {
      window.open ("/static/dist/invoiceStatusInt.html?legacy_order_no="+this.props.order.legacy_order_no+"&type=in&order_no="+this.props.order.order_no,"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  handleOpenInvoiceList() {
    var data_source = this.props.order.data_source
    var acv         = this.props.order.acv
    var baseUrl = "/os/ossui/";
    if(document.querySelector('.mobile-app')){
      // if mobile
      baseUrl = process.env.REACT_APP_API_URL;
    }

    GET(baseUrl + "v1/in/getInvoices/" + this.props.order.legacy_order_no, "", function(resp) {
      if (resp.status == 'N') {
        $("#resultMsg").html(resp.message);
        $("#resultMsg").addClass("alert alert-danger");
        //alert(resp.message);
      } else {

        ReactDOM.render(
          <InvoiceListPopUp
            invoiceList={resp.data}
            invoiceStatus={status}
            acv={acv}
            data_source={data_source} />
          , document.getElementById('invoice')
        );
      }
    });
  }

  handleDownloadMFGData() {
    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    var prefix = '';
    if (window.mobileMode) {
        prefix = '/ext';
    }
    window.open (RewriteRESTURL(prefix+"/os/ossui/v1/in/exportMFGDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + "en"),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
  }

  handleMfgDataList() {

    if (typeof WidgetMode !== 'undefined' && WidgetMode == 'onetime') {
      return;                                                     
    }        

    var params = {};

    var URL = RewriteRESTURL("/os/ossui/v1/in/getMfgDataInfo/"+this.props.order.legacy_order_no);

    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters;
    }

    if (window.mobileMode) {
        URL = '/ext'+URL;
    }
    GET(URL, params, function(res) {

      if (res.status == 'N') {
         $("#mfgdetail").hide();
         $("#mfgResultMsg").html(res.message);
         $("#mfgResultMsg").addClass("alert alert-danger");
      } else {

        $("#mfgResultMsg").empty();
        $("#mfgResultMsg").removeClass("alert alert-danger");

        ReactDOM.render(
          <MFGListPopUp
            mfgList={res.data}/>
          , document.getElementById('mfgdetail')
        );

        $("#mfgdetail").show();
      }
    }.bind(this));
  }

  handleDownloadPacklist() {
    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    window.open (RewriteRESTURL("/static/dist/shipmentPackListInt.html?legacy_order_no="+this.props.order.legacy_order_no+"&orderNo="+this.props.order.order_no+"&language="+I18N.locale+"&type=in"),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
  }

  handleShipmentList() {

    $("#shipmentResultMsg").empty();
    $("#shipmentResultMsg").removeClass("alert alert-danger");
    var prefix = '';
    if (window.mobileMode) {
        prefix = '/ext';
    }

    ReactDOM.render(
      <BasicAlert type="L" />
      , document.getElementById('shipmentdet')
    );

    GET(prefix+"/os/ossui/v1/in/getShipmentInfo/"+this.props.order.legacy_order_no, "", function(res) {

      if (res.status == 'N') {
        $("#shipmentResultMsg").html(res.message);
        $("#shipmentResultMsg").addClass("alert alert-danger");
        ReactDOM.unmountComponentAtNode(document.getElementById('shipmentdet'));
      } else {

        var shipment_nos = []; 
        for (var i = 0; i < res.data.length; i++) {
          shipment_nos.push({order_no: this.props.order.order_no, shipment_no: res.data[i].shipmentno});
        }

        this.setState({
          shipment_nos: shipment_nos,
        });

        ReactDOM.render(
          <ShipmentListWidget
            callerArea="internal"
            shipmentList={res.data}
            OMSystem={this.props.order.om_system}
            handlePodImage={this.handlePodImage}
            TATPreURL={res.podurl} />
          , document.getElementById('shipmentdet')
        );
      }
    }.bind(this));
  }

  handleTracknTrace(hpLegacyOrderNo,shipmentno,trackingno) {

    GET ("/os/ossui/v1/in/trackInfo?legacy_order_no=" + hpLegacyOrderNo + "&shipment_no=" + shipmentno + "&trackingno=" + trackingno, "", function(res){
     if ( res.Trackinfo.status == "E") {

      $("#resultMsg").html(res.Trackinfo.Message);
      $("#resultMsg").addClass("alert alert-danger");

     } else {

      var tnturl = res.Trackinfo[trackingno].tat_url;

      if (tnturl != "" ) {
      var urlFlag = confirm("You are about to leave HP's website!\nHP is not responsible for information outside the HP website.");
      if (urlFlag == true) {
          window.open(tnturl, '_blank', 'width=700,height=500,toolbar=0,location=0,menubar=0');
          }
        } else {
          console.log("testing here");
          alert("Track and Trace url is not available for shipment number " + shipmentno +" and  tracking number " + trackingno);
        }
     }
    });
    event.preventDefault();
  }

  handlePodImage( legacyorderno, shipmentno, carriername, trackingno, hpdeliveryno ,TATPreURL) {
    var podUrl = TATPreURL + "pod=" + hpdeliveryno + "&carrier=" + carriername + "&shipmentno=" + shipmentno + "&pod_os=" + legacyorderno
    window.open (podUrl,"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    event.preventDefault();
  }

  componentDidMount() {
    if (UserSettings.tenant != "HPICS") {
      if ( document.querySelector('#ShipmentScheduled') != null ) {
        document.querySelector('#ShipmentScheduled').setAttribute('style','display:none');
      }
    } else{
      if ( document.querySelector('#Production') != null ) {
        document.querySelector('#Production').setAttribute('style','display:none');
      }
    }
  }

  render() {

    var invoice_status = this.props.order.invoice_status;
    var ship_status    = this.props.order.ship_status;
    var handlePodImage = this.props.handlePodImage;

    console.log("dat source "+this.props.order.data_source);

    var patt = new RegExp("SAP-FAP2");
    var patt1 = new RegExp("SAP-AP");
    var patt2 = new RegExp("QAD-.*");


    var slimDropdown = { "padding": "2px 6px 1px 6px" };

    var invStatus = "Nothing<br>invoiced";
    var invStatusinPopup = "";
    if (invoice_status == "PI") {
      invStatus = "Partially<br>invoiced";
      invStatusinPopup = "Partially invoiced"
    }
    if (invoice_status == "FI") { invStatus = "Fully<br>invoiced"     }

    // define invoice icon/dropdown section
    var invIcon =
      <img height="32" src={Bill_RGB_gray_NT}/>;
    if (invoice_status == "PI") { invIcon = <a id="invdrop" role="button" data-toggle="dropdown" style={slimDropdown} href="#" onClick={this.handleOpenInvoiceList}><img height="32" src={Bill_RGB_blue_NT}/></a> }
    if (invoice_status == "FI") { invIcon = <a id="invdrop" role="button" data-toggle="dropdown" style={slimDropdown} href="#" onClick={this.handleOpenInvoiceList}> <img height="32" src={Bill_RGB_green_NT}/></a> }

    // define mfg icon/dropdown section
    var mfgStatus = "Mfg<br>Data";
    var mfgIcon = <img height="32" src={Factory_RGB_gray_NT2}/>

    var mfgDropDown = "dropdown";
    if (this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0) {
      var mfgIcon = <a id="mfgdrop" role="button" data-toggle={mfgDropDown} style={slimDropdown} href="#" onClick={this.handleMfgDataList}><img height="32" src={Factory_RGB_green_NT2}/></a>
    }

    // define shipment icon/dropdown section

    var exportXLURL = RewriteRESTURL("/os/ossui/v1/in/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale);

    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      exportXLURL = "/os/ossui/v1/in/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale + "?b2bparameters=" + encodeURIComponent( this.props.b2bparameters );
    }
    var downloadShipmentButton =
        <a href={exportXLURL} target="_blank" title={T('DownloadShipmentDataToolTip')} className="btn btn-danger" style={{ "color": "white"}}><L>Download Shipment Details</L></a>

    if (this.state.packingListToggleEnabled) {
      var downloadPacklistButton = 
        <button type="button" className="btn btn-danger" style={{padding:"1px 10px"}} onClick={this.handleDownloadPacklist}>{T('Packing Lists Direct')}</button>
    } else {
      var downloadPacklistButton = 
        <a className={massDLClass} style={{"padding": "1px 10px"}} onClick={this.handleMassDL} title="mass download Packing Lists" name="packing-list">{T('Packing Lists')}</a>
    }
    var massDLClass = "btn btn-danger disabled"
    if (this.state.shipment_nos.length > 0) {
      massDLClass = "btn btn-danger"
    }
    var downloadPODsButton = 
        <a className={massDLClass} onClick={this.handleMassDL} title="mass download POD Docs" name="pod-docs">{T('All PODs')}</a>


    var shpStatus = "Nothing<br>shipped";
    if (ship_status == "PS") { shpStatus = "Partially<br>shipped" }
    if (ship_status == "FS") { shpStatus = "Fully<br>shipped"     }

    var shipIcon = <img height="24" src={Shipping_RGB_gray_NT}/>;
    if (ship_status == "PS") { shipIcon = <a id="shipdrpdwn" role="button" data-toggle="dropdown" style={slimDropdown} href="#" onClick={this.handleShipmentList}><img height="24" src={Shipping_RGB_blue_NT} /></a> }
    if (ship_status == "FS") { shipIcon = <a id="shipdrpdwn" role="button" data-toggle="dropdown" style={slimDropdown} href="#" onClick={this.handleShipmentList}><img height="24" src={Shipping_RGB_green_NT}/></a> }

    var escIcon   = "";
    var escStatus = "";
    if (this.props.order.highest_esc_level && this.props.order.highest_esc_level > 0) {
        escIcon = <img height="26" src={escalationUpRight}/>;
        escStatus = "Escalation Level " + this.props.order.highest_esc_level;
    }

    var critDealIcon   = "";
    var critDealStatus = "";
    if (this.props.order.critical_deal_flag && this.props.order.critical_deal_flag == 'Y') {
        critDealIcon = <img height="26" src={exclamation}/>;
        critDealStatus = "Critical Deal";
    }

    var map = "FFFFFHH";  // F=future, S=seen, A=active, H=hide T=Tooltip
    var url="/os/ossui/v1/in/invoice/"+this.props.order.legacy_order_no;
    var s = this.props.order.order_overall_status;

    if (this.props.order.tenant == "HPICS" && isAdvancedExchangeServiceType(this.props.order.service_type)) {
      // (C)urrent (H)ide (S)een (F)uture
      //                                     +----------------Processing
      //                                     |+---------------Shipped
      //                                     ||+--------------Awaiting Return
      //                                     |||+-------------Received
      //                                     ||||||+----------ShipmentCanceled
      //                                     |||||||+---------Canceled
      if (s == "Canceled"         ) { map = "SHHHHA"; } else
      if (s == "CANCELED"         ) { map = "SHHHHA"; } else
      if (s == "Received"         ) { map = "SSSAHH"; } else
      if (s == "AwaitingReturn"   ) { map = "SSAFHH"; } else
      if (s == "Shipped"          ) { map = "SAFFHH"; } else
      if (s == "Delivered"        ) { map = "SAFFHH"; } else
      if (s == "Processing"       ) { map = "AFFFHH"; } else
      if (s == "ShipmentCanceled" ) { map = "SSHHAH"; }

    } else {
      //                                     +---------------Submitted
      //                                     |+--------------Accepted
      //                                     ||+-------------Production
      //                                     |||+------------Shipped to Customer
      //                                     ||||+-----------Delivered
      //                                     |||||+----------ShipmentCanceled
      //                                     ||||||+---------Canceled
      if (s == "Canceled"         ) { map = "SHHHHHA"; } else
      if (s == "CANCELED"         ) { map = "SHHHHHA"; } else
      if (s == "Delivered"        ) { map = "SSSSAHH"; } else
      if (s == "Shipped"          ) { map = "SSSAFHH"; } else
      if (s == "Consolidation"    ) { map = "SSSAFHH"; } else
      if (s == "Registered"       ) { map = "SSAFFHH"; } else
      if (s == "FactShipped"      ) { map = "SSAFFHH"; } else
      if (s == "ProductionDone"   ) { map = "SSAFFHH"; } else
      if (s == "Production"       ) { map = "SSAFFHH"; } else
      if (s == "ShipmentScheduled") { map = "SSAFFHH"; } else
      if (s == "Acked"            ) { map = "SAFFFHH"; } else
      if (s == "Processing"       ) { map = "SAFFFHH"; } else
      if (s == "Submitted"        ) { map = "AFFFFHH"; } else
      if (s == "ShipmentCanceled" ) { map = "SSSSHAH"; }
    }

    var statusTooltip = "This reflects the status of the longest lead time item on your order";
    var handleDownloadAllInvs = this.handleDownload;

    var stop_chg = this.props.order.stop_change_flag;
    var cons = this.props.order.consolidated_stati;
    var c    = this.props.order.credit_status;

    if (c == null) {
        c = "";
    }

    if ( c.match(/CreditApproved/)
      || ( ( s == "Consolidation" 
        || s == "Registered" 
        || s == "FactShipped" 
        || s == "Shipped" 
        || s == "Delivered" )  
      && !c.match(/Credit/) )
    ) {
        var creIcon  = <img height="38" src={Dollar_green}/>;
        var creStatus = "Credit<br>approved";
    } else
    if ( c.match(/CreditRejected/)
    ) {
        var creIcon  = <img height="38" src={Dollar_red}/>;
        var creStatus = "Credit<br>rejected";
    } else 
    if ( c.match(/CreditUnderValidation/)
    ) {
        var creIcon  = <img height="38" src={Dollar_blue}/>;
        var creStatus = "Credit under<br>validation";
    } else {
        var creIcon  = <img height="38" src={Dollar_blue}/>;
        var creStatus = "Credit under<br>validation";
    }

    if ( stop_chg == 'PC' && this.props.order.om_system == 'SAP-SCP' ) {
      var stopChgIcon = <img height="38" src={lock_yellow}/>;
      var stopChgStatus = "Changes Partially<br>Allowed"
    } else
    if ( stop_chg == 'NC' && this.props.order.om_system == 'SAP-SCP'
    ) {
      var stopChgIcon = <img height="38" src={lock_red}/>;
      var stopChgStatus = "No Changes<br>Allowed"
    } else 
    if ( stop_chg == 'FC' && this.props.order.om_system == 'SAP-SCP'
    ) {
      var stopChgIcon = <img height="38" src={lock_green}/>;
      var stopChgStatus = "Changes<br>Allowed"
    } else {
      var stopChgIcon = <img height="38" src={lock_grey}/>;
      var stopChgStatus = "SC_NA"
    }

    var progressionWidth = '85%';
    var showTooltip = true;
    if (window.mobileMode) {
        progressionWidth = '97%';
        showTooltip = false;
    }

    var statusElements = "";
    if (this.props.order.tenant == "HPICS" && isAdvancedExchangeServiceType(this.props.order.service_type)) {
      statusElements = <ul>
                        <StatusElementOld value_id={"Processing"}        type={map[0]}> <L>Processing</L>          </StatusElementOld>
                        <StatusElementOld value_id={"ShippedtoCustomer"} type={map[1]}> <L>Shipped to Customer</L> </StatusElementOld>
                        <StatusElementOld value_id={"AwaitingReturn"}    type={map[2]}> <L>Awaiting Return</L>     </StatusElementOld>
                        <StatusElementOld value_id={"Received"}          type={map[3]}> <L>Received</L>            </StatusElementOld>
                        <StatusElementOld value_id={"ShipmentCanceled"}  type={map[4]}> <L>Shipment Canceled</L>   </StatusElementOld>
                        <StatusElementOld value_id={"Cancelled"}         type={map[5]}> <L>Cancelled</L>           </StatusElementOld>
                        {showTooltip ?
                          <li className="tooltiphead">
                            <a className="tooltips" >{this.props.children}
                              <div className="classic" style={{ "whiteSpace": "normal"}}><L>{statusTooltip}</L></div>
                            </a>
                          </li>
                        : null
                        }
                      </ul>
    } else {
      statusElements = <ul>
                        <StatusElementOld value_id={"Submitted"}         type={map[0]}> <L>Submitted</L>          </StatusElementOld>
                        <StatusElementOld value_id={"Processing"}        type={map[1]}> <L>Processing</L>          </StatusElementOld>
                        <StatusElementOld value_id={"ShipmentScheduled"} type={map[2]}> <L>ShipmentScheduled</L>  </StatusElementOld>
                        <StatusElementOld value_id={"Production"}        type={map[2]}> <L>Production</L>         </StatusElementOld>
                        <StatusElementOld value_id={"ShippedtoCustomer"} type={map[3]}> <L>Shipped to Customer</L></StatusElementOld>
                        <StatusElementOld value_id={"Delivered"}         type={map[4]}> <L>Delivered</L>          </StatusElementOld>
                        <StatusElementOld value_id={"ShipmentCanceled"}  type={map[5]}> <L>Shipment Canceled</L>  </StatusElementOld>
                        <StatusElementOld value_id={"Cancelled"}         type={map[6]}> <L>Cancelled</L>          </StatusElementOld>
                        {showTooltip ?
                          <li className="tooltiphead">
                            <a className="tooltips" >{this.props.children}
                              <div className="classic" style={{ "whiteSpace": "normal"}}><L>{statusTooltip}</L></div>
                            </a>
                          </li>
                        : null
                        }
                      </ul>
    }

    return (
      <div>
        <table className="topstatus" width="100%">
        <tbody className="topstatus_body">
          <tr>
            <td style={{ "width": {progressionWidth}, "verticalAlign": "bottom", "align": "left"}}>
                <div className="progression">
                  {statusElements}
                </div>
            </td>
            { this.props.order.critical_deal_flag === 'Y' && 
                  <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>{critDealIcon}</td>
            }
            { this.props.order.highest_esc_level > 0 && 
                  <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>{escIcon}</td>
            }
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>{stopChgIcon}</td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>{creIcon}</td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>
              <ul className="nav nav-dropWin">
                <li className="dropdown">
                  {mfgIcon}
                  <ul id="menumfg" className="dropdown-menu pull-right" role="menu" aria-labelledby="mfgdrop" style={{"right": "-100px"}}>
                  <div className="dropInfoWin">
                      <div className="modal-header">
                        <MfgPopupWrapperClass
                          order={this.props.order} />
                      </div>
                      <div id="mfgResultMsg"></div>
                      <div id="mfgdetail" style={{ "margin": "15px"}}></div>
                    </div>
                  </ul>
                </li>
              </ul>
            </td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>
              <ul className="nav nav-dropWin">
                  <li className="dropdown">
                    {shipIcon}
                    <ul id="menushp" className="dropdown-menu pull-right" role="menu" aria-labelledby="shipdrpdwn" style={{"right": "10px"}}>
                    <div className="dropInfoWin">
                        <div className="modal-header">
                          <h4 className="modal-title" style={{ "textAlign": "left"}}>
                            <div className="pull-left"><L>Shipment(s)</L></div>
                            <div id="downloadShipData" className="pull-right">
                                {downloadPODsButton}
                                &nbsp; 
                                {downloadShipmentButton}
                                &nbsp; 
                                {downloadPacklistButton}
                                {/* <Checkbox isEnabled={this.state.packingListToggleEnabled} onChange={this.handlePackingListToggle} /> */}
                            </div>
                          </h4>
                        </div>
                        <div id="shipmentResultMsg"></div>
                        <div id="shipmentdet" style={{ margin: "7px", maxHeight: "440px", overflow: "auto"}}></div>
                      </div>
                    </ul>
                  </li>
              </ul>
            </td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>
              <ul className="nav nav-dropWin">
                <li className="dropdown">
                  {invIcon}
                  <ul id="menuinv" className="dropdown-menu pull-right" role="menu" aria-labelledby="invdrop" style={{"right": "67px"}}>
                  <div className="dropInfoWin">
                      <div className="modal-header">
                        <InvoicePopupWrapperClass
                          invStatusinPopup={invStatusinPopup}
                          handleDownloadAllInvs={handleDownloadAllInvs}
                          order={this.props.order} />
                      </div>
                      <div id="resultMsg"></div>
                      <div id="invoice" style={{ "margin": "15px"}}>
                      </div>
                    </div>
                  </ul>
                </li>
              </ul>
          </td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            { this.props.order.critical_deal_flag === 'Y' && 
            <td className='statuslabel'><L>{critDealStatus}</L></td>
            }
            { this.props.order.highest_esc_level > 0 && 
                <td className='statuslabel'><L>{escStatus}</L></td>
            }
            <td className='statuslabel'><L>{stopChgStatus}</L></td> 
            <td className='statuslabel'><L>{creStatus}</L></td>
            <td className='statuslabel'><L>{mfgStatus}</L></td>
            <td className='statuslabel'><L>{shpStatus}</L></td>
            <td className='statuslabel'><L>{invStatus}</L></td>
          </tr>
        </tbody>
        </table>
        <ToastContainer />
      </div>
    )
  }
};

class TimelineSpacer extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="timelineMiddleSpacer">&nbsp;</div>
    )
  }
};

class TimelineInfo extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var statusTooltip = "Most recent event dates of your order";
    return (
      <div className="timelineMiddleInfo">
        <a className="tooltips" style={{ "paddingLeft":"17px" }}>{this.props.children}
          <div className="classic"><L>{statusTooltip}</L></div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </a>
      </div>
    )
  }
};


class TimelineEntry extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.date == '') {
      return (
        <div className="timelineMiddle timelineMiddleMissing">&nbsp;<br/><br/>{this.props.label}</div>
      )
    }
      return (
      <div className="timelineMiddle">{this.props.date}<br/><br/>{this.props.label}</div>
    )
  }
};

class Timeline extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var order = this.props.order;
    var ship_status = this.props.order.ship_status;
        if(ship_status == 'PS'){
            var shipLabel = T('Last Shipped');
            var podLabel  = T('Last Delivered');
        }else{
            var shipLabel = T('Shipped');
            var podLabel  = T('Delivered');
        }
    return (
       <div className="timeline">
          <TimelineEntry date={fmDate(order.purch_order_date)} label={T('Purchased')}/>
          <TimelineEntry date={fmDate(order.clean_order_date)}    label={T('Clean Order')}/>
          <TimelineEntry date={fmDate(order.customer_ship_date)}  label={shipLabel}/>
          <TimelineEntry date={fmDate(order.pod_date)}            label={podLabel}/>
          <TimelineInfo/>
       </div>
    )
  }
};


//----------------------------------------------------------------------
//   OswiActions -- show action buttons - export, open in SAP, etc.
//
//----------------------------------------------------------------------
class OswiActions extends React.Component {

  constructor(props) {
    super(props);
  }
  
  render() {
    var tenant = this.props.userSettings.tenant;
    var submitRequestBtn = null;
    if(!OSWidgetLib.ZMSOOrder(this.props.order)) {
      submitRequestBtn = <>
                          <InitSFDCWorkflow order={this.props.order} locale={I18N.locale} class="btn-smallest" isValidDwGroupUser={this.props.userSettings.memberOf('SupportRequests')} sccpItems={this.props.sccpItems}/>
                          &nbsp;
                        </>
    }

    let launchInSAP = null;
    if ( isHpUser(this.props.userSettings.user_id) ) {
      launchInSAP = <>
        <LaunchInSAP size="smallest" order={this.props.order}/>
        &nbsp;
      </>
    }

    if (window.mobileMode) {
      return (
        <div id="TopLineSegment_Buttons" style={{"display":"inline", "float": "right", "textAlign":"right", "paddingBottom": "12px"}}>
          <ExportExcelOrder size="smallest" order={this.props.order}/>
          { tenant !== 'HPICS' && <SandyExternalLink order={this.props.order}/> }
          &nbsp;
          {submitRequestBtn}
        </div>
      )
    }
    return (
      <div id="TopLineSegment_Buttons" style={{"display":"inline", "float": "right", "textAlign":"right", "paddingBottom": "10px"}}>
        {submitRequestBtn}
        {launchInSAP}
        <OpenIn order={this.props.order} class="btn-smallest" caller="oswi"/>
        &nbsp;
        <ExportExcelOrder size="smallest" order={this.props.order}/>
        &nbsp;
        <RefreshOrder order={this.props.order}/>
      </div>
    )
  }
}


//---------------------------------------------------------------------------------
//   StatusIcons -- show clickable status icons such as Lock, Dollar, Bill, etc.
//
//---------------------------------------------------------------------------------
class StatusIcons extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      shipment_nos: [],
      packingListToggleEnabled: false
    };

    this.getVizIcon                = this.getVizIcon.bind(this);
    this.handleDownloadMFGData     = this.handleDownloadMFGData.bind(this);
    this.handleMfgDataList         = this.handleMfgDataList.bind(this);
    this.handleMassDL              = this.handleMassDL.bind(this);
    this.handleDownloadPacklist    = this.handleDownloadPacklist.bind(this);
    this.handlePackingListToggle   = this.handlePackingListToggle.bind(this);
    this.handleShipmentList        = this.handleShipmentList.bind(this);
    this.handlePodImage            = this.handlePodImage.bind(this);
    this.handleOpenInvoiceList     = this.handleOpenInvoiceList.bind(this);
    this.handleDownloadAllInvs     = this.handleDownloadAllInvs.bind(this);
  }

  handlePackingListToggle  = e => {
    this.setState((prevState) => ({
      packingListToggleEnabled: !prevState.packingListToggleEnabled,
    }));
  };

  handleDownloadMFGData() {
    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    var prefix = '';
    if (window.mobileMode) {
        prefix = '/ext';
    }
    window.open (RewriteRESTURL(prefix+"/os/ossui/v1/in/exportMFGDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + "en"),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
  }

  handleMfgDataList() {

    if (typeof WidgetMode !== 'undefined' && WidgetMode == 'onetime') {
      return;                                                     
    }        

    var params = {};

    var URL = RewriteRESTURL("/os/ossui/v1/in/getMfgDataInfo/"+this.props.order.legacy_order_no);

    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters;
    }

    if (window.mobileMode) {
        URL = '/ext'+URL;
    }
    GET(URL, params, function(res) {

      if (res.status == 'N') {
         $("#mfgdetail").hide();
         $("#mfgResultMsg").html(res.message);
         $("#mfgResultMsg").addClass("alert alert-danger");
      } else {

        $("#mfgResultMsg").empty();
        $("#mfgResultMsg").removeClass("alert alert-danger");

        ReactDOM.render(
          <MFGListPopUp
            mfgList={res.data}/>
          , document.getElementById('mfgdetail')
        );

        $("#mfgdetail").show();
      }
    }.bind(this));
  }

  handleMassDL = e => {
    e.preventDefault();

    var order_no  = this.props.order.order_no;
    var massDLNos = this.state.shipment_nos;
    var uniqueMassDLNos = []

    for (var i = 0; i < massDLNos.length; i++) {
      if (massDLNos[i].shipment_no && massDLNos[i].shipment_no != "") {
        if(uniqueMassDLNos.indexOf(massDLNos[i].shipment_no) === -1) {
          uniqueMassDLNos.push(massDLNos[i].shipment_no);
        }
      }
    } 

    axios.post('/os/ossui/v1/in/massDL/createSerialReport', {
      id: "", 
      name: "OSWidgetInt_" + order_no, 
      description: "", 
      type: e.target.name,
      values: {
                file: "n/a",
                method: "paste",
                values: uniqueMassDLNos
              }
    })
    .then(response => {
      var message = response.data.name + " submitted for processing";
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    });
  };

  handleDownloadPacklist() {
    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    window.open (RewriteRESTURL("/static/dist/shipmentPackListInt.html?legacy_order_no="+this.props.order.legacy_order_no+"&orderNo="+this.props.order.order_no+"&language="+I18N.locale+"&type=in"),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
  }

  handleShipmentList() {

    $("#shipmentResultMsg").empty();
    ReactDOM.unmountComponentAtNode(document.getElementById('shipmentdet'));
    $("#shipmentResultMsg").removeClass("alert alert-danger");
    var prefix = '';
    if (window.mobileMode) {
        prefix = '/ext';
    }

    ReactDOM.render(
      <BasicAlert type="L" />
      , document.getElementById('shipmentdet')
    );

    GET(prefix+"/os/ossui/v1/in/getShipmentInfo/"+this.props.order.legacy_order_no, "", function(res) {

      if (res.status == 'N') {
        $("#shipmentResultMsg").html(res.message);
        $("#shipmentResultMsg").addClass("alert alert-danger");
        ReactDOM.unmountComponentAtNode(document.getElementById('shipmentdet'));
      } else {

        var shipment_nos = []; 
        for (var i = 0; i < res.data.length; i++) {
          shipment_nos.push({order_no: this.props.order.order_no, shipment_no: res.data[i].shipmentno});
        }

        this.setState({
          shipment_nos: shipment_nos,
        });

        ReactDOM.render(
          <ShipmentListWidget
            callerArea="internal"
            shipmentList={res.data}
            OMSystem={this.props.order.om_system}
            handlePodImage={this.handlePodImage}
            TATPreURL={res.podurl} />
          , document.getElementById('shipmentdet')
        );
      }
    }.bind(this));
  }

  handlePodImage( legacyorderno, shipmentno, carriername, trackingno, hpdeliveryno ,TATPreURL) {
    var podUrl = TATPreURL + "pod=" + hpdeliveryno + "&carrier=" + carriername + "&shipmentno=" + shipmentno + "&pod_os=" + legacyorderno
    var podUrl = "/os/podimg?shipment="+shipmentno+"&lno="+legacyorderno;
    window.open(podUrl,"downloadwindow","menubar=1,resizable=1,width=750,height=590");
    event.preventDefault();
  }

  handleOpenInvoiceList() {
    var data_source = this.props.order.data_source
    var acv         = this.props.order.acv
    var baseUrl = "/os/ossui/";
    if(document.querySelector('.mobile-app')){
      // if mobile
      baseUrl = process.env.REACT_APP_API_URL;
    }

    GET(baseUrl + "v1/in/getInvoices/" + this.props.order.legacy_order_no, "", function(resp) {
      if (resp.status == 'N') {
        $("#resultMsg").html(resp.message);
        $("#resultMsg").addClass("alert alert-danger");
        //alert(resp.message);
      } else {

        ReactDOM.render(
          <InvoiceListPopUp
            invoiceList={resp.data}
            invoiceStatus={status}
            acv={acv}
            data_source={data_source} />
          , document.getElementById('invoice')
        );
      }
    });
  }

  handleDownloadAllInvs() {
    //TODO: This is just for testing and the file will be moved later
    if(document.querySelector('.mobile-app')){
      // if mobile
      window.open ( (process.env.REACT_APP_BASENAME === '/' ? '': process.env.REACT_APP_BASENAME)  + "/InvoiceStatusInt?legacy_order_no="+ this.props.order.legacy_order_no,"downloadwindow" ,"menubar=1,resizable=1,width=450,height=450");
    } else {
      window.open ("/static/dist/invoiceStatusInt.html?legacy_order_no="+this.props.order.legacy_order_no+"&type=in&order_no="+this.props.order.order_no,"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  getVizIcon(iconCode){
    const icon = {};

    if (iconCode === 'credit_status') {
      // if credit status icon
      const os = this.props.order.order_overall_status;
      const cs = this.props.order.credit_status;

      if (
        cs.match(/CreditApproved/) ||
        ((os === "Consolidation" ||
          os === "Registered" ||
          os === "FactShipped" ||
          os === "Shipped" ||
          os === "Delivered") &&
          !cs.match(/Credit/))
      ) {
        icon.type = Dollar_green;
        icon.statusText = "Credit<br>approved"
      } else if (cs.match(/CreditRejected/)) {
        icon.type = Dollar_red;
        icon.statusText = "Credit<br>rejected";
      } else if (cs.match(/CreditUnderValidation/)) {
        icon.type = Dollar_blue;
        icon.statusText = "Credit under<br>validation";
      } else {
        icon.type = Dollar_blue;
        icon.statusText = "Credit under<br>validation";
      }

    } else if (iconCode === 'changes'){
      const stop_chg = this.props.order.stop_change_flag;
      const om_system = this.props.order.om_system;
      if ( stop_chg == 'PC' && om_system == 'SAP-SCP' ) {
        icon.type = lock_yellow;
        icon.statusText = "Changes Partially<br>Allowed";
      } else
      if ( stop_chg == 'NC' && om_system == 'SAP-SCP') {
        icon.type = lock_red;
        icon.statusText = "No Changes<br>Allowed";
      } else if ( stop_chg == 'FC' && om_system == 'SAP-SCP' ) {
        icon.type = lock_green;
        icon.statusText = "Changes<br>Allowed";
      } else {
        icon.type = lock_grey;
        icon.statusText = "SC_NA";
      }

    } else if (iconCode === 'mfg') {
        icon.type = Factory_RGB_gray_NT2;
        icon.statusText = "Mfg<br>Data";
        if (this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0) {
          icon.type = Factory_RGB_green_NT2;
          icon.statusText = "Mfg<br>Data";
        }
    } else if (iconCode === 'shp') {
        const shpStatus = this.props.order.ship_status;

        icon.type = Shipping_RGB_gray_NT;
        icon.statusText = "Nothing<br>shipped";
        if (shpStatus == "PS") { 
          icon.type = Shipping_RGB_blue_NT;
          icon.statusText = "Partially<br>shipped";
        } else if (shpStatus == "FS") {
          icon.type = Shipping_RGB_green_NT;
          icon.statusText = "Fully<br>shipped";
        }
    } else if (iconCode === 'inv') {
      const invoice_status = this.props.order.invoice_status;
      icon.type = Bill_RGB_gray_NT;
      icon.statusText = 'Nothing<br>invoiced';

      if (invoice_status == "PI") {
        icon.type = Bill_RGB_blue_NT;
        icon.statusText = 'Partially<br>invoiced';
      } else if ( invoice_status == "FI" ){
        icon.type = Bill_RGB_green_NT;
        icon.statusText = 'Fully<br>invoiced';
      }
    }

    return icon;
  }

  render() {

    var iconStyle = { "padding": "2px 6px 1px 6px", "pointerEvents": "all" };

    // Enable MFG data download modal

    if ((this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0) || (this.props.order.nr_of_trackids && this.props.order.nr_of_trackids > 0) ) {
      var mfgIcon = 
        <a id="mfgdrop" role="button" className="ico-container" data-toggle="dropdown" style={iconStyle} href="#" onClick={this.handleMfgDataList}>
          <img className="status-ico" height="32" src={this.getVizIcon('mfg').type} />
        </a>
    } else {
      var mfgIcon = <img className="status-ico" height="32" src={this.getVizIcon('mfg').type} />
    }

    var mfgModal =  
        <div className="dropdown nav-dropWin">
          {mfgIcon}
          <ul id="menumfg" className="dropdown-menu pull-right" role="menu" aria-labelledby="mfgdrop" style={{"right": "-100px"}}>
          <div className="dropInfoWin">
              <div className="modal-header">
                <MfgPopupWrapperClass
                  order={this.props.order} />
              </div>
              <div id="mfgResultMsg"></div>
              <div id="mfgdetail" style={{ "margin": "15px"}}></div>
            </div>
          </ul>
        </div>
                    

    // Shipment section

    var massDLClass = "btn btn-danger disabled"
    if (this.state.shipment_nos.length > 0) {
      massDLClass = "btn btn-danger"
    }
    var exportXLURL = RewriteRESTURL("/os/ossui/v1/in/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale);

    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      exportXLURL = "/os/ossui/v1/in/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale + "?b2bparameters=" + encodeURIComponent( this.props.b2bparameters );
    }

    var downloadPODsButton = 
        <a className={massDLClass} style={{"padding": "1px 10px"}} onClick={this.handleMassDL} title="mass download POD Docs" name="pod-docs">{T('All PODs')}</a>

    var downloadShipmentButton =
        <a href={exportXLURL} target="_blank" title={T('DownloadShipmentDataToolTip')} className="btn btn-danger" style={{ "color": "white", "padding": "1px 10px" }}><L>Download Shipment Details</L></a>

    if (this.state.packingListToggleEnabled) {
      var downloadPacklistButton =
        <button type="button" className="btn btn-danger" style={{padding:"1px 10px"}} onClick={this.handleDownloadPacklist}>{T('Packing Lists Direct')}</button>
    } else {
      var downloadPacklistButton =
        <a className={massDLClass} style={{"padding": "1px 10px"}} onClick={this.handleMassDL} title="mass download Packing Lists" name="packing-list">{T('Packing Lists')}</a>
    }


    var shpIcon =
        <a id="shipdrpdwn" role="button" className="ico-container" data-toggle="dropdown" style={iconStyle} href="#" onClick={this.handleShipmentList}>
          <img className="status-ico" height="26" src={this.getVizIcon('shp').type} />
        </a>

    var shpModal =
        <div className="dropdown nav-dropWin">
          {shpIcon}
          <ul id="menushp" className="dropdown-menu pull-right" role="menu" aria-labelledby="shipdrpdwn" style={{"right": "10px"}}>
          <div className="dropInfoWin">
              <div className="modal-header">
                <h4 className="modal-title" style={{ "textAlign": "left"}}>
                  <div className="pull-left"><L>Shipment(s)</L></div>
                  <div id="downloadShipData" className="pull-right">
                      {downloadPODsButton}
                      &nbsp; 
                      {downloadShipmentButton}
                      &nbsp; 
                      {downloadPacklistButton}
                      &nbsp;
                      {/* <Checkbox isEnabled={this.state.packingListToggleEnabled} onChange={this.handlePackingListToggle} /> */}
                  </div>
                </h4>
              </div>
              <div id="shipmentResultMsg"></div>
              <div id="shipmentdet" style={{ margin: "7px", maxHeight: "440px", overflow: "auto"}}></div>
            </div>
          </ul>
        </div>

    // Invoice download
    var invIconStyle = { ...iconStyle, "marginLeft" : "10px" };
    
    var invIcon =
        <a id="invdrop" style={invIconStyle} className="ico-container" role="button" data-toggle="dropdown" href="#" onClick={this.handleOpenInvoiceList}>
          <img className="status-ico" height="32" src={this.getVizIcon('inv').type} />
        </a>

    var invModal =
        <div className="dropdown nav-dropWin">
          {invIcon}
          <ul id="menuinv" className="dropdown-menu pull-right" role="menu" aria-labelledby="invdrop" style={{"right": "67px"}}>
          <div className="dropInfoWin">
              <div className="modal-header">
                <InvoicePopupWrapperClass
                  invStatusinPopup={this.getVizIcon('inv').statusText}
                  handleDownloadAllInvs={this.handleDownloadAllInvs}
                  order={this.props.order} />
              </div>
              <div id="resultMsg"></div>
              <div id="invoice" style={{ "margin": "15px"}}>
              </div>
            </div>
          </ul>
        </div>

    return (
      <div id="statusIcons" style={{'display':'inline', 'paddingBottom': '10px', 'float': 'right'}}>
        <ul style={{"paddingLeft": "unset"}}>
          <li className="statuslabel ico-container">
            <img className="status-ico" height="32" src={this.getVizIcon('credit_status').type} />
            <span style={{'display': 'block'}}><L>{this.getVizIcon('credit_status').statusText}</L></span>
            <span className="status-tooltip">{this.getVizIcon('credit_status').statusText.replace("<br>", " ")}</span></li>
          <li className="statuslabel ico-container">
            <img className="status-ico" height="32" src={this.getVizIcon('changes').type} title={this.getVizIcon('changes').statusText.replace("<br>", " ")} />
            <span style={{'display': 'block'}}><L>{this.getVizIcon('changes').statusText}</L></span>
            <span className="status-tooltip">{this.getVizIcon('changes').statusText.replace("<br>", " ")}</span></li>
          <li className="statuslabel">
            {mfgModal}
            <span><L>{this.getVizIcon('mfg').statusText}</L></span></li>
          <li className="statuslabel">
            {shpModal}
            <span><L>{this.getVizIcon('shp').statusText}</L></span></li>
          <li className="statuslabel">
            {invModal}
            <span><L>{this.getVizIcon('inv').statusText}</L></span></li>
        </ul>
      </div>
    );
  }
}


//----------------------------------------------------------------------
//   StatusGraphic -- show visual quick status / animation
//
//----------------------------------------------------------------------
class StatusGraphic extends React.Component {

  constructor(props) {
    super(props);

    this.handleActiveItemsToggle = this.handleActiveItemsToggle.bind(this);
  }
 
  handleActiveItemsToggle(dataID){
    this.props.activeItemsToggle(dataID)
  }

  render() {

    // SOM orders (Subscription Contract / Solution Quotation): dedicated status flow
    const orderType = this.props.order.order_type;
    if (orderType && orderType.startsWith('SOM-')) {
      const s = this.props.order.order_overall_status;
      const map = OSWidgetLib.getMappingFromStatus_SOM(s);
      var disabledButtons = { "pointerEvents": "none" };

      return (
      // status graphics for SOM Subscription / Solution Quotation orders
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            <StatusElement type={map[0]} dataID="submitted" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="pending"   tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[2]} dataID="active"    tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[3]} dataID="planned"   tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[4]} dataID="canceled"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[5]} dataID="expired"   tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: Status not yet reached</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: Current status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: Status completed</span></li>
            <li><span className="key key-color clr-red">Red</span><span className="val">: Canceled</span></li>
          </ul>
        </div>
      </div>
      );
    }

    // Order Change (ORDCHG): dedicated Submitted -> Completed status flow
    if (orderType === 'ORDCHG') {
      const s = this.props.order.order_overall_status;
      const map = OSWidgetLib.getMappingFromStatus_ORDCHG(s);
      var disabledButtons = { "pointerEvents": "none" };

      return (
      // status graphics for Order Change (ORDCHG) orders
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            {this.props.order.hp_receive_date && <StatusElement type={map[0]} isBookmarkFlag><span title="HPRD" className="viz-flag"><span className="viz-bookmark-lbl lt">{fmDate(this.props.order.hp_receive_date)}</span></span></StatusElement>}
            <StatusElement type={map[0]} dataID="submitted" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="completed" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.order_close_date && <StatusElement type={map[1]} isBookmarkFlag><span title="Change Order Completed" className="viz-flag"><span className="viz-bookmark-lbl">{fmDate(this.props.order.order_close_date)}</span></span></StatusElement>}
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: Status not yet reached</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: Current status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: Status completed</span></li>
          </ul>
        </div>
      </div>
      );
    }

    var s = this.props.order.order_overall_status;
    const tenant = this.props.tenant;
    const serviceType = this.props.order.service_type;

    if (tenant == "HPICS" && isAdvancedExchangeServiceType(serviceType)) {
      var map = OSWidgetLib.getMappingFromStatus_CS_AdvExchange(s);
    } else {
      var map = OSWidgetLib.getMappingFromStatus(s);
    }

    if (tenant == "HPICS" && isAdvancedExchangeServiceType(serviceType)) {
      if(s === "Delivered" &&  this.props.order.pod_date) { map = "SCFFHH"}
    } else {
      if(s === "Delivered" &&  this.props.order.pod_date) { map = "SSSSSSHH"}
    }
    const deliveredDate = this.props.order.pod_date ? fmDate(this.props.order.pod_date) : 'Date: WIP';

    if (isAdvancedExchangeServiceType(serviceType)) {
      // do not change the map for HPICS adv exch flows
    } else {
      // hide consolidation when delivery_type is present in valuesToHideConsolidation array values
      const valuesToHideConsolidation = ['ship as available', 'ship as avail-via fixhubemea', 'ship as avail-via mit_emea'];
      if ((this.props.order.delivery_type)) {
        const delvType = this.props.order.delivery_type.toLowerCase();
        var hideConsolidationFlag = false;
        valuesToHideConsolidation.map((item) => {
          if (delvType.indexOf(item) > -1) {
            hideConsolidationFlag = true;
          }
        })
        if (hideConsolidationFlag) {
          map = map.substr(0, 3) + "H" + map.substr(4);
        }
      }
    }

    // mapping table only checks for order overall status
    // below line just manipulates the map so we can identify a non cancelled order but with cancelled items
    if (this.props.itemGroupsCount.canceled > 0) {
      map = map.replace(/.$/,"A");
    }

    if (this.props.itemGroupsCount.shipmentCanceled > 0) {
      map = map.substring(0, map.length-2) + "A" + map.substring(map.length-1);
    }

    var disabledButtons = { "pointerEvents": "none" };

    if (tenant == "HPICS" && isAdvancedExchangeServiceType(serviceType)) {

      return (      
      // status graphics for HPICS Standard/Advanced Exchange orders  
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            {this.props.order.hp_receive_date && <StatusElement type={map[0]} isBookmarkFlag><span title="HPRD" className="viz-flag" > <span className="viz-bookmark-lbl lt">{fmDate(this.props.order.hp_receive_date)}</span></span></StatusElement>}
            <StatusElement type={map[0]} dataID="processing"        tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="shippedToCustomer" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[2]} dataID="awaitingReturn"    tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[3]} dataID="received"          tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[4]} dataID="shipmentCanceled"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[5]} dataID="canceled"          tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: No item in this status</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: At least 1 item in this status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: All items have moved past this status</span></li>
            <li><span className="key key-color clr-red">Red</span><span className="val">: Some items are cancelled</span></li>
            <li><span className="key ico-status-legend ico-credit-approved"></span><span className="val">: Credit status</span></li>
            <li><span className="key ico-status-legend ico-locked"></span><span className="val">: Changes status</span></li>
            <li><span className="key ico-status-legend ico-mfg"></span><span className="val">: Mfg Date</span></li>
            <li><span className="key ico-status-legend ico-not-invoiced"></span><span className="val">: Invoiced status</span></li>
          </ul>
        </div>
      </div>
      );

    } else {

      return (
      // status graphics for non HPICS Standard/Advanced Exchange orders  
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            {this.props.order.hp_receive_date && <StatusElement type={map[0]} isBookmarkFlag><span title="HPRD" className="viz-flag" > <span className="viz-bookmark-lbl lt">{fmDate(this.props.order.hp_receive_date)}</span></span></StatusElement>}
            <StatusElement type={map[0]} dataID="submitted" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="accepted"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.clean_order_date && <StatusElement type={map[1]} isBookmarkFlag><span title="Complete Order Clean date" className="viz-flag" > <span className="viz-bookmark-lbl">{fmDate(this.props.order.clean_order_date)}</span></span></StatusElement>}
            {tenant !== 'HPICS' && (
              <StatusElement type={map[2]} dataID="production" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />)
            }
            {tenant === 'HPICS' && (
              <StatusElement type={map[2]} dataID="shipmentScheduled" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />)
            }
            <StatusElement type={map[3]} dataID="consolidation"     tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[4]} dataID="shippedToCustomer" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.customer_ship_date && <StatusElement type={map[4]} isBookmarkFlag><span title="Complete Order Ship date" className="viz-flag" > <span className="viz-bookmark-lbl">{fmDate(this.props.order.customer_ship_date)}</span></span></StatusElement>}
            <StatusElement type={map[5]} dataID="delivered"         tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.pod_date && <StatusElement type={map[5]} isBookmarkFlag><span title="Complete Order Delivered" className="viz-flag" > <span className="viz-bookmark-lbl">{deliveredDate}</span></span></StatusElement>}
            <StatusElement type={map[6]} dataID="shipmentCanceled"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons}/>
            <StatusElement type={map[7]} dataID="canceled"          tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons}/>
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: No item in this status</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: At least 1 item in this status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: All items have moved past this status</span></li>
            <li><span className="key key-color clr-red">Red</span><span className="val">: Some items are cancelled</span></li>
            <li><span className="key ico-status-legend ico-credit-approved"></span><span className="val">: Credit status</span></li>
            <li><span className="key ico-status-legend ico-locked"></span><span className="val">: Changes status</span></li>
            <li><span className="key ico-status-legend ico-mfg"></span><span className="val">: Mfg Date</span></li>
            <li><span className="key ico-status-legend ico-not-invoiced"></span><span className="val">: Invoiced status</span></li>
          </ul>
        </div>
        {
          this.props.order.order_type_descr == "Trade Order" && <OSSAIPersonaModal order={this.props.order} />
        }
      </div>
      );
    }

  }
};



class MfgPopupWrapperClass extends React.Component {

  constructor(props) {
    super(props);
    this.handleDownloadMfgData = this.handleDownloadMfgData.bind(this); 
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.order.legacy_order_no != nextProps.order.legacy_order_no) {
    }
    return true;
  }

  handleDownloadMfgData() {

    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    if (sfdcSession) {
      param = '&sfdcSession='+sfdcSession
    }

    var prefix = '';
    if (window.mobileMode) {
        prefix = '/ext';
    }    
    window.open (RewriteRESTURL(prefix+"/os/ossui/v1/in/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
  }

  render() {

    var prefix = '';
    if (window.mobileMode) {
        prefix = '/ext';
    }
    var exportXLURL = RewriteRESTURL(prefix+"/os/ossui/v1/in/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale);
    if (sfdcSession) {
      var exportXLURL = prefix + "/os/ossui/v1/in/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale
                      + "?sfdcSession="+ sfdcSession;
    }

    var downloadMFGButton1 = 
            <button type="button" className="btn btn-danger" onClick={this.handleDownloadMfgData}>
              <L>Download all Item details</L>
            </button>;

    var downloadMFGButton =
      <a href={exportXLURL} target="_blank" title={T('DownloadManufacturingDataToolTip')} className="btn btn-danger" style={{ "color": "white"}}><L>Download Manufacturing Details</L></a>

    return (
      <h4 key="MfgPopupWrapperClass" className="modal-title" style={{ "textAlign": "left"}}>
        <div className="pull-left"><L>Manufacturing Data</L></div>
        <div id="downloadMfgData" className="pull-right">
        {downloadMFGButton}
        </div>
      </h4>
    );
  }
};

class InvoicePopupWrapperClass extends React.Component {

//GEGA TODO, shouldComponentUpdate needed? download button never shows up?!

/*  getInitialState() {
    this.checkInvoiceSetup(this.props.order.legacy_order_no);
    return {displayOption: "none"};
  }*/
  constructor(props) {
    super(props);
    this.state = {
      displayOption: "none"
    };
    this.checkInvoiceSetup = this.checkInvoiceSetup.bind(this);
    //this.handleDownloadAllInvs = this.handleDownloadAllInvs.bind(this);
  }

  checkInvoiceSetup (legacyOrderNo) {
    var cb = function (res) {
      var displayOptionValue;      
      try {
        if (res.status !== 'N') {
          displayOptionValue =
            !res.data.isAPJ ?
              "block" :
              (res.data.setups && res.data.setups.length > 0 ? "block" : "block")
        } else {
          displayOptionValue="block";
        }
      } catch (e) {
        displayOptionValue="block";
      }
      this.setState({displayOption:displayOptionValue});
    }.bind(this);

     if(document.querySelector('.mobile-app')){
      //  if mobile
      GET( process.env.REACT_APP_API_URL + "v1/in/getAPJOrderInvoicePDFSetup/"+legacyOrderNo, "", cb);
     } else {
      GET("/os/ossui/v1/in/getAPJOrderInvoicePDFSetup/"+legacyOrderNo, "", cb);
     }
  }

  /*  GEGA instead use componentDidMount 
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.order.legacy_order_no != nextProps.order.legacy_order_no) {
      this.checkInvoiceSetup(nextProps.order.legacy_order_no);
    }
    return true;
  }*/

  componentDidMount() {
    this.checkInvoiceSetup(this.props.order.legacy_order_no);
  }

  render() {

    var pat = new RegExp("QAD-.*");

    if (pat.test(this.props.order.data_source)) {
      this.state = {
        displayOption: "none"
      };
    }

    var disableDownloadButton = false;
    if (!UserSettings.memberOf('ShowRestrictedFields') || !UserSettings.isValidAcv(this.props.order.acv, '300') || window.mobileMode) {
      disableDownloadButton = true;
    }

    return (
      <h4 key="InvoicePopupWrapperClass" className="modal-title" style={{ "textAlign": "left"}}>
        <div className="pull-left">{T('Invoice(s)')}&nbsp; {T(this.props.invStatusinPopup)}</div>
        <div className="pull-left">{T('for') + " " + T('Order') + " " + this.props.order.order_no}</div>
        <div id="downloadAllInvs" className="pull-right">
           <button type="button" className="btn btn-danger" style={{display: this.state.displayOption}} onClick={this.props.handleDownloadAllInvs.bind(this)} disabled={disableDownloadButton} >
            {T('Download all Invoices')}
           </button>
        </div>
      </h4>
    );
  }
};



//----------------------------------------------------------------------
//   lite widget sales conract tab --
//                     shows header level Sales Contract and 
//                     Master Sales Contract  information
//
//----------------------------------------------------------------------

export class SalesContract extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    var order = this.props.order;

    return (
      <div className="hdrGridContainer">
        <table  className="hdrGrid">
          <thead>
          <tr>
              <th className="hdrGridSeparator" colSpan="6" 
                  style={{ backgroundColor:"#0096d6", color: "#fff"}}>{T('Sales Contract Attributes')}</th>
          </tr>
          </thead>
          <tbody>
            <tr>
                <th><DDLabel field={DD('contract_no', 'int_widget')} /> / <DDLabel field={DD('sc_cbn', 'int_widget')} /></th> <td>{order.contract_no} / {order.sc_cbn}</td>
                <th><DDLabel field={DD('sc_start_date', 'int_widget')} /> / <DDLabel field={DD('sc_end_date', 'int_widget')} /></th> <td>{fmDate(order.sc_start_date)} / {fmDate(order.sc_end_date)}</td>
                <th><DDLabel field={DD('sc_fulfillment_site_id', 'int_widget', 'right')} /> </th> <td>{order.sc_fulfillment_site_id}</td>
            </tr>
            <tr>
                <th><DDLabel field={DD('sc_smart_po', 'int_widget')} /> </th> <td>{order.sc_smart_po}</td>
                <th><DDLabel field={DD('sc_invoice_layout', 'int_widget')} /> </th> <td>{order.sc_invoice_layout}</td>
                <th><DDLabel field={DD('sc_global_network_mgmr', 'int_widget', 'right')} /> </th> <td>{order.sc_global_network_mgmr}</td>
            </tr>
            <tr>
                <th><DDLabel field={DD('sc_leasing_type', 'int_widget')} /> </th> <td>{order.sc_leasing_type}</td>
                <th><DDLabel field={DD('sal_number', 'int_widget')} /> </th> <td>{order.sc_shipment_auth_letter}</td>
                <th><DDLabel field={DD('sc_ship_to_overwrite', 'int_widget', 'right')} /> </th> <td>{order.sc_ship_to_overwrite}</td>
            </tr>
          </tbody>

          <thead>
          <tr>
              <th className="hdrGridSeparator" colSpan="6" 
                  style={{backgroundColor:"#0096d6", color: "#fff"}}>{T('Master Sales Contract Attributes')}</th>
          </tr>
          </thead>

          <tbody>
            <tr>
              <th><DDLabel field={DD('contract_master_no', 'int_widget')} /> </th> <td>{order.contract_master_no}</td>
              <th><DDLabel field={DD('contract_master_name', 'int_widget')} /> </th> <td>{order.contract_master_name}</td>
              <th><DDLabel field={DD('msc_sla_type', 'int_widget', 'right')} /> </th> <td>{order.msc_sla_type}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('purch_order_type', 'int_widget')} /> </th> <td>{order.msc_purch_order_type}</td>
              <th><DDLabel field={DD('business_type', 'int_widget')} /> </th> <td>{order.msc_type_of_business}</td>
              <th><DDLabel field={DD('msc_opgs', 'int_widget', 'right')} /> </th> <td>{order.msc_opgs}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('deal_geo_scope', 'int_widget')} /> </th> <td>{order.msc_deal_geo_scope}</td>
              <th><DDLabel field={DD('msc_lead_market', 'int_widget')} /> </th> <td>{order.msc_lead_market}</td>
              <th><DDLabel field={DD('msc_partner_comp_excl', 'int_widget', 'right')} /> </th> <td>{order.msc_partner_comp_excl}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('msc_do_not_use', 'int_widget')} /> </th> <td>{order.msc_do_not_use}</td>
              <th><DDLabel field={DD('vals_foc_approval', 'int_widget')} /> </th> <td>{order.msc_vals_foc_approval}</td>
              <th><DDLabel field={DD('msc_non_std_sla_approval', 'int_widget', 'right')} /> </th> <td>{order.msc_non_std_sla_approval}</td>
            </tr> 
          </tbody>
        </table>
      </div>
    )
  }

};


//----------------------------------------------------------------------
//   HeaderTabs --
//
//----------------------------------------------------------------------
class HeaderTabs extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      render: {
        orderAnalysis: false
      }
    };
  }

  handleReleaseHdrBlock ( order, item_no, exceptionArea, exception ) {

    console.log('handleReleaseHdrBlock:', order.legacy_order_no, item_no, exceptionArea, exception );

    $('#remblockModal').modal('hide');

    ReactDOM.render(
      <ModalWidgetWaiting
        size={"small"}/>
      , document.getElementById('remblockbody')
    );

    $('#doneRemovingBlock').hide();
    if (exceptionArea == "billing") {
        $('#removingBlock').text('Removing billing block '+ exception.code);
    } else
    if (exceptionArea == "delivery") {
        $('#removingBlock').text('Removing delivery block '+ exception.code);
    } else {
        $('#removingBlock').text('Removing header user status block '+exception.code);
    }
    $('#spinningIconRemoveBlock').show();

    POST("/os/ossui/v1/in/removeBlock", {

      legacy_order_no: order.legacy_order_no, 
      sap_system:      order.om_system, 
      so_no:           order.so_no, 
      item_no:         item_no, 
      exceptionArea:   exceptionArea,
      exceptionType:   exception.type,
      block:           exception.code

    }, function (resp) {
        $('#spinningIconRemoveBlock').hide();
        $('#doneRemovingBlock').show();
        console.log(resp);
        if (resp && resp.stdout && resp.stdout != "") {
            $('#doneRemovingBlock').text(resp.stdout);
        } else {
            $('#doneRemovingBlock').text('Done!');
        }
        $('#spinningIconRefreshingOrder').show();
    });

    setTimeout( function() {
        $('#spinningIconRefreshingOrder').hide();
    }, 7000);
      
    $('#remblockModal').modal( { backdrop: 'static'} );
  }

  handleReprocessOIS ( order) { 
      console.log('handleReprocessOIS', order);
      $('#reprocessOISModal').modal( { backdrop: 'static'} );

      $('#reprocessOISResult').hide();
      $('#reprocessOISAwait').show();

      POST("/os/ossui/v1/in/reprocessOIS", {

          legacy_order_no: order.legacy_order_no,
          ois_id:          order.b2bis_id

      }, function (resp) {
          $('#reprocessOISAwait').hide();
          $('#reprocessOISResult').show();
          console.log(resp);
          if (resp && resp.stdout && resp.stdout != "") {
              $('#reprocessOISResult').text(resp.stdout);
          } else {
              $('#reprocessOISResult').text('Reprocessing triggered successful !');
          }

      }, function (err, responseText , originalResponseText) {
          var errorPayload = JSON.parse(originalResponseText);
          if ( errorPayload.message.substring(0,34) == 'javax.naming.CommunicationException' ) {
            errorPayload.message = 'LDAP authentication is currently unavailable, please try again later!';
          }
          $('#reprocessOISAwait').hide();
          $('#reprocessOISResult').show();
          $('#reprocessOISResult').text("Error: " + errorPayload.message);
      });
  }


  handleCancelOIS ( order ) {
      console.log('handleCancelOIS', order);
      $('#cancelOISModal').modal( { backdrop: 'static'} );

      $('#cancelOISResult').hide();
      $('#cancelOISAwait').show();

      POST("/os/ossui/v1/in/cancelOIS", {

          legacy_order_no: order.legacy_order_no,
          ois_id:          order.b2bis_id

      }, function (resp) {
          $('#cancelOISAwait').hide();
          $('#cancelOISResult').show();
          console.log(resp);
          if (resp && resp.stdout && resp.stdout != "") {
              $('#cancelOISResult').text(resp.stdout);
          } else {
              $('#cancelOISResult').text('Cancelation triggered successful !');
          }

      }, function (err, responseText , originalResponseText) {
          var errorPayload = JSON.parse(originalResponseText);
          $('#cancelOISAwait').hide();
          $('#cancelOISResult').show();
          $('#cancelOISResult').text("Error: " + errorPayload.message);
      });
  }

  handleByPass ( order ) {
    console.log('handleByPass', order);
    $('#byPassOISModal').modal( { backdrop: 'static'} );

    $('#byPassOISResult').hide();
    $('#byPassOISAwait').show();


    POST("/os/ossui/v1/in/byPassSimulation", {

      legacy_order_no: order.legacy_order_no,
      ois_id:          order.b2bis_id

    }, function (resp) {
          $('#byPassOISAwait').hide();
          $('#byPassOISResult').show();
          console.log(resp);
          if (resp && resp.stdout && resp.stdout != "") {
              $('#byPassOISResult').text(resp.stdout);
          } else {
              $('#byPassOISResult').text('OIS ByPass triggered successful !');
          }

      }, function (err, responseText , originalResponseText) {
          var errorPayload = JSON.parse(originalResponseText);
          $('#byPassOISAwait').hide();
          $('#byPassOISResult').show();
          $('#byPassOISResult').text("Error: " + errorPayload.message);
      });
  }


  handleReprocessIDOC ( order, sap_system, idocNr ) {

    console.log('handleReprocessIDOC:', order.legacy_order_no, idocNr );

    $('#reprocessIdocModal').modal( { backdrop: 'static'} );

    $('#reprocessIdocResult').hide();
    $('#reprocessIdocAwait').show();


    POST("/os/ossui/v1/in/retriggerIDOC", {

      legacy_order_no: order.legacy_order_no,
      sap_system:      sap_system,
      idoc_no:         idocNr

    }, function (resp) {
        $('#reprocessIdocAwait').hide();
        $('#reprocessIdocResult').show();
        console.log(resp);
        if (resp && resp.stdout && resp.stdout != "") {
            $('#reprocessIdocResult').text(resp.stdout);
        } else {
            $('#reprocessIdocResult').text('Triggered!');
        }

    }, function (err) {
        $('#reprocessIdocAwait').hide();
        $('#reprocessIdocResult').show();
        $('#reprocessIdocResult').text(err);
    });

  }
  
  handleAddHeaderUserStatus (order) {
      console.log("handleAddHeaderUserStatus: ", order);
      $('#addHeaderUserStatusErrorText').text("");
      $('#addHeaderUserStatus').modal( { backdrop: 'static'} );
  }

  render() {

    var self = this;
    var order = this.props.order;
    var render = this.state.render;

    var labelGridDataOrderDetail = [
          [ DD('account_name',      'int_widget')      , order.account_name,
            DD('quote_no',          'int_widget')      , order.quote_no,
            DD('total_price',       'int_widget',   'right')    , fmNum(order.total_price)+' '+order.currency
          ],

          [ DD('customer_name',     'int_widget')      , order.customer_name,
            DD('customer_no',       'int_widget')      , order.customer_no,
            DD('customer_req_date', 'int_widget',     'right')   , fmDate(order.customer_req_date),
          ],

          [ DD('top_st_name',       'int_widget')      , order.top_st_name,
            DD('contract_no',       'int_widget')      , order.contract_no,
            DD('customer_segment', 'int_widget',      'right')   , order.customer_segement
          ],

          [ DD('order_type_descr',  'int_widget')      , order.order_type_descr,
            DD('web_order_no',      'int_widget')      , order.web_order_no,
            DD('program_type',      'int_widget',     'right')   , order.program_type,
          ],

          [ "", "",
            DD('end_customer_po_no','int_widget')      , order.end_customer_po_no,
            "", "",
          ]
    ];

    var labelGridNotificationDetail = [
          [ T('Notification Type')             , order.sn_type,
            T('Entitlement OTC Code')          , order.entitlement_code,
            T('Service Product Number')        , order.sn_material_no,
          ],

          [ T('Service Offer Id')              , order.service_offer_id,
            T('Entitlement Status')            , order.entitlement_status,
            T('Service Product Serial Number') , order.sn_serial_number,
          ],

          [ T('Service Type Group')            , order.case_type,
            T('Entitlement Override reason')   , order.entitlement_override_reason,
            T('Case Type')                     , order.case_type
          ]
    ];

    /*----------------------------------------------------------------------------
    |   comments & dates Tab
    \---------------------------------------------------------------------------*/
    var comments = this.props.order.comments;
    if (!comments) comments = [];
    var labelGridDataComments = [];
    for (var i = 0; i < comments.length; i++) {
      labelGridDataComments.push(
        [ comments[i].key == "" ? T('Comment') : comments[i].key ,
          comments[i].value
        ]
      );
    }

    console.log('order.customer_notes:', order.customer_notes);
    if (order.customer_notes && order.customer_notes != "") {
      var subject = "HP Notes for HP Order: "+order.order_no+"; Purchase Order: "+order.purchase_order_no;
      var body    = "HP Order: "+order.order_no+"; Purchase Order: "+order.purchase_order_no
                  + "%0D%0A"
                  + "%0D%0A"
                  + "HP Notes"
                  + "%0D%0A"
                  + order.customer_notes.replace(/\\n/g,"%0D%0A")
                  + "%0D%0A"
                  + "%0D%0A"
                  + "Last Updated On: " + fmDate(order.customer_notes_lupd)

      var mailLink = "?subject=" + subject + "&body=" + body;

      var hpnotesLabel =
         <span>
            <b><L>HP Notes</L></b>&nbsp;&nbsp;<a href={"mailto:"+mailLink}><b><i className="glyphicon glyphicon-edit"/>&nbsp;Email</b></a>
            <br/>
            <span style={{"fontSize":"11px"}}><L>last updated on </L>{fmDate(order.customer_notes_lupd)}</span>
         </span>
      var s = order.customer_notes.split('\\n');
      if (s.length < 2) {
        labelGridDataComments.unshift( [ hpnotesLabel, order.customer_notes ] );
      } else {
        var lines = [ s[0] ];
        for (var i=1; i<s.length; i++) {
          lines.push( React.createFactory('br') );
          lines.push( s[i] );
        }
        labelGridDataComments.unshift( [ hpnotesLabel, lines ] );
      }
    }

    var commentsTab = "";

    if (labelGridDataComments.length != 0) {
      commentsTab =
        <Tab name="commentsTab" label={T('Comments')}>
           <LabelGrid data={labelGridDataComments} />
        </Tab>
      ;
    }

    /*----------------------------------------------------------------------------
    |   moreInfo & exceptions/additional info Tab
    \---------------------------------------------------------------------------*/
    // build More Info tab and exceptions/additional info
    var exceptions = this.props.order.exceptions;

    var labelGridDataMoreInfo = [
          [ DD('gvt_contract_number',       'int_widget')          , order.gvt_contract_number == "" ? order.purch_agree : order.purch_agree + ' / ' + order.gvt_contract_number,
            DD('purch_agent',               'int_widget')          , order.purch_agent_email,
            DD('payment_terms',             'int_widget',  'right'), order.payment_term_text,
          ],
          [ DD('agent_id',                  'int_widget')          , order.agent_id,
            DD('big_deal_id',               'int_widget')          , order.big_deal_id,
            DD('inco_terms',                'int_widget',  'right'), order.inco_terms,
          ],
          [ DD('sales_market',              'int_widget')          , order.sales_market,
            DD('account_service_level',     'int_widget')          , order.account_service_level,
            DD('partner_pro_id',            'int_widget',  'right'), order.partner_pro_id
          ]
    ];

    var moreInfoLabel = (
       <span>
         <L>More Info</L>
       </span>
    );    

    var moreInfoTab = "";

    if (labelGridDataMoreInfo != "") {
      moreInfoTab =
        <Tab name="moreInfoTab" label={moreInfoLabel}>
           <LabelGrid data={labelGridDataMoreInfo} />
        </Tab>
      ;
    }

    var datesTab = (
      <Tab name="dates" label={T('Dates')}>
        <Dates order={order} caller='int_widget' />
      </Tab>
    );

    var hpContacts = (
      <Tab name="hpContacts" label={T('HP Contacts')}>
        <HPContacts order={order} caller='int_widget' />
      </Tab>
    );

    /*----------------------------------------------------------------------------
    |   Order Analysis Tab
    \---------------------------------------------------------------------------*/
    var hOrderAnalysisTab = null;

    if (order.tenant === "HPI" && order.order_type_descr === "Trade Order" && order.order_status === "OPEN"
        && !(UserSettings?.config?.GenAICfg?.disable_ottoV2 === true)) {
      var oAColorMap = { LOW: "green", MEDIUM: "yellow", HIGH: "red", CRITICAL: "red" };
      var oABadgeColor = this.props.orderAnalysis?.[0]?.[4] ? oAColorMap[this.props.orderAnalysis[0][4]] : "";
      var oABadgeValue = this.props.orderAnalysis?.[0]?.[8] ? this.props.orderAnalysis[0][8] : "";

      hOrderAnalysisTab = (
        <Tab name="hOrderAnalysis" label={<><ChatbotSandy fill="currentColor" stroke="currentColor" style={{width: "14px", height: "14px", verticalAlign: "middle"}} /> Order Analysis</>} onClick={()=>this.setState(prevState=>({render:{...prevState.render, orderAnalysis: true}}))} badgeColor={oABadgeColor} amount={oABadgeValue} >
          {render.orderAnalysis && <HOrderAnalysis order={order} updateOrderAnalysis={this.props.updateOrderAnalysis} caller="int_widget" />}
        </Tab>
      );
    }

    /*----------------------------------------------------------------------------
    |   cases Tab
    \---------------------------------------------------------------------------*/
    var casesTab = "";

    if (order.cases && order.cases.length > 0) {
      var casesLabel = (
        <span>
          <L>Cases</L>
          &nbsp;
          <div className="badge badge-red">{order.cases.length}</div>
        </span>
      ); 
      var casesList = order.cases.map( (caseEntry) => {
          if (typeof GlobalUserSettings != 'undefined') { 
              UserSettings.config = GlobalUserSettings.config;
          }
          UserSettings.config = (!UserSettings.config || !UserSettings.config.links) ? this.props.userSettings.config : UserSettings.config;
          var deepLink3W = UserSettings.config.links.MSDyn3WDeepLink + "&id=" + caseEntry.case_instance_id + "&pagetype=entityrecord&etn=incident";
          var CaseViewer3wLink = get3wViewerLink(UserSettings.config.links.SfdcWorkflowServiceUrl, caseEntry.case_instance_id);
          var selfServicePortal3W = UserSettings.config.links.SelfServicePortal3W + "?id=" + caseEntry.case_instance_id;

          return (<tr>
                    <td style={{whiteSpace: "nowrap"}}>
                      {
                        UserSettings.user_id && window.SCCPUsers3W?.includes(UserSettings.user_id)
                          ? (
                              <a href={selfServicePortal3W} target="_blank">
                                <i title="Open in 3W Collaboration Portal (license not required)" className="glyphicon glyphicon-new-window" style={{color: '#0096d6', padding: '1px', verticalAlign: 'text-top', marginRight: '5px'}} />
                              </a>
                            )
                          : (
                              <i title="Open in 3W Collaboration Portal (license not required)" className="glyphicon glyphicon-new-window" style={{color: '#bbbbbb', padding: '1px', verticalAlign: 'text-top', marginRight: '5px'}} />
                            )
                      }
                      <a href={deepLink3W} target="_blank" title="Open in 3W (license required)">{caseEntry.case_number}</a>
                    </td>
                    <td>{caseEntry.case_request_source}</td> 
                    <td>{caseEntry.case_status} &nbsp; {caseEntry.case_instructions != "" ? (<img id="caseOutcomeLogo" title= {caseEntry.case_instructions} src = {case_outcomeLogo} height="10" width = "10" />) : ""}</td>  
                    <td>{caseEntry.case_category}</td>  
                    <td>{caseEntry.case_subcategory}</td>  
                    <td>{caseEntry.case_l3category}</td>
                    <td>{caseEntry.case_requestor_email}</td>
                    <td>{caseEntry.case_assigned_to}</td>  
                    <td>{caseEntry.case_aquired_by}</td>  
                    <td>{fmDateTime(caseEntry.case_update_date)}</td>
                    <td>{caseEntry.case_parent_id}</td>
                    <td>{caseEntry.case_description}</td>
                    <td>{caseEntry.case_priority_code}</td>
                    <td>{caseEntry.case_material_no}</td>
                    <td>{fmDateTime(caseEntry.case_resolve_by)}</td>
                  </tr>
                 );   
      });   
      casesTab =
        <Tab name="casesTab" label={casesLabel}>
           <table className="table table-hover">
             <thead>
               <tr>
                 <th><L>Case Number</L></th>
                 <th><L>Request Source</L></th>
                 <th><L>Case Status</L></th>
                 <th><L>Case L1 Category</L></th>
                 <th><L>Case L2 Category</L></th>
                 <th><L>Case L3 Category</L></th>
                 <th><L>Requestor Email</L></th>
                 <th><L>Assigned To</L></th>
                 <th><L>Acquired By</L></th>
                 <th><L>Updated At</L></th>
                 <th><L>Parent Case</L></th>
                 <th><L>Description</L></th>
                 <th><L>Priority</L></th>
                 <th><L>Material No</L></th>
                 <th><L>Resolve by</L></th>
               </tr>
             </thead>
             <tbody>
               {casesList}
             </tbody>
           </table>
        </Tab>
      ;
    }

    /*----------------------------------------------------------------------------
    |   claims Tab
    \---------------------------------------------------------------------------*/
    var claimsTab = "";

    var system = ""
    if (window.location.host.charAt(3) == "-" ) {
      system = window.location.host.substring(3, 7); 
    }

    if (order.claims && order.claims.length > 0) {
      var claimsLabel = (
        <span>
          <L>Claims</L>
          &nbsp;
          <div className="badge badge-red">{order.claims.length}</div>
        </span>
      ); 
      var claimsList = order.claims.map( (claimEntry) => {

          var cLen = claimEntry.claim_id.length;
          var eClaimsURL = "https://eclaims" + system + ".corp.hp.com/eClaims/app?component=searchResultTable.claimIdLinkFromWorkList3&page=SearchClaimsResult&service=direct&session=T&sp=SE-" + claimEntry.claim_id.substring(3,cLen) + "&sp=l" + claimEntry.claim_id.substring(7,cLen);

          return (<tr>
                    <td nowrap><a href={eClaimsURL} target="_blank">{claimEntry.claim_id}</a></td>
                    <td>{claimEntry.claim_type}</td> 
                    <td style={{textAlign: "right"}}>{fmDate(claimEntry.claim_date)}</td>
                    <td>{claimEntry.current_process}</td>
                    <td>{claimEntry.claim_status}</td>
                    <td>{claimEntry.created_by}</td>
                    <td style={{textAlign: "right"}}>{fmNum(claimEntry.total_net_price)} {claimEntry.currency}</td>
                    <td>{claimEntry.invoice_number}</td>
                    <td style={{textAlign: "right"}}>{fmDate(claimEntry.earliest_pickup_date)}</td>
                    <td style={{textAlign: "right"}}>{fmDate(claimEntry.actual_pickup_date)}</td>
                  </tr>
                 );   
      });   
      claimsTab =
        <Tab name="claimsTab" label={claimsLabel}>
           <table className="table table-hover">
             <thead>
               <tr>
                 <th><L>Claim No</L></th>
                 <th><L>Type</L></th>
                 <th><L>Creation Date</L></th>
                 <th><L>Current Process</L></th>
                 <th><L>Status</L></th>
                 <th><L>Created By</L></th>
                 <th><L>Amount</L></th>
                 <th><L>Original Invoice</L></th>
                 <th><L>Earliest Pickup Date</L></th>
                 <th><L>Actual Pickup Date</L></th>
               </tr>
             </thead>
             <tbody>
               {claimsList}
             </tbody>
           </table>
        </Tab>
      ;
    }

    /*----------------------------------------------------------------------------
    |   fallouts Tab
    \---------------------------------------------------------------------------*/
    var falloutsTab = "";

    if (order.fallouts && order.fallouts.length > 0) {

      var oef = order.fallouts;
      var falloutsLabel = (
        <span>
          <L>Fallouts</L>
          &nbsp;
          <div className="badge badge-red">{oef.length}</div>
        </span>
      ); 

      var falloutsList = order.fallouts.map( function(falloutline) {
          var ref = falloutline.ref; 
          if (falloutline.source == "SAP-SCP" 
              && 
              UserSettings.memberOf('Q2C_OSS_REPROCESS_IDOC')
          ) {
             var cb = self.handleReprocessIDOC.bind(null, order, falloutline.source, falloutline.ref);
             ref = <span>
                     {falloutline.ref} 
                     <button  type="button" className="btn btn-sm btn-danger" style={{ marginLeft: '10px', padding: '2px 5px', 'line-height':'1.0' }} 
                         onClick={cb}> re-process IDOC</button>
                   </span>;
          }
   
          return (<tr>
                    <td>{ref}</td>  
                    <td>{falloutline.code}</td>  
                    <td>{falloutline.text}</td>  
                    <td>{fmDate(falloutline.date)}</td>  
                  </tr>
                 );   
      });
      
      falloutsTab =
        <Tab name="falloutsTab" label={falloutsLabel}>
           <table className="table table-hover">
             <thead>
               <tr>
                 <th><L>Doc Reference</L></th>
                 <th><L>Fallout Code</L></th>
                 <th><L>Fallout Text</L></th>
                 <th><L>Date</L></th>
               </tr>
             </thead>
             <tbody>
               {falloutsList}
             </tbody>
           </table>
        </Tab>
      ;
    } else {

        /*-- check for OIS errors and treat them as fallouts --*/

       if (order.om_system == "ois") {
          var reprocessOIS = null;
          var cancelInOIS  = null;
          var rejectDR     = null;

          if (UserSettings.memberOf('FalloutUser')
          ) {
             var cb_ois_reprocesses = self.handleReprocessOIS.bind(null, order);
             var cb_ois_cancel      = self.handleCancelOIS.bind(null, order);

             reprocessOIS = <button type="button" className="btn btn-sm btn-danger" style={{ marginLeft: '10px', padding: '2px 5px', 'line-height':'1.0' }} 
                                     onClick={cb_ois_reprocesses}> Re-Process in OIS</button>
             cancelInOIS  = <button type="button" className="btn btn-sm btn-danger" style={{ marginLeft: '10px', padding: '2px 5px', 'line-height':'1.0' }} 
                                     onClick={cb_ois_cancel}> Cancel in OIS</button>
          }
          if (order.order_type_descr == "NGENR DeliveryRequest") {
             rejectDR  = <a href={"/os/DeliveryRequestStatusUpdate?ois_id="+order.order_no} target="_blank" type="button" className="btn btn-sm btn-danger" 
                             style={{ marginLeft: '10px', padding: '2px 5px', 'line-height':'1.0', textDecoration: "none" }}
                         >
                           Reject GOMO Delivery Request
                        </a>
          }
   
          var oisBlocks = 0;
          var hardReject       = false ,
            softReject         = false ,
            byPassSimulation   = null  ;

          for (var code in exceptions.othersys) {
              if (exceptions.othersys[code]["OIS"]) {   
                  if (   exceptions.othersys[code]["OIS"].cat != "info"
                      && exceptions.othersys[code]["OIS"].cat != "hide"
                  ) {
                      oisBlocks++;
                      if(/^(OIS-SIMH-)/.test(code)) hardReject = true ;
                      else if(/^OIS-SIMS-/.test(code)) softReject = true ;
                  }
              }
          }
          if (!hardReject && !softReject) {
            for( var iitem of order.items ) {
              if( iitem.exceptions && iitem.exceptions.item ) {
                for (var code in iitem.exceptions.item) {
                  if(   /^OIS-SIMS-/.test(code)
                    && iitem.exceptions.item[code].cat != "info"
                    && iitem.exceptions.item[code].cat != "hide" ) { softReject = true ;break ; }
                }
              }
            }
          }

          if( !hardReject && softReject && UserSettings.memberOf('FalloutUser') ) {
              var cb_bypass    = self.handleByPass.bind(null, order);
              byPassSimulation = <button type="button" className="btn btn-sm btn-danger"  style={{ marginLeft: '10px', padding: '2px 5px', 'line-height':'1.0' }}
                                  onClick={cb_bypass}> Bypass Simulation </button>
          }
          if ( order.order_overall_status
            && order.order_overall_status == "Submitted" ) {
              var falloutsLabel = (
                <span>
                  <L>Fallouts</L>
                  &nbsp;
                  <div className="badge badge-red">{1}</div>
                </span>
              ); 

              falloutsTab =
                <Tab name="falloutsTab" label={falloutsLabel}>
                 <table className="hdrGrid">
                   <tbody>
                     <tr>
                       <td>OIS fallout / block details:</td>
                       <td style={{ width: "90%" }}>{fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "hdr", exceptions, "othersys", "", "", "", cbReleaseHdrBlock, order, 0, order.om_system ))}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>
                        OIS ID {order.b2bis_id}:  {reprocessOIS} &nbsp;&nbsp;&nbsp;&nbsp; {cancelInOIS} &nbsp;&nbsp;&nbsp; {rejectDR} &nbsp;&nbsp;&nbsp;&nbsp; {byPassSimulation}
                      </td>
                    </tr>
                   </tbody>
                 </table>
                </Tab>
           }
       }
    }

    var nrHdrBlocks = OSWidgetLib.countHeaderBlocks(order.exceptions);

    if ( nrHdrBlocks > 0) {
      var hdrStatusLabel = (
       <span>
         <L>Header Status</L>
         <div className="badge badge-red">{nrHdrBlocks}</div>
       </span>
     );    
    } else {
      var hdrStatusLabel = (
       <span>
         <L>Header Status</L>
       </span>
     );    
    }

    var cbReleaseHdrBlock = null;
    if (UserSettings.memberOf("RemoveBlocks") || order.hp_contact == UserSettings.user_id) {
      cbReleaseHdrBlock = self.handleReleaseHdrBlock;
    }

    var activeNotification = true;
    var activeTabCS = true;
    var activeTab = true;

    if ( UserSettings.tenant != "HPICS" ) {
      activeNotification = false;
      activeTabCS = false;
    } else {
      if ( order.sn_no == '' ) {
        activeNotification = false;
        activeTabCS = false;
        activeTab = true;  
      } else {
        activeTab = false;
      }
    }

    var addUserStatus = null;

    if (UserSettings.memberOf("RemoveBlocks") || order.hp_contact == UserSettings.user_id) {

        var addUserStatusClick = self.handleAddHeaderUserStatus.bind(null, order);

        addUserStatus = <i className="glyphicon glyphicon-plus" 
                           title="add an user status" 
                           onClick={addUserStatusClick}
                           style={{ color: "#c1401a"}}
                        />
    }

    var renderInlineTaxDetails = function(taxDetails) {
      if (!taxDetails) {
        return null;
      }
      return (
        <div style={{marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #ddd'}}>
          <div style={{fontSize: '12px', color: '#555', marginBottom: '3px'}}>
            <strong>Tax ID:</strong> {taxDetails}
          </div>
        </div>
      );
    };

    return (
      <TabBar id="hdrTab"  toggle='yes' class='tabbar-toggle tabbar-toggle-up' title='Collapse / Expand Header tabs' style={{"right":"15px"}}>
         { activeNotification && <Tab active={activeTabCS} name="notificationDetailTab" label={T('Service Details')}>
         <LabelGrid data={labelGridNotificationDetail}/>
         </Tab> }
 
        <Tab active={activeTab} name="orderDetailTab" label={T('Order Details')}>
          <LabelGrid data={labelGridDataOrderDetail}/>
        </Tab>
 
        <Tab  name="headerStatus" label={hdrStatusLabel}>
          <table className="hdrGrid">
           <tbody>
            <tr>
              <th><DDLabel field={DD('consolidated_stati', 'int_widget')} />
                  <br/>
                  {addUserStatus}
              </th>
              <td style={{ width: "90%" }}>{fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "hdr", exceptions, "header", "", "", "", cbReleaseHdrBlock, order, 0, order.om_system ))}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('delivery_block', 'int_widget')} /></th>
              <td style={{ width: "90%" }}>{fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "hdr", exceptions, "delivery", "", "", "", cbReleaseHdrBlock, order, 0, order.om_system ))}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('billing_block',   'int_widget')} /></th>
              <td style={{ width: "90%" }}>{fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "hdr", exceptions, "billing", "", "", "", cbReleaseHdrBlock, order, 0, order.om_system ))}</td>
            </tr>
            <tr>
              <th>Other System Block</th>
              <td style={{ width: "90%" }}>{fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "hdr", exceptions, "othersys", "", "", "", cbReleaseHdrBlock, order, 0, order.om_system ))}</td>
            </tr>
           </tbody>
          </table>
        </Tab>
 
        <Tab name="addressTab" label={T('Address')}>
 
          <table className="table table-hover">
           <thead>
           <tr>
              <th className="addressPartner"><DDLabel field={DD('ShipToAddr',    'int_widget')} /></th>
              <th className="addressPartner"><DDLabel field={DD('SoldToAddr',    'int_widget')} /></th>
              <th className="addressPartner"><DDLabel field={DD('InvoiceToAddr', 'int_widget')} /></th>
              {fmAddress(order.end_customer) != "" ? (<th className="addressPartner"><L>End Customer</L></th>): ""}
              {fmAddress(order.reseller_customer) != "" ? (<th className="addressPartner"><L>Reseller</L></th>): ""}
           </tr>
           </thead>
           <tbody>
           <tr>
              <td>
                {fmAddress(order.ship_to_addr)}
                {renderInlineTaxDetails(order.ship_to_tax_id)}
              </td>
              <td>
                {fmAddress(order.sold_to_addr)}
                {renderInlineTaxDetails(order.sold_to_tax_id)}
              </td>
              <td>
                {fmAddress(order.invoice_to_addr)}
                {renderInlineTaxDetails(order.inv_to_tax_id)}
              </td>
              {fmAddress(order.end_customer) != "" ? (<td>{fmAddress(order.end_customer)}</td>) : ""}
              {fmAddress(order.reseller_customer) != "" ? (<td>{fmAddress(order.reseller_customer)}</td>) : ""}
           </tr>
            </tbody>
            <thead>
            <tr>
               <th className="addressPartner" colSpan="5"><L>Contact Information (name, phone, fax, mail)</L></th>
            </tr>
            </thead>
            <tbody>
           <tr>
              <td>Name: {order.ship_to_attention.name}</td>
              <td>Name: {order.sold_to_attention.name}</td>
              <td>Name: {order.invoice_to_attention.name}</td>
              {fmAddress(order.end_customer) != "" ? (<td>Name: </td>) : ""}
              {fmAddress(order.reseller_customer) != "" ? (<td>Name: </td>) : ""}
           </tr>
           <tr>
               <td>Phone: {order.ship_to_attention.phone          != "" ? order.ship_to_attention.phone : ""}</td>
               <td>Phone: {order.sold_to_attention.phone          != "" ? order.sold_to_attention.phone : ""}</td>
               <td>Phone: {order.invoice_to_attention.phone       != "" ? order.invoice_to_attention.phone : ""}</td>
               {fmAddress(order.end_customer) != "" ? (<td>Phone: {order.end_customer_attention.phone      != "" ? order.end_customer_attention.phone : ""}</td>) : ""}
               {fmAddress(order.reseller_customer) != "" ? (<td>Phone: {order.reseller_customer_attention.phone != "" ? order.reseller_customer_attention.phone : ""}</td>) : ""}
           </tr>
           <tr>
               <td>Fax: {order.ship_to_attention.fax           != "" ? order.ship_to_attention.fax : ""}</td>
               <td>Fax: {order.sold_to_attention.fax           != "" ? order.sold_to_attention.fax : ""}</td>
               <td>Fax: {order.invoice_to_attention.fax        != "" ? order.invoice_to_attention.fax : ""}</td>
               {fmAddress(order.end_customer) != "" ? (<td>Fax: {order.end_customer_attention.fax      != "" ? order.end_customer_attention.fax : ""}</td>) : ""}
               {fmAddress(order.reseller_customer) != "" ? (<td>Fax: {order.reseller_customer_attention.fax != "" ? order.reseller_customer_attention.fax : ""}</td>) : ""}
           </tr>
           <tr>
              <td>Email: {order.ship_to_attention.email}</td>
              <td>Email: {order.sold_to_attention.email}</td>
              <td>Email: {order.invoice_to_attention.email}</td>
              {fmAddress(order.end_customer) != "" ? (<td>Email: {order.end_customer_attention.email}</td>) : ""}
              {fmAddress(order.reseller_customer) != "" ? (<td>Email: {order.reseller_customer_attention.email}</td>) : ""}
           </tr>
           </tbody>
          </table>
       </Tab>
       <Tab name="salesContractTab" label={T('Sales Contract')}>
           <SalesContract order={order}/>
       </Tab>

       {commentsTab}
       {moreInfoTab}
       {casesTab}
       {claimsTab}
       {falloutsTab}
       {datesTab}
       {hpContacts}
       {hOrderAnalysisTab}
 
      </TabBar>
    )
  }
};


//----------------------------------------------------------------------
//   ItemTabs -- item/bundle by open/shipped/canceled items
//
//----------------------------------------------------------------------
class ItemTabs extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      itemCat: 'all',
      selectedTimeSlice: 'Hide_Inactive',
      render: {
        shipToAddr: false
      },
      sccpItems: []
    }
    this.handleSelectColumn  = this.handleSelectColumn.bind(this);
    this.handleSCCPItems     = this.handleSCCPItems.bind(this);

    this.MAX_SCCP_ITEMS = (this.props.order.tenant == 'HPICS') ? 1 : 25;

    this.sccpBtnRefs = [];
    this.timeSliceCaller     = this.timeSliceCaller.bind(this);
    this.clickSwitch = this.clickSwitch.bind(this);
  }

  handleReleaseItemBlock( order, item_no, exceptionArea, exception ) {

    //console.log('handleReleaseItemBlock:', order.legacy_ordhis.props.order.credit_stater_no, item_no, exceptionArea, exception);
    console.log('handleReleaseItemBlock:', order.legacy_order_no, item_no, exceptionArea, exception);

    $('#remblockModal').modal('hide');

    ReactDOM.render(
      <ModalWidgetWaiting
        size={"small"}/>
      , document.getElementById('remblockbody')
    );

    $('#doneRemovingBlock').hide();
    $('#removingBlock').text('Removing block '+exception.code+' on item '+item_no);
    $('#spinningIconRemoveBlock').show();

    POST("/os/ossui/v1/in/removeBlock", {

      legacy_order_no: order.legacy_order_no, 
      sap_system:      order.om_system, 
      so_no:           order.so_no, 
      item_no:         item_no, 
      exceptionArea:   exceptionArea,
      exceptionType:   exception.type,
      block:           exception.code

    }, function (resp) {
        $('#spinningIconRemoveBlock').hide();
        $('#doneRemovingBlock').show();
        if (resp && resp.stdout && resp.stdout != "") {
            $('#doneRemovingBlock').text(resp.stdout);
        } else {
            $('#doneRemovingBlock').text(resp.stdout);
        }
        $('#spinningIconRefreshingOrder').show();
        setTimeout( function() {
            $('#spinningIconRefreshingOrder').hide();
        }, 7000);
    });
      
    $('#remblockModal').modal( { backdrop: 'static'} );
  }

  showAddItemUserStatus(legacy_order_no, item_no) {
    console.log("handleAddItemUserStatus:", legacy_order_no, item_no);
    $('#addItemUserStatusItemNo').val(item_no);
    $('#addItemUserStatusErrorText').text("");
    $('#addItemUserStatus').modal( { backdrop: 'static'} );
  }

  handleCloseAddItemUserStatus() {
      console.log('handleCloseAddItemUserStatus');
      $('#addItemUserStatus').modal('hide');
      event.preventDefault();
  }

  handleAddItemUserStatus(order) {
      var user_status = $('#userstatus_item').val();
      var item_slns = [ $('#addItemUserStatusItemNo').val() ];
      console.log("handleAddItemUserStatus:", order, user_status, item_slns);
      var massUpdateRequest = { 
             action: "userstatus_item_set",        
             user_status: user_status,
             selection: { 
                 orders:     [ order.legacy_order_no ],
                 orderItems: { }
             }
      }      
     massUpdateRequest.selection.orderItems[order.legacy_order_no] = item_slns;                  
      POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest,
          function(resp) {
              console.log('massUpdateResponse=', resp); 
              var r = /SAP_PERMISSION_MISSING:(.*?)!!/.exec(resp.message);
              if (r && r[1]) {
                  $('#addItemUserStatusErrorText').text("Error: " + r[1]);
              } else { 
                  $('#addItemUserStatus').modal('hide');
                  event.preventDefault();
              }
          }      
      )
  }

  handleSelectColumn(e) {
    if(this.state.itemCat != e.target.value ) {
      this.setState({
        itemCat: e.target.value,
      })
    }
    e.preventDefault();
  }

  handleSCCPItems(item) {
    var sccpItems = [...this.state.sccpItems]

    if (sccpItems.includes(item)) {
      sccpItems.splice(sccpItems.indexOf(item), 1)

    } else {
      if (sccpItems.length < this.MAX_SCCP_ITEMS) {
        sccpItems.push(item);

      } else {
        toast.info("Maximum number of items that can be selected is " + this.MAX_SCCP_ITEMS);
        return;
      }
    }

    this.setState({sccpItems: sccpItems});
    this.props.updateSCCPItems([...sccpItems]);
  }

  timeSliceCaller(event) {
    var selectedTimeSlice = event.target.value;
    console.log("Selected Time Slice: ", selectedTimeSlice);
    this.setState({ selectedTimeSlice: selectedTimeSlice });
  }

  clickSwitch (event) {
    var e = document.getElementById("filt-dollar"),
    d = document.getElementById("filt-localc"),
    t = document.getElementById("cSwitcher"),
    m = document.getElementById("dollar"),
    y = document.getElementById("localc");

    if (t.checked == true) {
      //t.checked = false;
      e.classList.add("cToggler--is-active");
      d.classList.remove("cToggler--is-active");
      m.classList.remove("cHide");
      y.classList.add("cHide");
    } else {
      //t.checked = false;
      e.classList.remove("cToggler--is-active");
      d.classList.add("cToggler--is-active");
      m.classList.add("cHide");
      y.classList.remove("cHide");    
    }
  }

  handleAIPrompt(prompt) {
    window.promptChatbot(prompt);

    // Special handling for internal widget in landing page
    if (!document.location.pathname.includes("osWidgetWrapperInt"))
      document.querySelector('button.close[data-dismiss="modal"]')?.click();
  }

  render() {

    var self = this;

    var order = this.props.order;
    var items = this.props.order.items;

    if (!items) items = [];

    var groups = {};
    var counts = {};
    var itemTab = "";
    var sItems   = [];
    var sCounts  = 0;
    var shipToAddressTab = "" ;
    var multiShipTo      = OSWidgetLib.ZMSOOrder(this.props.order);
    var somOrder         = OSWidgetLib.SOMOrder(this.props.order);

    var cbReleaseItemBlock = null;
    if (UserSettings.memberOf("RemoveBlocks") || order.hp_contact == UserSettings.user_id ) {
      cbReleaseItemBlock = self.handleReleaseItemBlock;
    }
    var fieldExist    = OSWidgetLib.checkFieldValueExist(this.props.order.items,['canceled_at','cust_product_no','prod_localization','fact_delv_no','shipment_no','proforma_invoice_no','ship_cancelled_at','proforma_invoice_import_no','contract_account','timeslice_id','timeslice_status','timeslice_start','timeslice_end','recurring_charge','fcdn','ro_etrans_scope','workflow_status']);
    var checkProforma = 0;
    var countProforma =  ((order.om_region == "APJ") && (fieldExist['proforma_invoice_no'] || fieldExist['proforma_invoice_import_no'])) ? 1 :  0 ;


    var sStyle = {  display : "inline-block" ,
                    outline : 'none' ,
                    fontSize: "12px" ,
                    width   : "fit-content" ,
                    height  : "fit-content",
                    color   : "#555",
                    border  : "1px solid #ccc",
                    margin  : "0 10px",
                    borderRadius   : "3px",
                    backgroundColor: "#fff",
                  }


    var itemCatBox =  <select name="itemOptions"  onClick={this.handleSelectColumn} style={sStyle}>
                        <option value="all">All</option>
                        <option value="openItems">Open</option>
                        <option value="shippedItems">Shipped</option>
                        <option value="canceledItems">Canceled</option>
                      </select>

    if (this.props.order.order_type_descr === "Subscription Contract") {
      console.log("ITEMS:: ", this.props.order.items);

      const uniqueTimeslices = new Map();

      // Collect unique timeslices
      this.props.order.items.forEach(item => {
        if (!uniqueTimeslices.has(item.timeslice_id)) {
          uniqueTimeslices.set(item.timeslice_id, {
            timeslice_start: item.timeslice_start,
            timeslice_end: item.timeslice_end,
            timeslice_status: item.timeslice_status,
          });
        }
      });

      // Convert the Map to an array and sort by timeslice_id
      const timeslices = Array.from(uniqueTimeslices, ([timeslice_id, details]) => ({
        timeslice_id,
        ...details,
      })).sort((a, b) => a.timeslice_id.localeCompare(b.timeslice_id));

      // Build the dropdown
      var itemCatBox = (
        <span>
          &nbsp;&nbsp;&nbsp; Time slice Selector :
          <select name="itemOptions" style={sStyle} onChange={this.timeSliceCaller} value={this.state.selectedTimeSlice}>
            <option value="All">All</option>
            <option value="Hide_Inactive">Hide Inactive</option>
            {timeslices.map((item) => (
              <option
                key={item.timeslice_id}
                value={item.timeslice_id}
                style={{
                  color: item.timeslice_status === "Canceled" ? "#c1401a" : "inherit",
                }}
              >
                {fmDate(item.timeslice_start)} - {fmDate(item.timeslice_end)} (
                {item.timeslice_id} - {item.timeslice_status})
              </option>
            ))}
          </select>
        </span>
      );
    }

    if(multiShipTo) {
      var groupCounts = {};
      OSWidgetLib.PrepareActiveItemGroupsForZMSO( this.props.order.items, groups, counts, groupCounts);

      if ( this.state.itemCat == "all"           )  { sItems = groups.allStati   ; sCounts = groupCounts.allStati  ;}
      if ( this.state.itemCat == "openItems"     )  { sItems = groups.open       ; sCounts = groupCounts.open      ;}
      if ( this.state.itemCat == "shippedItems"  )  { sItems = groups.shipped    ; sCounts = groupCounts.shipped   ;}
      if ( this.state.itemCat == "canceledItems" )  { sItems = groups.canceled   ; sCounts = groupCounts.canceled  ;}

      var zmsoItems = {
        header: [
          { name: DD('item_subitem',    'int_widget') },
          { name: DD('material_no',     'int_widget'), nowrap:1 },
          { name: DD('cust_product_no', 'int_widget') },
          { name: DD('prod_localization',    'int_widget' ) },
          { name: DD('product_descr',   'int_widget') },
          { name: DD('status',          'int_widget') },
          { name: DD('so_line_item_qty',  'int_widget') ,  right:1 },
          { name: DD('sched_line_qty',    'int_widget') ,  right:1 },
          { name: DD('bundle_price',      'int_widget') ,  right:1 },
          { name: 'MOT',  },
          { name: DD('fact_delv_no',        'int_widget' ) },
          { name: DD('shipment_no',          'int_widget' ) },
          { name: DD('sched_ship_date', 'int_widget') ,  right:1 },
          { name: DD('eshp_actual',       'int_widget') ,  right:1 },
          { name: DD('customer_req_date' ,  'int_widget', 'right' ) },
          { name: DD('sched_delv_date',   'int_widget','right') },
          { name: DD('ship_cancelled_at', 'int_widget', 'right') },
          { name: DD('pod_at',                      'int_widget','right')},
          { name: DD('endcust_planned_delivery_date', 'int_widget','right')},
          { name: DD('endcust_delivery_date',         'int_widget','right')},
          { name: DD('invoice_no',           'int_widget','right' ) },
          { name: DD('proforma_invoice_no', 'int_widget', 'right') },
          { name: DD('proforma_invoice_import_no', 'int_widget', 'right') },
          { name: DD('canceled_at',         'int_widget', 'right' )},
          { name: DD('cancellation_reason', 'int_widget', 'right' )},

          { name: 'Additional Info'        },
        ],
        data: OSWidgetLib.constructRowsWrapper( sItems,true, function(row) {
          // Submit Request button at item level for CS (3W SCCP Integration)
          var sRBtn = OSWidgetLib.genItemLevelSubReqBtn(UserSettings, order, row, this, this.state.sccpItems)

          // Sandy AI Item Prompts
          var aiItemPrompts = null;
          if (   ["Trade Order", "Leasing Trade Order"].includes(order?.order_type_descr || "")
              && UserSettings?.config?.GenAICfg?.prompts?.item
              && Array.isArray(UserSettings.config.GenAICfg.prompts.item)) {
            var sandyItemPromptsList = [];
            var toolCallValues = { 1: order.legacy_order_no, 2: row.item_sln };

            UserSettings.config.GenAICfg.prompts.item.map((prompt, idx) => (
              sandyItemPromptsList.push(<a onClick={() => this.handleAIPrompt(prompt.v.replace(/\$(\d+)/g, (_, n) => toolCallValues[n] ?? `$${n}`))}>{prompt.l}</a>)
            ));

            if (sandyItemPromptsList.length > 0)
              aiItemPrompts = <PopupMenu field={<i className="fa-solid fa-oss-sandy" style={{fontSize: '14px', marginRight: '2px'}}/>} list={sandyItemPromptsList}/>
          }

          // Sandy AI Ship Prompts
          var aiShipPrompts = null;
          if (   ["Trade Order", "Leasing Trade Order"].includes(this.props.order?.order_type_descr || "")
              && row.shipment_no
              && UserSettings?.config?.GenAICfg?.prompts?.ship
              && Array.isArray(UserSettings.config.GenAICfg.prompts.ship)) {
            var sandyShipPromptsList = [];

            UserSettings.config.GenAICfg.prompts.ship.map((prompt, idx) => (
              sandyShipPromptsList.push(<a onClick={() => this.handleAIPrompt(`${prompt.v} ${row.shipment_no}`)}>{prompt.l}</a>)
            ));

            if (sandyShipPromptsList.length > 0)
              aiShipPrompts = <PopupMenu field={<i className="fa-solid fa-oss-sandy" style={{fontSize: '14px', marginRight: '2px'}}/>} list={sandyShipPromptsList}/>
          }

          // Sandy AI Invoice Prompts
          var aiInvPrompts = null;
          if (   ["Trade Order", "Leasing Trade Order"].includes(order?.order_type_descr || "")
              && UserSettings?.config?.GenAICfg?.prompts?.inv
              && Array.isArray(UserSettings.config.GenAICfg.prompts.inv)) {
            var sandyInvPromptsList = [];

            UserSettings.config.GenAICfg.prompts.inv.map((prompt, idx) => (
              sandyInvPromptsList.push(<a onClick={() => this.handleAIPrompt(`${prompt.v} ${row.invoice_no}`)}>{prompt.l}</a>)
            ));

            if (sandyInvPromptsList.length > 0)
              aiInvPrompts = <PopupMenu field={<i className="fa-solid fa-oss-sandy" style={{fontSize: '14px', marginRight: '2px'}}/>} list={sandyInvPromptsList}/>
          }

          if (cbReleaseItemBlock == null) {
              var itemObj = <span>{sRBtn}{aiItemPrompts}{row.item_subitem}</span>
          } else {
              var itemObj = <span>{sRBtn}{aiItemPrompts}<span onClick={self.showAddItemUserStatus.bind(null,order.legacy_order_no, row.item_subitem)}
                                title='add user status' style={{cursor: 'default', color:"#c1401a"}}
                            >{row.item_subitem}</span></span>
          }
          var invUrl  =  RewriteRESTURL("/os/ossui/v1/in/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.system );
          var invCell =  <a href= {invUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                              {row.invoice_no}
                            </a>;
          var  proInvUrl = RewriteRESTURL("/os/ossui/v1/in/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_no+"&data_source="+row.system );
          var  proInvCell = <a href= {proInvUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                              {row.proforma_invoice_no}
                            </a>;
          var  proInvImpUrl = RewriteRESTURL("/os/ossui/v1/in/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_import_no+"&data_source="+row.system );
          var  proInvImpCell = <a href= {proInvImpUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                              {row.proforma_invoice_import_no}
                            </a>;

          if ( row.system == "QAD-IL" || row.system == "QAD-JP" || row.system == "QAD-NL" ||  row.system == "QAD-US" || window.mobileMode ) {
            invCell    = row.invoice_no;
            proInvCell = row.proforma_invoice_no;
            proInvImpCell = row.proforma_invoice_import_no;
          }
          if (!UserSettings.memberOf('ShowRestrictedFields') || !UserSettings.isValidAcv(row.acv, '300')) {
            invCell    = row.invoice_no;
            proInvCell = row.proforma_invoice_no;
            proInvImpCell = row.proforma_invoice_import_no;
          }
          var isCanceledStatusOnItem = ((row.status || "").toUpperCase() == "CANCELED" || (row.status || "").toUpperCase() == "CANCELLED");
          var additional_info = [];
          if (!isCanceledStatusOnItem) {
            additional_info = fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "item", row.exceptions, "item", row.delivery_status, row.ack_date_comment, row.manual_ack_comment, cbReleaseItemBlock, order, row.so_item_no, row.system, "open", row.odm_reason, row.odm_priority, row.odm_drop));
            if(row.shipment_no) {
              additional_info = fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "item", row.exceptions, "", row.delivery_status, "", "", cbReleaseItemBlock, order.legacy_order_no, row.item_subitem, row.system, "shipped" ));
            }
          }

          var shipObj = row.shipment_no ? <span style={{whiteSpace: "nowrap", display: "flex"}}>{aiShipPrompts}{row.shipment_no}</span> : row.shipment_no;
          var invObj = row.invoice_no ? <span style={{whiteSpace: "nowrap", display: "flex"}}>{aiInvPrompts}{invCell}</span> : invCell;

          var arr = [
            itemObj,
            row.material_no,
            row.cust_product_no,
            row.prod_localization,
            row.product_descr,
            OSWidgetLib.mapItemStatus(row.status, order.tenant),
            row.so_line_item_qty,
            row.sched_line_qty,
            window.mobileMode ? 'N/A' : fmNum(row.bundle_price),
            row.transportmode_act ? row.transportmode_act : row.transportmode_orig,
            row.fact_delv_no,
            shipObj,
            fmDate(row.sched_ship_date),
            fmDate(row.eshp_actual),
            fmDate(row.customer_req_date),
            fmDate(row.sched_delv_date),
            fmDate(row.ship_cancelled_at),
            fmDate(row.pod_at),

            fmDate(order.endcust_planned_delivery_date),
            fmDate(order.endcust_delivery_date),

            invObj,
            proInvCell,
            proInvImpCell,

            fmDate(row.canceled_at),
            row.cancellation_reason_sap,

            additional_info,
          ]

          !fieldExist['canceled_at'] && arr.splice(23,2);

          if(order.om_region != "APJ" || !countProforma){
           arr.splice(21,1);
           checkProforma = 1;
          }
          if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
            arr.splice(18,2);
          }

          !fieldExist['ship_cancelled_at']  && arr.splice(16,1);
          !fieldExist['shipment_no']        && arr.splice(11,1);
          !fieldExist['fact_delv_no']       && arr.splice(10,1);
          !fieldExist['prod_localization']  && arr.splice(3,1);
          !fieldExist['cust_product_no']    && arr.splice(2,1);

          return arr;
        }.bind(this))
      }

      !fieldExist['canceled_at'] && zmsoItems.header.splice(23,2);

      if (checkProforma || !zmsoItems.data.length) {
         zmsoItems.header.splice(21,1);
      }

      if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
        zmsoItems.header.splice(18,2);
      }

      !fieldExist['ship_cancelled_at']  && zmsoItems.header.splice(16,1);
      !fieldExist['shipment_no']        && zmsoItems.header.splice(11,1);
      !fieldExist['fact_delv_no']       && zmsoItems.header.splice(10,1);
      !fieldExist['prod_localization']  && zmsoItems.header.splice(3,1);
      !fieldExist['cust_product_no']    && zmsoItems.header.splice(2,1);

      var zmsoLabel = (
                        <span>
                          <L>Items</L>
                          <div className="badge badge-red">{sCounts}</div>
                          &nbsp;{itemCatBox}
                        </span>
                      );


      itemTab = <Tab active name="zmsoItemsTab" label={zmsoLabel}>
                  <SimpleDataGrid header={zmsoItems.header} data={zmsoItems.data} doUpdate={true} wrapper='zmso'  caller="int" enableDownload={true}/>
                </Tab>

      shipToAddressTab =  <Tab name="shipToAddressTab" label="shipToAddress" onClick={()=>this.setState(prevState=>({render:{...prevState.render, shipToAddr: true}}))}>
                            { this.state.render.shipToAddr && <ShipToAddress order={order} simpleWidget={true}  doUpdate={true} expandedByDefault={window.mobileMode} caller="int"/> }
                          </Tab>
    } else {
      checkProforma = 0;
      if (this.props.order.order_type_descr === "Subscription Contract") {
        var subGroups = {};
        var subCounts = {};
        var subGroupCounts = {};
        OSWidgetLib.PrepareActiveItemGroupsForSOM(items, subGroups, subCounts, subGroupCounts);
        sItems = subGroups.allStati;
        sCounts = subGroupCounts.allStati;
      } else if(somOrder) {
        OSWidgetLib.PrepareItemGroupsForSOM( items, groups, counts);
        if ( this.state.itemCat == "all"           )  { sItems = groups.eOdmItems  ; sCounts = counts.eOdmItems ;}
        if ( this.state.itemCat == "openItems"     )  { sItems = groups.open       ; sCounts = counts.open      ;}
        if ( this.state.itemCat == "shippedItems"  )  { sItems = groups.shipped    ; sCounts = counts.shipped   ;}
        if ( this.state.itemCat == "canceledItems" )  { sItems = groups.canceled   ; sCounts = counts.canceled  ;}
      } else {
        OSWidgetLib.PrepareItemGroups( items, groups, counts);
        if ( this.state.itemCat == "all"           )  { sItems = groups.eOdmItems  ; sCounts = counts.eOdmItems ;}
        if ( this.state.itemCat == "openItems"     )  { sItems = groups.open       ; sCounts = counts.open      ;}
        if ( this.state.itemCat == "shippedItems"  )  { sItems = groups.shipped    ; sCounts = counts.shipped   ;}
        if ( this.state.itemCat == "canceledItems" )  { sItems = groups.canceled   ; sCounts = counts.canceled  ;}
      }

      var mergedItems = {
        header: [
          { name: DD('item_subitem',    'int_widget') },
          { name: DD('material_no',     'int_widget'), nowrap:1 },
          { name: DD('cust_product_no', 'int_widget') },
          { name: DD('prod_localization',    'int_widget' ) },
          { name: DD('product_descr',   'int_widget') },
          { name: DD('status',          'int_widget') },
          { name: DD('so_line_item_qty',  'int_widget') ,  right:1 },
          { name: DD('sched_line_qty',    'int_widget') ,  right:1 },
          { name: DD('bundle_price',      'int_widget') ,  right:1 },
          { name: 'MOT',  },

          { name: DD('fact_delv_no',        'int_widget' ) },
          { name: DD('shipment_no',          'int_widget' ) },
          { name: DD('sched_ship_date', 'int_widget') ,  right:1 },
          { name: DD('eshp_actual',       'int_widget') ,  right:1 },
          { name: DD('customer_req_date' ,  'int_widget', 'right' ) },
          { name: DD('sched_delv_date',   'int_widget','right') ,  right:1 },
          { name: DD('ship_cancelled_at', 'int_widget','right'), right:1 },
          { name: DD('pod_at',                      'int_widget','right'),  right:1 },

          { name: DD('endcust_planned_delivery_date', 'int_widget','right'), nowrap:1 },
          { name: DD('endcust_delivery_date',         'int_widget','right'), nowrap:1 },

          { name: DD('invoice_no',           'int_widget','right' ) },
          { name: DD('proforma_invoice_no', 'int_widget', 'right') },
          { name: DD('proforma_invoice_import_no', 'int_widget', 'right') },

          { name: DD('canceled_at',         'int_widget', 'right' )},
          { name: DD('cancellation_reason', 'int_widget', 'right' )},

          { name: 'Additional Info'        },
          { name: DD('contract_account',     'int_widget', 'right' )},
          { name: DD('timeslice_id',         'int_widget', 'right' )},
          { name: DD('timeslice_status',     'int_widget', 'right' )},
          { name: DD('timeslice_start',      'int_widget', 'right' )},
          { name: DD('timeslice_end',        'int_widget', 'right' )},
          { name: DD('recurring_charge',     'int_widget', 'right' )},
          { name: DD('fcdn',                 'int_widget', 'right' )},
        ],
        data: OSWidgetLib.constructRows( sItems, function(row) {

          // Submit Request button at item level for CS (3W SCCP Integration)
          var sRBtn = OSWidgetLib.genItemLevelSubReqBtn(UserSettings, order, row, this, this.state.sccpItems)

          // Sandy AI Item Prompts
          var aiItemPrompts = null;
          if (   ["Trade Order", "Leasing Trade Order"].includes(order?.order_type_descr || "")
              && UserSettings?.config?.GenAICfg?.prompts?.item
              && Array.isArray(UserSettings.config.GenAICfg.prompts.item)) {
            var sandyItemPromptsList = [];
            var toolCallValues = { 1: order.legacy_order_no, 2: row.item_sln };

            UserSettings.config.GenAICfg.prompts.item.map((prompt, idx) => (
              sandyItemPromptsList.push(<a onClick={() => this.handleAIPrompt(prompt.v.replace(/\$(\d+)/g, (_, n) => toolCallValues[n] ?? `$${n}`))}>{prompt.l}</a>)
            ));

            if (sandyItemPromptsList.length > 0)
              aiItemPrompts = <PopupMenu field={<i className="fa-solid fa-oss-sandy" style={{fontSize: '14px', marginRight: '2px'}}/>} list={sandyItemPromptsList}/>
          }

          // Sandy AI Ship Prompts
          var aiShipPrompts = null;
          if (   ["Trade Order", "Leasing Trade Order"].includes(this.props.order?.order_type_descr || "")
              && row.shipment_no
              && UserSettings?.config?.GenAICfg?.prompts?.ship
              && Array.isArray(UserSettings.config.GenAICfg.prompts.ship)) {
            var sandyShipPromptsList = [];

            UserSettings.config.GenAICfg.prompts.ship.map((prompt, idx) => (
              sandyShipPromptsList.push(<a onClick={() => this.handleAIPrompt(`${prompt.v} ${row.shipment_no}`)}>{prompt.l}</a>)
            ));

            if (sandyShipPromptsList.length > 0)
              aiShipPrompts = <PopupMenu field={<i className="fa-solid fa-oss-sandy" style={{fontSize: '14px', marginRight: '2px'}}/>} list={sandyShipPromptsList}/>
          }

          // Sandy AI Invoice Prompts
          var aiInvPrompts = null;
          if (   ["Trade Order", "Leasing Trade Order"].includes(order?.order_type_descr || "")
              && UserSettings?.config?.GenAICfg?.prompts?.inv
              && Array.isArray(UserSettings.config.GenAICfg.prompts.inv)) {
            var sandyInvPromptsList = [];

            UserSettings.config.GenAICfg.prompts.inv.map((prompt, idx) => (
              sandyInvPromptsList.push(<a onClick={() => this.handleAIPrompt(`${prompt.v} ${row.invoice_no}`)}>{prompt.l}</a>)
            ));

            if (sandyInvPromptsList.length > 0)
              aiInvPrompts = <PopupMenu field={<i className="fa-solid fa-oss-sandy" style={{fontSize: '14px', marginRight: '2px'}}/>} list={sandyInvPromptsList}/>
          }

          if (cbReleaseItemBlock == null) {
              var itemObj = <span>{sRBtn}{aiItemPrompts}{row.item_subitem}</span>
          } else {
              var itemObj = <span>{sRBtn}{aiItemPrompts}<span onClick={self.showAddItemUserStatus.bind(null,order.legacy_order_no, row.item_subitem)}
                                title='add user status' style={{cursor: 'default', color:"#c1401a"}}
                            >{row.item_subitem}</span></span>
          }
          var invUrl  =  RewriteRESTURL("/os/ossui/v1/in/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.system );
          var invCell =  <a href= {invUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                              {row.invoice_no}
                            </a>;
          var  proInvUrl = RewriteRESTURL("/os/ossui/v1/in/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_no+"&data_source="+row.system );
          var  proInvCell = <a href= {proInvUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                              {row.proforma_invoice_no}
                            </a>;
          var  proInvImpUrl = RewriteRESTURL("/os/ossui/v1/in/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_import_no+"&data_source="+row.system );
          var  proInvImpCell = <a href= {proInvImpUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                              {row.proforma_invoice_import_no}
                            </a>;

          if ( row.system == "QAD-IL" || row.system == "QAD-JP" || row.system == "QAD-NL" ||  row.system == "QAD-US" || window.mobileMode ) {
            invCell    = row.invoice_no;
            proInvCell = row.proforma_invoice_no;
            proInvImpCell = row.proforma_invoice_import_no;
          }
          if (!UserSettings.memberOf('ShowRestrictedFields') || !UserSettings.isValidAcv(row.acv, '300')) {
            invCell    = row.invoice_no;
            proInvCell = row.proforma_invoice_no;
            proInvImpCell = row.proforma_invoice_import_no;
          }
          var isCanceledStatusOnItem = ((row.status || "").toUpperCase() == "CANCELED" || (row.status || "").toUpperCase() == "CANCELLED");
          var additional_info = [];
          if (!isCanceledStatusOnItem) {
            additional_info = fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "item", row.exceptions, "item", row.delivery_status, row.ack_date_comment, row.manual_ack_comment, cbReleaseItemBlock, order, row.so_item_no, row.system, "open", row.odm_reason, row.odm_priority, row.odm_drop));
            if(row.shipment_no) {
              additional_info = fmArray(OSWidgetLib.additionalInfo(order.tenant, "in", "item", row.exceptions, "", row.delivery_status, "", "", cbReleaseItemBlock, order.legacy_order_no, row.item_subitem, row.system, "shipped" ));
            }
          }

          var shipObj = row.shipment_no ? <span style={{whiteSpace: "nowrap", display: "flex"}}>{aiShipPrompts}{row.shipment_no}</span> : row.shipment_no;
          var invObj = row.invoice_no ? <span style={{whiteSpace: "nowrap", display: "flex"}}>{aiInvPrompts}{invCell}</span> : invCell;

          var arr = [
            itemObj,
            row.material_no,
            row.cust_product_no,
            row.prod_localization,
            row.product_descr,
            OSWidgetLib.mapItemStatus(row.status, order.tenant),
            row.so_line_item_qty,
            row.sched_line_qty,
            window.mobileMode ? 'N/A' : fmNum(row.bundle_price),
            row.transportmode_act ? row.transportmode_act : row.transportmode_orig,
            row.fact_delv_no,
            shipObj,
            fmDate(row.sched_ship_date),
            fmDate(row.eshp_actual),
            fmDate(row.customer_req_date),
            fmDate(row.sched_delv_date),
            fmDate(row.ship_cancelled_at),
            fmDate(row.pod_at),

            fmDate(order.endcust_planned_delivery_date),
            fmDate(order.endcust_delivery_date),

            invObj,
            proInvCell,
            proInvImpCell,

            fmDate(row.canceled_at),
            row.cancellation_reason_sap,

            additional_info,
            row.contract_account,
            row.timeslice_id,
            row.timeslice_status,
            fmDate(row.timeslice_start),
            fmDate(row.timeslice_end),
            row.recurring_charge,
            (order.ro_etrans_scope === 'Y') ?
              (row.fcdn ? <span title={OSWidgetLib.getFcdnStatusText(row.workflow_status)}>{row.fcdn}</span> : '') : null,
          ]

          // Conditionally remove FCDN column if ro_etrans_scope is not 'Y'
          if (order.ro_etrans_scope != 'Y') {
            arr.splice(arr.length - 1, 1);
          }

          !fieldExist['recurring_charge'] && arr.splice(31, 1);
          !fieldExist['timeslice_end']    && arr.splice(30, 1);
          !fieldExist['timeslice_start']  && arr.splice(29, 1);
          !fieldExist['timeslice_status'] && arr.splice(28, 1);
          !fieldExist['timeslice_id']     && arr.splice(27, 1);
          !fieldExist['contract_account'] && arr.splice(26, 1);

          !fieldExist['canceled_at'] && arr.splice(23,2);

          if(order.om_region != "APJ" || !countProforma){
           arr.splice(21,1);
           checkProforma = 1;
          }
          if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
            arr.splice(18,2);
          }

          !fieldExist['ship_cancelled_at']  && arr.splice(16,1);
          !fieldExist['shipment_no']        && arr.splice(11,1);
          !fieldExist['fact_delv_no']       && arr.splice(10,1);
          !fieldExist['prod_localization']  && arr.splice(3,1);
          !fieldExist['cust_product_no']    && arr.splice(2,1);

          console.log("THAR :: this.state.selectedTimeSlice = ", this.state.selectedTimeSlice , " row.timeslice_id = ", row.timeslice_id, " row.timeslice_status = ", row.timeslice_status);
          if (this.state.selectedTimeSlice === 'Hide_Inactive') {
            console.log("THAR :: inside if section");
            var tsStatus = (row.timeslice_status || '').toUpperCase();
            if (tsStatus == 'INACTIVE') {
              return [];
            }
          } else if (
            this.state.selectedTimeSlice &&
            String(this.state.selectedTimeSlice) !== String(row.timeslice_id) &&
            this.state.selectedTimeSlice !== 'All'
          ) {
            console.log("THAR :: inside else if section");

            return [];
          }

          return arr;
        }.bind(this))
      }

      // Conditionally remove FCDN header if not applicable
      if (order.ro_etrans_scope !== 'Y') {
        mergedItems.header.splice(mergedItems.header.length - 1, 1);
        mergedItems.data = mergedItems.data.map(function(row) {
          if (row.length > 0 && row[row.length - 1] === '') {
            return row.slice(0, -1);
          }
          return row;
        });
      }

      !fieldExist['recurring_charge'] && mergedItems.header.splice(31,1);
      !fieldExist['timeslice_end']    && mergedItems.header.splice(30,1);
      !fieldExist['timeslice_start']  && mergedItems.header.splice(29,1);
      !fieldExist['timeslice_status'] && mergedItems.header.splice(28,1);
      !fieldExist['timeslice_id']     && mergedItems.header.splice(27,1);
      !fieldExist['contract_account'] && mergedItems.header.splice(26,1);

      !fieldExist['canceled_at'] && mergedItems.header.splice(23,2);

      if (checkProforma || !mergedItems.data.length) {
         mergedItems.header.splice(21,1);
      }

      if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
        mergedItems.header.splice(18,2);
      }

      !fieldExist['ship_cancelled_at']  && mergedItems.header.splice(16,1);
      !fieldExist['shipment_no']        && mergedItems.header.splice(11,1);
      !fieldExist['fact_delv_no']       && mergedItems.header.splice(10,1);
      !fieldExist['prod_localization']  && mergedItems.header.splice(3,1);
      !fieldExist['cust_product_no']    && mergedItems.header.splice(2,1);

      var mLabel = (<span>
                      <L>Items</L>
                      <div className="badge badge-red">{sCounts}</div>
                      &nbsp;{itemCatBox}
                    </span>
                    );


      itemTab = <Tab active name="mergedItemsTab" label={mLabel}>
                  <SimpleDataGrid header={mergedItems.header} data={mergedItems.data} doUpdate={true} expandedByDefault={window.mobileMode}/>
                </Tab>
    }

    groups = {};
    counts = {};

    OSWidgetLib.PrepareItemGroups( items, groups, counts);
    var odmItems = {
    header: [
      { name: T('Item'               ) },
      { name: T('Product'            ), nowrap:1 },
      { name: T('Description'        ) },
      { name: T('Open Qty'           ) , right:1 },
      { name: T('Planned Ship Date'  ) , right:1 },
      { name: T('ODM Reason'         ) },
      { name: T('ODM Priority'       ) },
      { name: T('ODM Drop'           ) }
    ],
    data: OSWidgetLib.constructRows( groups.odm, function(row) {
            return [
              row.item_subitem,
              row.material_no,
              row.product_descr,
              row.sched_line_qty,
              fmDate(row.sched_ship_date),
              row.odm_reason,
              row.odm_priority,
              row.odm_drop
              ]
          })
    }

    var odmLabel = (
       <span>
         <L>R11</L>
         <div className="badge badge-brown" >{counts.odm}</div>
       </span>
    );

    //TODO(adkr): add CSR email address validation
    if ( counts.odm && (UserSettings.memberOf('Q2C_OSS_PLANNERS') || (UserSettings.user_id == order.sales_coord))) {
      var odmTab = <Tab name="OdmItemsTab" label={odmLabel}>
                        <SimpleDataGrid header={odmItems.header} data={odmItems.data} doUpdate={true}/>
                      </Tab>
    } else {
      var odmTab = ""

    } 

    var priceTab = "";
    var conversion_rate = null;
    var last_order_update = new Date(order.last_update);
    var newPricingCutOffDate = new Date('2019-08-09T00:00:00');

    if ( order.om_system == "SAP-SCP" &&  last_order_update > newPricingCutOffDate ) {
      
      var notCancelledItems = order.items.filter(item => item.status !== "CANCELED");

      var itemBundleStructures = {};
      var mainItems = [];
      OSWidgetLib.GetBundleStructure( notCancelledItems, itemBundleStructures );

      //Identify Bundles that have no higher level item
      itemBundleStructures.bundles.map( function(bundle) {
        if (bundle.group) {
          var foundMain = 0;
          bundle.children.map( function(item) {

            if (item.main) {
              foundMain = 1;
            } 

          });

          if (!foundMain) {
            bundle.missingMain = 'y';
          }

          if (bundle.missingMain == 'y' ) {

            //var newObj = { 
            //  main     : {},
            //  children : []
            //};

            for (var i=0; i < bundle.children.length; i++) {
              var child = bundle.children[i]
              mainItems.push(child);

              //if (!newObj.main.legacy_order_no) {
              //  newObj.main = child;
              //} else {
              //  newObj.children.push(child);
              //}
            }   
            //bundle.children = [];
            //bundle.children.push(newObj);
          }
        }
      });

      itemBundleStructures.bundles.map( function(bundle) {
      
        // within bundle, we have bundles and standalone items
        if (bundle.group ) {
          if (bundle.missingMain == 'y') {
            // this is a special case, where we identified a soft bundle, meaning, there is no Higher/Lower
            // level hierarchy and those need to be excluded from the price rollup and handled as standalone
            bundle = {};
            bundle.children = [];
          }
          // if a group exists, this is an indication for a bundle
          bundle.children.map( function(item) {
            // now loop over all childrens/items of this bundle
            if (item.main) {
              // in this case, we identified a higher/lower level item hierarchy where we keep only the main item to add the prices there.
              item.main = OSWidgetLib.sumUpNewPriceFields(item.main, item.children, 1);
              mainItems.push(item.main);
            } else if (item.higher_level == "0") {
              mainItems.push(item);
            } else {
              //append prices to the prior idendified higher level item
              mainItems.map( function(mainItem) {
                if (mainItem.bundle_name == item.bundle_name) {
                  mainItem = OSWidgetLib.sumUpNewPriceFields(mainItem, item);
                }
              });
            }
          })
        } else {

          if (bundle.main) {
            bundle.main = OSWidgetLib.sumUpNewPriceFields(bundle.main, bundle.children, 1);
            mainItems.push(bundle.main);
          } else {
            //Standalone Items, not in a Bundle
            //console.log(bundle);
            mainItems.push(bundle);
          }
        } 

      });

      var itLevel = {};
      var mainItemsWithoutPartials = {};
      for (var i=0; i < mainItems.length; i++) {
          var item_subitem = mainItems[i].item_subitem;
          if ( itLevel [ item_subitem ]) {      
              // roll up to first record 
              //itLevel [ item_subitem ].list_price +=  mainItems[i].list_price;
              mainItemsWithoutPartials = OSWidgetLib.sumUpNewPriceFields(mainItemsWithoutPartials, mainItems[i]);
          } else { 
              itLevel [ item_subitem ] = mainItems[i];
              mainItemsWithoutPartials = mainItems[i];
          }
      }        

      var mainItems = []
      for (var item_subitem in itLevel) {
          mainItems.push(itLevel[item_subitem]);
      }

      mainItems.sort(function(a, b){
        var bundleNameA=a.bundle_name, bundleNameB=b.bundle_name, itemSubItemA=a.item_subitem, itemSubItemB=b.item_subitem
        if (bundleNameA < bundleNameB) return -1 
        if (bundleNameA > bundleNameB) return 1
        if (itemSubItemA < itemSubItemB) return -1 
        if (itemSubItemA > itemSubItemB) return 1
        return 0
      })

      var finalItemPriceRow = [];
      var bundleNameObj = {};
      for (var i=0; i < mainItems.length; i++) {
        if (mainItems[i].bundle_name && mainItems[i].higher_level == "0"){
      
          bundleNameObj = {
            item_subitem : mainItems[i].item_subitem,
            label : mainItems[i].bundle_name,
          }
      
          if (finalItemPriceRow.filter(elem => (elem.label === bundleNameObj.label)).length > 0) {
            //console.log("this bundle already exists ", bundleNameObj.label);
          } else {
            finalItemPriceRow.push(bundleNameObj);          
          }
      
        }
        finalItemPriceRow.push(mainItems[i])
      }

      var pItemList = finalItemPriceRow.map( function(item) {
        
        //var item_net_price = item.list_price + item.price_sales_discount + item.price_contract_discount - item.price_shipping_charges - item.price_fees;
        var dataTarget = "#DT_local_" + item.item_subitem;
        var rowClass = "simpleDataGridBundle1"

        if (item.bundle_name != "") {
          rowClass = "simpleDataGridBundle0";
        }

        if (item.label) {
          return (  <tr >
                      <td colSpan="11" className="simpleDataGridBundleHeader">{item.label}</td>  
                    </tr>            
         );   
        } else {
          return (  <tr >
                      <td className={rowClass}>{item.item_subitem}</td>  
                      <td>{item.product_descr}</td>
                      <td className="tdR">{item.so_line_item_qty}</td>
                      <td className="tdR">{fmNum(item.list_price)}</td>  
                      <td className="tdR">{fmNum(item.price_sales_discount)}</td>  
                      <td className="tdR">{fmNum(item.price_contract_discount)}</td>  
                      <td className="tdR">{fmNum(item.price_shipping_charges)}</td>
                      <td className="tdR">{fmNum(item.price_fees)}</td>  
                      <td className="tdR">{fmNum(item.price_other)}</td>
                      <td className="tdR">{fmNum(item.net_price)}</td>
                      <td className="tdR">{fmNum(item.price_tax_value)}</td> 
                    </tr>            
         );   
        }
      });

      var pItemListDlr = finalItemPriceRow.map( function(item) {

        var item_net_price = item.list_price_dlr + item.price_sales_discount_dlr + item.price_contract_discount_dlr - item.price_shipping_charges_dlr - item.price_fees_dlr;;
        var dataTarget = "#DT_dlr_" + item.item_subitem;
        var rowClass = "simpleDataGridBundle1"

        if (item.bundle_name != "") {
          rowClass = "simpleDataGridBundle0";
        }

        if (item.label) {
          return (  <tr >
                      <td colSpan="11" className="simpleDataGridBundleHeader">{item.label}</td>  
                    </tr>            
         );   
        } else {
          return (  <tr >
                      <td className={rowClass}>{item.item_subitem}</td>  
                      <td>{item.product_descr}</td>
                      <td className="tdR">{item.so_line_item_qty}</td>
                      <td className="tdR">{fmNum(item.list_price_dlr)}</td>  
                      <td className="tdR">{fmNum(item.price_sales_discount_dlr)}</td>  
                      <td className="tdR">{fmNum(item.price_contract_discount_dlr)}</td>  
                      <td className="tdR">{fmNum(item.price_shipping_charges_dlr)}</td>  
                      <td className="tdR">{fmNum(item.price_fees_dlr)}</td>  
                      <td className="tdR">{fmNum(item.price_other_dlr)}</td>  
                      <td className="tdR">{fmNum(item.dlr_net_price)}</td>
                      <td className="tdR">{fmNum(item.price_tax_value_dlr)}</td> 
                    </tr>            
          );
        }
      });

      // Handling the header level pricing sum up values

      // Local Currency
      var total_list_price = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.list_price: 0)),0);
      var total_sales_discount = order.items.reduce((a, b) => (a + (b.higher_level == '0' ? b.price_sales_discount: 0)),0);
      var total_contract_discount = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_contract_discount: 0)),0);
      var total_price_other = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_other: 0)),0);
      var total_shipping_charges = order.items.reduce((a, b) => (a + (b.higher_level == '0' ? b.price_shipping_charges: 0)),0);
      var total_tax_value = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_tax_value: 0)),0);
      var total_fees = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_fees: 0)),0);
      var total_net_price = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.net_price: 0)),0);

      //Check Calculation as there can be positive and negative discounts!
      var total_discounts = total_sales_discount + total_contract_discount + total_price_other;
      if(total_tax_value < 0){
        var total_order = -(total_list_price + total_discounts + total_shipping_charges + total_fees) + total_tax_value;
      } else {
        var total_order = total_list_price + total_discounts + total_shipping_charges + total_fees + total_tax_value;
      }
      // Dollar
      var total_list_price_dlr = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.list_price_dlr: 0)),0);
      var total_sales_discount_dlr = order.items.reduce((a, b) => (a + (b.higher_level == '0' ? b.price_sales_discount_dlr: 0)),0);
      var total_contract_discount_dlr = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_contract_discount_dlr: 0)),0);
      var total_price_other_dlr = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_other_dlr: 0)),0);
      var total_shipping_charges_dlr = order.items.reduce((a, b) => (a + (b.higher_level == '0' ? b.price_shipping_charges_dlr: 0)),0);
      var total_tax_value_dlr = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_tax_value_dlr: 0)),0);
      var total_fees_dlr = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.price_fees_dlr: 0)),0);
      var total_net_price_dlr = order.items.reduce((a, b) => ( a + (b.higher_level == '0' ? b.dlr_net_price: 0)),0);

      var total_discounts_dlr = total_sales_discount_dlr + total_contract_discount_dlr + total_price_other_dlr;

      if(total_tax_value_dlr < 0){
        var total_order_dlr = -(total_list_price_dlr + total_discounts_dlr + total_shipping_charges_dlr + total_fees_dlr) + total_tax_value_dlr;
      } else {
        var total_order_dlr = total_list_price_dlr + total_discounts_dlr + total_shipping_charges_dlr + total_fees_dlr + total_tax_value_dlr;
      }

      if (total_net_price_dlr != total_net_price) {
        conversion_rate =  total_net_price / total_net_price_dlr;
      }

      var dlr_conversion_rate = conversion_rate ? "Dollar ($1 = " + fmNum(conversion_rate) + " " + order.currency + ")" : "Dollar";

      var disableValuePriceTab = false;
      if (!UserSettings.memberOf('ShowRestrictedFields') || !UserSettings.isValidAcv(this.props.order.acv, '300') || window.mobileMode) {
        disableValuePriceTab = true;
      }
      priceTab =
        <Tab disabled={disableValuePriceTab} name="newPricesTab" label={T('Price')}>
      
          <label className="cToggler cToggler--is-active" id="filt-localc">Local ({order.currency})</label>

          <div className="cToggle">
          <input type="checkbox" id="cSwitcher" className="cCheck" onClick={this.clickSwitch}/>
          <b className="b cSwitch"></b>
          </div>

          <label className="cToggler" id="filt-dollar">{dlr_conversion_rate}</label>

          <div id="localc"> 

          <div id="itemTbl" className="priceTab">
              <table className="priceTabTable table table-hover">
                <thead>
                <tr>
                  <th className="thItem"><L>widget_price_tab_item</L></th>
                  <th className="thProdDescr"><L>widget_price_tab_description</L></th>
                  <th className="thOrdQty"><L>widget_price_tab_orderedQty</L></th>
                  <th className="thLP"><L>widget_price_tab_list_price</L></th>
                  <th className="thSD"><L>widget_price_tab_sales_discount</L></th>
                  <th className="thCD"><L>widget_price_tab_contractual_discount</L></th>
                  <th className="thSH"><L>widget_price_tab_shipping_charges</L></th>
                  <th className="thF"><L>widget_price_tab_fees_value</L></th>
                  <th className="thO"><L>widget_price_tab_other_prices</L></th>
                  <th className="thN"><L>widget_price_tab_net_price</L></th>
                  <th className="thT"><L>widget_price_tab_tax_value</L></th>
                </tr>
                </thead>
                <tbody>
                {pItemList}
                </tbody>
              </table>
          </div>
              <table className="priceSumTbl" style={{"float":"right"}}>
                <tbody>
                  <tr>
                    <td><L>widget_price_tab_total_list_price</L></td>
                    <td className="tdR">{fmNum(total_list_price)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_discounts</L></td>
                    <td className="tdR">{fmNum(total_discounts)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_net_price</L></td>
                    <td className="tdR">{fmNum(total_net_price)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_shipping_charges</L></td>
                    <td className="tdR">{fmNum(total_shipping_charges)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_tax_value</L></td>
                    <td className="tdR">{fmNum(total_tax_value)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_fees_value</L></td>
                    <td className="tdR">{fmNum(total_fees)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_order</L></td>
                    <td className="tdR">{fmNum(total_order)}</td>
                  </tr>
                </tbody>
              </table> 

            </div>
            
          <div id="dollar" className="cHide">
            <div id="itemTblDlr" className="priceTab">
              <table className="priceTabTable table table-hover">
                  <thead>
                  <tr>
                    <th className="thItem"><L>widget_price_tab_item</L></th>
                    <th className="thProdDescr"><L>widget_price_tab_description</L></th>
                    <th className="thOrdQty"><L>widget_price_tab_orderedQty</L></th>
                    <th className="thLP"><L>widget_price_tab_list_price</L></th>
                    <th className="thSD"><L>widget_price_tab_sales_discount</L></th>
                    <th className="thCD"><L>widget_price_tab_contractual_discount</L></th>
                    <th className="thSH"><L>widget_price_tab_shipping_charges</L></th>
                    <th className="thF"><L>widget_price_tab_fees_value</L></th>
                    <th className="thO"><L>widget_price_tab_other_prices</L></th>
                    <th className="thN"><L>widget_price_tab_net_price</L></th>
                    <th className="thT"><L>widget_price_tab_tax_value</L></th>
                  </tr>
                  </thead>
                  <tbody>
                  {pItemListDlr}
                  </tbody>
                </table>
              </div>
              <table className="priceSumTbl" style={{"float":"right"}}>
                <tbody>
                  <tr>
                    <td><L>widget_price_tab_total_list_price</L></td>
                    <td className="tdR">{fmNum(total_list_price_dlr)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_discounts</L></td>
                    <td className="tdR">{fmNum(total_discounts_dlr)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_net_price</L></td>
                    <td className="tdR">{fmNum(total_net_price_dlr)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_shipping_charges</L></td>
                    <td className="tdR">{fmNum(total_shipping_charges_dlr)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_tax_value</L></td>
                    <td className="tdR">{fmNum(total_tax_value_dlr)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_fees_value</L></td>
                    <td className="tdR">{fmNum(total_fees_dlr)}</td>
                  </tr>
                  <tr>
                    <td><L>widget_price_tab_total_order</L></td>
                    <td className="tdR">{fmNum(total_order_dlr)}</td>
                  </tr>
                </tbody>
              </table> 
          </div>

        </Tab>
      ;
    }

    var massUpdHeaderStati = [];
    var massUpdItemStati   = [];

    console.log("UserSettings:", UserSettings);

    if (typeof GlobalUserSettings != 'undefined') { 
        UserSettings.config = GlobalUserSettings.config;
    }

    if (UserSettings.memberOf("RemoveBlocks") && UserSettings.config && UserSettings.config.BlockManagementSetup) {

        for (var i=0; i < UserSettings.config.BlockManagementSetup.length; i++ ) {
          if (UserSettings.config.BlockManagementSetup[i].tenant == UserSettings.tenant) {
            var blk = UserSettings.config.BlockManagementSetup[i]; 
            if (blk.level == "EditableHeaderUserStati") {
                massUpdHeaderStati.push( <option value={blk.user_status}>{blk.user_status} - {blk.user_status_text} ({blk.block_category})</option> );
            }
            if (blk.level == "EditableItemUserStati") {
                massUpdItemStati.push( <option value={blk.user_status}>{blk.user_status} - {blk.user_status_text} ({blk.block_category})</option> );
            }
          }
        }
    }

    // Item Analysis Tab
    var iOrderAnalysisTab = null;
    if (this.props.orderAnalysis?.length > 0)
      iOrderAnalysisTab = (
        <Tab name="iOrderAnalysis" label={<><ChatbotSandy fill="currentColor" stroke="currentColor" style={{width: "14px", height: "14px", verticalAlign: "middle"}} /> Item Analysis</>} >
          <IOrderAnalysis orderAnalysis={this.props.orderAnalysis} caller="int_widget" />
        </Tab>
      );

    return (

      <div>
        <ModalWithClose id="addItemUserStatus" handleClose={this.handleCloseAddItemUserStatus} closeButtonText={T('Close')} width="600">
           <ModalTitle noAutoClose={true} handleClose={this.handleCloseAddItemUserStatus}>
             <L>Add User Status on Item</L>
           </ModalTitle>
           <ModalBody height="100">
              <div style={{ "padding": "20px"}}>
                 <select id="userstatus_item">               
                   {massUpdItemStati}
                 </select>
                 <input type="hidden" id="addItemUserStatusItemNo"/>
                 &nbsp;&nbsp;  
                 <button id="addItemUserStatusBtn" 
                         className="btn btn-danger btn-sm"
                         onClick={this.handleAddItemUserStatus.bind(null, order)}>Add</button>
              </div>
              <div id="addItemUserStatusErrorText" style={{ "padding": "20px", fontSize: "14px", "color":"#cc4400" }}>
              </div>

           </ModalBody>
        </ModalWithClose>
        <TabBar id="itemsTab">
          {itemTab}
          {shipToAddressTab}
          {odmTab}
          {priceTab}
          {iOrderAnalysisTab}
        </TabBar>
      </div>
    )
  }
};


//----------------------------------------------------------------------
//  LaunchInSAP   --  link button, if SAP WEBUI url is available
//
//----------------------------------------------------------------------
class LaunchInSAP extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    var cl = "btn btn-primary btn-sm dropdown-toggle";
    if (this.props.size && this.props.size == "smallest") {
        cl = "btn btn-primary btn-smallest dropdown-toggle";
    }

    if ( this.props.order.tenant == 'HPICS' ) {

      if (   this.props.order.sapuiLink          == null 
          && this.props.order.sapuiLinkDisplay   == null
          && this.props.order.sapuiLinkChangeSN  == null
          && this.props.order.sapuiLinkDisplaySN == null
      ) {
        return ( <noscript/>)
      }

      var launchServiceNoti = "";
      if (this.props.order.sn_no != "") {
        launchServiceNoti =
        <ul className="dropdown-menu" role="menu">
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplay} 
              target={"ossSAPUIDisplay_"+this.props.order.so_no} 
              style={{ "cursor": "pointer" }}>Display Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLink} 
              target={"ossSAPUIChange_"+this.props.order.so_no}
              style={{ "cursor": "pointer" }}>Change Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplaySN} 
              target={"ossSAPUIDisplaySN_"+this.props.order.sn_no}
              style={{ "cursor": "pointer" }}>Display Service Notification</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkChangeSN} 
              target={"ossSAPUIChangeSN_"+this.props.order.sn_no}
              style={{ "cursor": "pointer" }}>Change Service Notification</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplayStock} 
              target={"ossSAPUIDisplayStock"}
              style={{ "cursor": "pointer" }}>Display Stock Overview</a>
          </li>                                                                                                                                         
        </ul>  
      } else {
        launchServiceNoti =
        <ul className="dropdown-menu" role="menu">
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplay} 
              target={"ossSAPUIDisplay_"+this.props.order.so_no} 
              style={{ "cursor": "pointer" }}>Display Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLink} 
              target={"ossSAPUIChange_"+this.props.order.so_no}
              style={{ "cursor": "pointer" }}>Change Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplayStock} 
              target={"ossSAPUIDisplayStock"}
              style={{ "cursor": "pointer" }}>Display Stock Overview</a>
          </li>                                                                                                                                         
        </ul>  
      }

      return (
        <div className="btn-group">
          <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
            <i className="glyphicon glyphicon-edit"/> SAP
          </button>
          {launchServiceNoti}          
        </div> 

      )

    } else {

      if ( this.props.order.sapuiLink          == null 
        && this.props.order.sapuiLinkDisplay   == null
      ) {
        return ( <noscript/>)
      }

      if (this.props.order.so_no.match(/^PR_/)) {

          var pr_no = this.props.order.so_no.substring(3);

          return (
            <div className="btn-group" style={{"margin": "0px 5px 0px 5px"}}>
              <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
                <i className="glyphicon glyphicon-edit"/> SAP
              </button>
              <ul className="dropdown-menu" role="menu">
                <li>                                    
                  <a href={this.props.order.sapuiLinkDisplay} 
                    target={"ossSAPUIDisplay_"+ pr_no } 
                    style={{ "cursor": "pointer" }}>Display Purchase Requisition</a>
                </li>                                                                                                                                         
              </ul>  
            </div>
          ) 
      }
      
      return (
      <div className="btn-group">
          <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
            <i className="glyphicon glyphicon-edit"/> SAP
          </button>
          <ul className="dropdown-menu" role="menu">
            <li>                                    
              <a href={this.props.order.sapuiLinkDisplay} 
                target={"ossSAPUIDisplay_"+this.props.order.so_no} 
                style={{ "cursor": "pointer" }}>Display Sales Order</a>
            </li>                                                                                                                                         
            <li>                                    
              <a href={this.props.order.sapuiLink} 
                target={"ossSAPUIChange_"+this.props.order.so_no}
                style={{ "cursor": "pointer" }}>Change Sales Order</a>
            </li>                                                                                                                                         
          </ul>  
        </div> 

      )
    }
  }
};


//----------------------------------------------------------------------
//  DetailedOrderStatus   --  the complete widget
//                            showing timeline + header + item + ...
//
//----------------------------------------------------------------------
class DetailedOrderStatus extends React.Component {

  constructor(props) {
    super(props);

    if (this.props.order.tenant == "HPICS" && isAdvancedExchangeServiceType(this.props.order.service_type)) {
      this.state = {
        activeItemButtons: {
          processing: false,
          shippedToCustomer : false, 
          awaitingReturn: false,
          received: false,
          canceled : false
        },
        generalUser: true
      };  

    } else if (this.props.order.order_type && this.props.order.order_type.startsWith('SOM-')) {
      this.state = {
        activeItemButtons: {
          submitted: false,
          pending: false,
          active: false,
          planned: false,
          canceled: false,
          expired: false
        },
        generalUser: true
      };

    } else {
      this.state = {
        activeItemButtons: {
          submitted: false,
          accepted: false,
          production: false,
          shipmentScheduled: false,
          consolidation: false,
          shippedToCustomer : false, 
          delivered: false,
          received: false,
          canceled : false
        },
        generalUser: true
      };  
    }

    this.handleActiveItemsToggle     = this.handleActiveItemsToggle.bind(this);

  }

  handleActiveItemsToggle(dataId){
      var selButtons = {...this.state.activeItemButtons} 
      selButtons[dataId] = selButtons[dataId] ? false : true;
      this.setState({ activeItemButtons : selButtons });
  }

  handleCloseOISreprocess() {
      console.log('handleCloseOISreprocess');
      $('#reprocessOISModal').modal('hide');
      event.preventDefault();
  } 
  handleCloseOIScancel() {
      console.log('handleCloseOIScancel');
      $('#cancelOISModal').modal('hide');
      event.preventDefault();
  }
  handleCloseOISByPass() {
   console.log('handleCloseOISByPass');
      $('#byPassOISModal').modal('hide');
      event.preventDefault();
  } 
  handleCloseAddHeaderUserStatus() {
      $('#addHeaderUserStatus').modal('hide');
      event.preventDefault();
  }


  handleAddHeaderUserStatus(order) {
      var user_status = $('#userstatus_hdr').val();
      console.log("handleAddHeaderUserStatus:", order, user_status);
      var massUpdateRequest = { 
             action: "userstatus_hdr_set",        
             user_status: user_status,
             selection: { orders: [ order.legacy_order_no ] }
      }                        
      POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest,
          function(resp) {
              console.log('massUpdateResponse=', resp); 
              var r = /SAP_PERMISSION_MISSING:(.*?)!!/.exec(resp.message);
              if (r && r[1]) {
                  $('#addHeaderUserStatusErrorText').text("Error: " + r[1]);
              } else { 
                  $('#addHeaderUserStatus').modal('hide');
                  event.preventDefault();
              }
          }      
      )
  }


  render() {

    var massUpdHeaderStati = [];
    var massUpdItemStati   = [];

    console.log("UserSettings:", UserSettings);

    if (typeof GlobalUserSettings != 'undefined') { 
        UserSettings.config = GlobalUserSettings.config;
    }
    if (UserSettings.memberOf("RemoveBlocks") && UserSettings.config && UserSettings.config.BlockManagementSetup) {

        for (var i=0; i < UserSettings.config.BlockManagementSetup.length; i++ ) {
          if (UserSettings.config.BlockManagementSetup[i].tenant == UserSettings.tenant) {
            var blk = UserSettings.config.BlockManagementSetup[i]; 
            if (blk.level == "EditableHeaderUserStati") {
                massUpdHeaderStati.push( <option value={blk.user_status}>{blk.user_status} - {blk.user_status_text} ({blk.block_category})</option> );
            }
            if (blk.level == "EditableItemUserStati") {
                massUpdItemStati.push( <option value={blk.user_status}>{blk.user_status} - {blk.user_status_text} ({blk.block_category})</option> );
            }
          }
        }
    }

    var groups = {};
    var counts = {};
    var groupCounts = {};
    var zmsoOrder = OSWidgetLib.ZMSOOrder(this.props.order);
    var somOrder  = OSWidgetLib.SOMOrder(this.props.order);
    if (this.props.order.tenant == "HPICS" && isAdvancedExchangeServiceType(this.props.order.service_type)) {
      OSWidgetLib.PrepareActiveItemGroups_CSAdvExch( this.props.order.items, groups, counts, groupCounts);
    } else if(somOrder) {
      OSWidgetLib.PrepareActiveItemGroupsForSOM( this.props.order.items, groups, counts, groupCounts);
    } else if(zmsoOrder) {
      OSWidgetLib.PrepareActiveItemGroupsForZMSO( this.props.order.items, groups, counts, groupCounts);
    } else if(this.props.order.order_type === 'ORDCHG') {
      OSWidgetLib.PrepareActiveItemGroupsForORDCHG( this.props.order.items, groups, counts, groupCounts);
    } else {
      OSWidgetLib.PrepareActiveItemGroups( this.props.order.items, groups, counts, groupCounts);
    }
    var itemGroups = {
      groups: groups,
      counts: counts,
      groupCounts: groupCounts,
    }

    let statusBlock = null;
    if (window.mobileMode) {
      statusBlock = <>
        <TopStatusSection order={this.props.order}/>
        {this.props.order.tenant != 'HPICS' && (
          <Timeline order={this.props.order} />)
        }
      </>
    } else {
      statusBlock = <>
        <div className="statusBox-left">
          <StatusGraphic order={this.props.order} itemGroupsCount={itemGroups.groupCounts} activeItemsToggle={this.handleActiveItemsToggle} activeItemButtons={this.state.activeItemButtons} tenant={UserSettings.tenant} />
        </div>
        <div className="statusBox-right">
          <div className="statusBox-buttons">
            <OswiActions order={this.props.order} generalUser={this.state.generalUser} userSettings={UserSettings} sccpItems={this.props.sccpItems}/>
          </div>
          {this.props.order.tenant != 'HPICS' &&
            (<div className="statusBox-icons">
              <StatusIcons order={this.props.order} />
            </div>)
          }
        </div>
      </>
    }

    return (

      <div>
        <div id="errorPane" style={{ display: "none", position: "relative" }}>
          <div id="errorPaneText" className="alert alert-danger errorPaneWidget"
               role="alert">
            error text
          </div>
        </div>
        <ToastContainer position='bottom-right' />
        <div id="statusBox" className="statusBox-container" style={{"minHeight": "100px"}}>
          {statusBlock}
        </div>
        <br/>
        <HeaderTabs order={this.props.order} userSettings={this.props.userSettings} orderAnalysis={this.props.orderAnalysis} updateOrderAnalysis={this.props.updateOrderAnalysis} />
        <br/><br/>
        <ItemTabs order={this.props.order} updateSCCPItems={this.props.updateSCCPItems} orderAnalysis={this.props.orderAnalysis} />

        <ModalWithClose id="reprocessOISModal" off_handleClose={this.handleCloseOISreprocess} closeButtonText={T('Close')} width="800">

           <ModalTitle off_handleClose={this.handleCloseOISreprocess}>
             <L>Reprocess OIS document</L>
           </ModalTitle>

           <ModalBody height="515">
              <div style={{ "padding": "10px"}}>
                  <div id="reprocessOISAwait" style={{ "display": "none"}}>
                       <label className="col-sm-4 control-label">
                           requesting OIS reprocessing ... &nbsp;&nbsp;
                           <img height="28" src={spinning_small}/>
                           &nbsp;&nbsp;
                       </label>
                  </div>
                  <div id="reprocessOISResult" style={{"display": "none"}} >
                     the result...
                  </div>                                                      
              </div>
              <p><br/><br/></p>
           </ModalBody>
        </ModalWithClose>

        <ModalWithClose id="cancelOISModal" handleClose={this.handleCloseOIScancel} closeButtonText={T('Close')} width="800">

           <ModalTitle handleClose={this.handleCloseOIScancel}>
             <L>Cancel OIS document</L>
           </ModalTitle>

           <ModalBody height="515">
              <div style={{ "padding": "10px"}}>
                  <div id="cancelOISAwait" style={{ "display": "none"}}>
                       <label className="col-sm-4 control-label">
                           requesting OIS cancelation ... &nbsp;&nbsp;
                           <img height="28" src={spinning_small}/>
                           &nbsp;&nbsp;
                       </label>
                  </div>
                  <div id="cancelOISResult" style={{"display": "none"}} >
                     the result...
                  </div>                                                      
              </div>
              <p><br/><br/></p>
           </ModalBody>
        </ModalWithClose>

        <ModalWithClose id="byPassOISModal" handleClose={this.handleCloseOISByPass} closeButtonText={T('Close')} width="800">

           <ModalTitle handleClose={this.handleCloseOISByPass}>
             <L>Skip OIS Simulation</L>
           </ModalTitle>

           <ModalBody height="515">
              <div style={{ "padding": "10px"}}>
                  <div id="byPassOISAwait" style={{ "display": "none"}}>
                       <label className="col-sm-4 control-label">
                           requesting OIS Simulation Skipping ... &nbsp;&nbsp;
                           <img height="28" src={spinning_small}/>
                           &nbsp;&nbsp;
                       </label>
                  </div>
                  <div id="byPassOISResult" style={{"display": "none"}} >
                     the result...
                  </div>
              </div>
              <p><br/><br/></p>
           </ModalBody>
        </ModalWithClose>

        <ModalWithClose id="addHeaderUserStatus" handleClose={this.handleCloseAddHeaderUserStatus} closeButtonText={T('Close')} width="600">

           <ModalTitle noAutoClose={true} handleClose={this.handleCloseAddHeaderUserStatus}>
             <L>Add User Status on Header</L>
           </ModalTitle>

           <ModalBody height="100">
              <div style={{ "padding": "20px"}}>
                 <select id="userstatus_hdr">               
                   {massUpdHeaderStati}
                 </select>                                                                    
                 &nbsp;&nbsp;  
                 <button id="addHeaderUserStatusBtn" className="btn btn-danger btn-sm"
                         onClick={this.handleAddHeaderUserStatus.bind(null, this.props.order)}>Add</button>
              </div>
              <div id="addHeaderUserStatusErrorText" style={{ "padding": "20px", fontSize: "14px", "color":"#cc4400" }}>
              </div>

           </ModalBody>
        </ModalWithClose>



      </div>
    )
  }
};

//----------------------------------------------------------------------
//  OrderSelectListInt   --  list for selecting an order
//                           in case multiple orders match filter
//
//----------------------------------------------------------------------
class OrderSelectListInt extends React.Component {

  constructor(props) {
    super(props);
  }

  handleClick(legacy_order_no) {

    var Params = {
        lookupType: "legacy_order_no",
        lookupValue: legacy_order_no,
        callingSystem: 'quicksearch'
    }
    var self = this;

    //console.log(test+" : "+legacyOrderNo);
    GET("/os/ossui/v1/in/widget/order", Params,
    function(resp) {
          //console.log(resp);

          if (resp.status == 'N') {

              alert(resp.message);

          } else {
              console.log(resp.data);
              // now show everything
              //$('#ossOrderModal').modal('hide');

              ReactDOM.render(
                <OSWidgetInt
                  order={resp.data}
                  quickSearchResp={resp.data}/>
                , document.getElementById('internalWidget')
              );

              //$('#ossOrderModal').modal({
              //    backdrop: 'static'
              //});
          }
       }
    );
  }

  render() {

    var order  = this.props.order;
    //console.log("I came listint:");
    var self = this;
    if (typeof Params === 'undefined') {
      var params = {};
    } else {
      var params = Params;
    }

    params.lookupType = 'legacy_order_no';
    console.log(order);
    console.log("======");
    var orders = {
      header: [
        { name: T('HP Order'               ) },
        { name: T('Purchase Order Date'    ) },
        { name: T('Customer Purchase Order') },
        { name: T('Order Type'             ) },
        { name: T('Customer Name'          ) },
        { name: T('Status'                 ) },
        { name: T('Invoice#'               ) },
        { name: T('Shipment#'              ) , width: "60%" }
      ],
      data: order.map( function(row) {
              return [
                <a onClick={self.handleClick.bind(null, row.legacy_order_no)} style={{ "cursor": "pointer" }}>{row.order_no}</a>,
                fmDate(row.purch_order_date),
                row.purchase_order_no,
                row.order_type,
                row.customer_name,
                row.order_overall_status,
                row.invoice_no,
                row.shipment_no
              ]
            })
    }

    return (
      <div>
        <div id="errorPane" style={{ display: "none", position: "relative" }}>
          <div id="errorPaneText" className="alert alert-danger errorPaneWidget"
               role="alert">
            error text
          </div>
        </div>
        <SimpleDataGrid header={orders.header} data={orders.data.sort()}/>
      </div>
    );
  }
};

//----------------------------------------------------------------------
//   OSWidgetInt -- the internal widget with the modal wrapper
//
//----------------------------------------------------------------------
export class OSWidgetInt extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      generalUser: true,
      dataDict: [],
      sccpItems: [],
      orderAnalysis: []
    }

    this.updateSCCPItems = this.updateSCCPItems.bind(this);
    this.updateOrderAnalysis = this.updateOrderAnalysis.bind(this);

    if (typeof UserSettings == "undefined" && typeof window.UserSettings != "undefined") {
        UserSettings = window.UserSettings;
    }
  }

  handleShowNotes( legacy_order_no ) {
    console.log('handleShowNotes:',legacy_order_no);
    OrderNotes_Open(legacy_order_no);
  }
 
  handlePinned( e) {
      console.log('handlePinned', e.target);
      var pinnedStatus = "off"
      if (/pinned_off/.test( e.target.src )) pinnedStatus = "on"
      var xhttp = new XMLHttpRequest();
      var img = e.target;
      xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
              img.src = '/os/img/pinned_'+pinnedStatus+'.png'
          }
      };
      var os = e.target.getAttribute('lno');
      xhttp.open("POST", "/os/ws/osvHelper.tcl?type=ajax&pinned="+pinnedStatus+"&os_no="+os, true)
      xhttp.send();    
  }

  componentDidMount() {

    var properties = ['name', 'short_desc', 'db_field', 'int_widget_field', 'int_rep_field', 'bmt_field']
    DataDict.custom('int_widget', properties, function(dataDict) {
      this.setState({ dataDict: dataDict });
    }.bind(this), errorHandler);

    $(document).on('click', '.dropdown-menu .dropInfoWin', function (e) {
      console.log('.dropdown-menu dropInfoWin e.stopPropagation');
      e.stopPropagation();
    });

    if (is3wAdvUser(UserSettings) && !isProdHpics(UserSettings)) {
      this.setState({ generalUser: false});
    }
  }

  updateSCCPItems(sccpItemsNew) {
    this.setState({sccpItems: [...sccpItemsNew]});
  }

  updateOrderAnalysis(orderAnalysis) {
    this.setState({orderAnalysis: [...orderAnalysis]});
  }

  render() {

    I18N.setLocale("en");
    
    var width = "995px";
    if (this.props.width) {
      width = this.props.width;
    }

    if (this.props.userSettings) {    
      UserSettings.groups  = this.props.userSettings.groups  ? this.props.userSettings.groups  : UserSettings.groups;
      UserSettings.levels  = this.props.userSettings.levels  ? this.props.userSettings.levels  : UserSettings.levels;
      UserSettings.val     = this.props.userSettings.val     ? this.props.userSettings.val     : UserSettings.val;
      UserSettings.tenant  = this.props.userSettings.tenant  ? this.props.userSettings.tenant  : UserSettings.tenant;
      UserSettings.user_id = this.props.userSettings.user_id ? this.props.userSettings.user_id : UserSettings.user_id;

    }
    var order = this.props.order;

    if (!UserSettings.memberOf('ShowRestrictedFields') || !UserSettings.isValidAcv(this.props.order.acv, '300')) {
      for (const key in order) {
        if (key.includes('price') || key.includes('payment') || key.includes('tax') || key.includes('currency')) {
          order[key] = "";
        }
      }

      for (var i=0; i < order.items.length; i++) {
        for (const key in order.items[i]) {
          if (key.includes('price') || key.includes('payment') || key.includes('tax') || key.includes('currency')) {
            order.items[i][key] = "";
          }
        }
      }
    }

    console.log(this.props.order);
    var quickSearchResp = this.props.quickSearchResp;

    if (order.length > 1) {
      quickSearchResp = this.props.order;
    }

    if ( quickSearchResp && quickSearchResp.length > 1 ) {
      console.log( 'Multiple orders matching filter criteria...' );
      return (
        <ModalWithClose id="ossOrderModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width={width}>

          <ModalTitle handleClose={handleCloseModal}>
            <L>Multiple orders found</L>
            &nbsp;-&nbsp;
            <L>Please select</L>:
          </ModalTitle>

          <ModalBody>
            <NewOrderSelectListInt orders={quickSearchResp} searchVal={this.props.searchVal}/>
          </ModalBody>

        </ModalWithClose>
      )

    } else {

      if (window.mobileMode) {
        var reducedTopPadding = ".modal-body { padding: 4px 3px 6px 3px;}";
      } else {
        var reducedTopPadding = ".modal-body { padding: 15px 15px 15px 15px;}";
      }
      var noteColor = "#999";

      var now = new Date();
      var t = new Date( order.overall_notes_lupd );
      var timeDiff = ((now - t) / 1000) / 3600.0;

      if (timeDiff <  12.0) { noteColor = "#0b0" }
      else if (timeDiff <  48.0) { noteColor = "#ffd500" }
      else if (timeDiff >= 48.0) { noteColor = "#0096d6" }

      var goBack     = null;
      var hideClose  = false;
      var leasingImg = "";

      if (order.is_leasing_order == "Y") {
          leasingImg = <img src={is_leasing_ico} height="20" title="Leasing Order"></img>
      }

      if (this.props.withoutModal) {
          goBack = <button onClick={() => this.props.history.goBack()} className="bar-page-options-go-back"></button>
          hideClose = true;
      } 

      var topAlign = '-3px';
      if (window.mobileMode) {     
          topAlign = '1px';
      }

      var pinnedIcon = <img src="/os/img/pinned_off.png" width="13" height="18" hspace="4" title="you did not pinned this order"
                            onClick={this.handlePinned.bind(this)} lno={order.legacy_order_no} />
      if (order.pinned) {
           pinnedIcon = <img src="/os/img/pinned_on.png" width="13" height="18" hspace="4" title="pinned by you" 
                            onClick={this.handlePinned.bind(this)} lno={order.legacy_order_no} />
      }

      var notesIcon = <a onClick={this.handleShowNotes.bind(null,order.legacy_order_no)} style={{"marginLeft":"3px", "fontSize":"13px", "color": "#0096d6" }}>
                        <i className="glyphicon glyphicon-tags" style={{"cursor": "pointer", "top": {topAlign}, "color": noteColor }}/>
                      </a>
      if (window.mobileMode) {
          notesIcon = <a href={"/static/dist/mobile/dashboard/HpOrderNotes/" + order.legacy_order_no} style={{"marginLeft":"3px", "fontSize":"13px", "color": "#0096d6" }}>
                        <i className="glyphicon glyphicon-tags" style={{"cursor": "pointer", "top": {topAlign}, "color": noteColor }}/>
                      </a>
      }

      var tenant = UserSettings.tenant ? UserSettings.tenant : userSettings.tenant;
      var titleLabel = "",dmfiLabel = "";

      if ( tenant != "HPICS" || order.sn_no == '' ) {
        if ( order.purchase_order_no != '' ) {
          titleLabel = window.mobileMode ? <span>{T('PO: ' + order.purchase_order_no)}</span> : <span>{T('Purchase Order: ' )} <span className="heading-weight">{order.purchase_order_no}</span></span>;
        }
      } else {
        titleLabel   = window.mobileMode ? <span>{T('SN No: ' + order.sn_no)}</span> : <span>{T('Service Notification No: ')} <span className="heading-weight">{order.sn_no}</span></span>;
      }

      if (["DMFi", "Multichannel DMFi", "Multichannel STM"].includes(this.props.order.trade_model) && this.props.order.partner_purch_order_no != "") {
        dmfiLabel = <span>{T('Partner Purchase Order: ')} <span className="heading-weight">{this.props.order.partner_purch_order_no}</span></span>;
      }

      var extraDetails = ( OSWidgetLib.ZMSOOrder(this.props.order) ? " (ZMSO)" : "" )

      var parentObject = "";
      var pStyle       = {};
      if (  (this.props.order.vparent_trade_order  && this.props.order.vparent_trade_order  != "")
         || (this.props.order.vparent_return_order && this.props.order.vparent_return_order != "")
         || (this.props.order.vparent_credit_order && this.props.order.vparent_credit_order != "")
      ) {
          var linkTradeOrder  = "";
          var linkReturnOrder = "";
          var linkCreditOrder = "";
          if (this.props.order.vparent_trade_order  && this.props.order.vparent_trade_order  != "") {
              var [ p_lno, p_order_no, p_hpRecvDate, p_orderTypeDescr, p_orderType ] = this.props.order.vparent_trade_order.split('~')
              linkTradeOrder = <li>
                                 <a style={{ cursor: "pointer"}} target="_blank" href={"?lookupType=legacy_order_no&lookupValue="+p_lno}>
                                   <span style={{ minWidth: "12ex", display: "inline-block"}}>{p_order_no}</span>
                                   <span style={{ minWidth: "12ex", display: "inline-block"}}>{fmDate(p_hpRecvDate)}</span>
                                   {p_orderTypeDescr} ({p_orderType})
                                 </a>
                               </li>
          }
          if (this.props.order.vparent_return_order  && this.props.order.vparent_return_order  != "") {
            var [ p_lno, p_order_no, p_hpRecvDate, p_orderTypeDescr, p_orderType ] = this.props.order.vparent_return_order.split('~')
            linkReturnOrder = <li>
                                <a style={{ cursor: "pointer"}} target="_blank" href={"?lookupType=legacy_order_no&lookupValue="+p_lno}>
                                  <span style={{ minWidth: "12ex", display: "inline-block"}}>{p_order_no}</span>
                                  <span style={{ minWidth: "12ex", display: "inline-block"}}>{fmDate(p_hpRecvDate)}</span>
                                  {p_orderTypeDescr} ({p_orderType})
                                </a>
                              </li>
          }
          if (this.props.order.vparent_credit_order  && this.props.order.vparent_credit_order  != "") {
            var [ p_lno, p_order_no, p_hpRecvDate, p_orderTypeDescr, p_orderType ] = this.props.order.vparent_credit_order.split('~')
            linkCreditOrder = <li>
                                <a style={{ cursor: "pointer"}} target="_blank" href={"?lookupType=legacy_order_no&lookupValue="+p_lno}>
                                  <span style={{ minWidth: "12ex", display: "inline-block"}}>{p_order_no}</span>
                                  <span style={{ minWidth: "12ex", display: "inline-block"}}>{fmDate(p_hpRecvDate)}</span>
                                  {p_orderTypeDescr} ({p_orderType})
                                </a>
                              </li>
          }
          parentObject =
            <div className="btn-group">
              <button type="button" className="btn btn-primary btn-smallest dropdown-toggle" data-toggle="dropdown" title={T('Parent Objects')}
                      style={{margin: "0 0 1px 4px", padding: "0 2px", fontSize: "10px"}}
              >
                &#9650;
             </button>
             <ul className="dropdown-menu" role="menu">
               {linkTradeOrder}
                {linkReturnOrder}
                {linkCreditOrder}
              </ul>
           </div>
           pStyle = parentObject ? {overflow:"unset"} : {} ;
      }

      var wTitle =
          <ModalTitle handleClose={handleCloseModal} hideClose={hideClose} style={pStyle}>
            <span style={{"fontSize": "12px", "color": "#777777", "float": "right", "textAlign": "right", "marginTop": "5px", "marginRight": "20px"}}>
              <strong>Last Order Update:</strong> {fmDateTime(this.props.order.last_update)}
            </span>
            {goBack}   
            {this.props.order.order_type_descr}{extraDetails}: <span className="heading-weight">{order.order_no}{parentObject}</span>
            <Notification legacy_order_no={this.props.order.legacy_order_no} hp_order_no={this.props.order.order_no}/>
            {!window.mobileMode ? pinnedIcon : ""}
            {notesIcon}&nbsp;&nbsp;&nbsp;{titleLabel}&nbsp;&nbsp;&nbsp;{leasingImg}
            {this.props.order.trade_model == 'DMFi' ? <br/> : ''}
            {dmfiLabel}
            {
              UserSettings && UserSettings.config?.maintMsg
              ? <MaintMsgModal msg={UserSettings.config.maintMsg} />
              : null
            }
          </ModalTitle>

      var wBody =
          <ModalBody>
            <DetailedOrderStatus order={order} userSettings={this.props.userSettings} updateSCCPItems={this.updateSCCPItems} sccpItems={this.state.sccpItems} orderAnalysis={this.state.orderAnalysis} updateOrderAnalysis={this.updateOrderAnalysis} />
            <div id="remblockbody" />
            {window.wrapperMode ? <Chatbot /> : null}
          </ModalBody>

      var wFooter =
          <ModalFooter>
            <div>

              <div style={{"display":"inline", "float": "left", "textAlign":"left"}}>
                <ExportExcelOrder order={order}/>
                { tenant !== 'HPICS' && <SandyExternalLink order={order}/> }
                &nbsp;
                { !OSWidgetLib.ZMSOOrder(this.props.order) && <InitSFDCWorkflow order={order} locale={I18N.locale} isValidDwGroupUser={UserSettings.memberOf('SupportRequests')} sccpItems={this.state.sccpItems}/> }
              </div>

            </div>
          </ModalFooter>

      if (this.props.withoutModal) {
          return (
            <div id="ossOrderFlat" width={width} >

              {wTitle}
              <style>{reducedTopPadding}</style>
              {wBody} 
              {window.mobileMode ? wFooter : null}
            </div>
          )
      }
      return (
        <Modal id="ossOrderModal" width={width} >

          {wTitle}
          <style>{reducedTopPadding}</style>
          {wBody} 
          {window.mobileMode ? wFooter : null}
        </Modal>
      );
    };
  }
};

class SchedLines extends React.Component {

  constructor(props) {
    super(props);
  }

  handleClick(legacy_order_no) {

    var Params = {
        lookupType: "legacy_order_no",
        lookupValue: legacy_order_no,
        callingSystem: 'quicksearch'
    }
    GET("/os/ossui/v1/in/widget/order", Params,function(resp) {

      if (resp.status == 'N') {
          alert(resp.message);
      } else {
        $('#ossOrderModal').modal('hide');

        ReactDOM.render(
          <OSWidgetInt
            order={resp.data}
            quickSearchResp={resp.data}/>
          , document.getElementById('internalWidget')
        );

        $('#ossOrderModal').modal({ backdrop: 'static' });
      }
    });
  }

  render() {

    var order = this.props.data;

    //console.log("GEGA SCHED");
    if (order.schedLines) {
      //console.log("schedLines Existing")
    } else {
      //console.log("schedLines Not Existing")
      order.schedLines = [];
    }

    var rowDetails =
      <tr>
        <td><a onClick={this.handleClick.bind(null,order.legacy_order_no)} style={{ "cursor": "pointer" }}>{order.order_no}</a></td>
        <td>{fmDate(order.purch_order_date)}</td>
        <td>{order.purchase_order_no}</td>
        <td>{order.order_type}</td>
        <td>{order.customer_name}</td>
        <td>{order.order_overall_status}</td>
        <td>{order.schedLines.length > 0 ? order.schedLines[0].shipment_no : null}</td>
        <td>{order.schedLines.length > 0 ? order.schedLines[0].invoice_no  : null}</td>
      </tr>
      {
        order.schedLines.map(function(sched_Line,i) {
          if(i>0) {
            return (
              <tr>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
               <td>{sched_Line.shipment_no}</td>
               <td>{sched_Line.invoice_no}</td>
              </tr>
            );
          }
        });        
      }
 
    return rowDetails;
  }
};


class NewOrderSelectListInt extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var orders = this.props.orders;

    //alert(orders)
    console.log(orders);

    var OrdersList = orders.map(function(order,i){
       return <SchedLines data={order} />
    });

    var searchVal = this.props.searchVal;
    setTimeout( function() {
      $("#orderSelectList td").highlight(searchVal,'highlighted');
      $("#orderSelectList td a").highlight(searchVal,'highlighted');
    }, 100);

    return (
      <div>
          <div id="errorPane" style={{ display: "none", position: "relative" }}>
            <div id="errorPaneText" className="alert alert-danger errorPaneWidget" role="alert">
            error text
            </div>
          </div>
        <table className="table" id="orderSelectList">
        <thead>
          <tr>
            <th>HP Order</th>
            <th>Purchase Order Date</th>
            <th>Customer Purchase Order</th>
            <th>Order Type</th>
            <th>Customer Name</th>
            <th>Status</th>
            <th>Shipment</th>
            <th>Invoice</th>
          </tr>
          </thead>
          <tbody>
            {OrdersList}
          </tbody>
        </table>
      </div>
    );
  }
};

// GEGA: Merge this function (which is used twice) to components with simplify project
class MFGListPopUp extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    var headerRow =
              <tr>
                  <th><L>Item</L></th>
                  <th><L>Product</L></th>
                  <th><L>Shipment</L></th>
                  <th><L>Serial Number</L></th>
                  <th><L>Equipment ID</L></th>
                  <th><L>Asset Tag</L></th>
                  <th><L>Primary Mac Address</L></th>
              </tr>;

    var param = '';
    if (this.props.b2bparameters && this.props.b2bparameters != "") {                                   
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    var data_source = this.props.data_source;
    var showMacAddress = true;
    if (!UserSettings.memberOf('ShowRestrictedFields')) {
      showMacAddress = false;
    }
    var lineDetails = this.props.mfgList.map( function(row,i) {

        return (
          <tr><td>{row.so_item_no}</td><td>{row.material_no}</td><td>{row.shipment_no}</td><td>{row.serial_number}</td><td>{row.equipment_number}</td><td>{row.asset_tag}</td><td>{showMacAddress ? row.primary_mac_addr : ""}</td>
          </tr>
          )
    });

    return(
      <div style={{"overflow":"auto","height":"330px"}}>
        <table className="table table-hover table-inv">
          <thead>
           {headerRow}
          </thead>
          <tbody>
            {lineDetails}
          </tbody>
        </table>
      </div>
    );
  }
};

export class InvoiceListPopUp extends React.Component {

  //GEGA TODO, CHANGE LINKS AND ALSO SEE WHY THE RED DLL BUTTON IS MISSIN ??!
  constructor(props) {
    super(props);
    this.handleDownloadAll = this.handleDownloadAll.bind(this);
  }

  handleDownloadAll() {
    window.open ("/static/dist/invoiceStatusInt.html?legacy_order_no=" + this.props.legacy_order_no + "&type=in&order_no=" + this.props.order_no, "downloadwindow","menubar=1,resizable=1,width=450,height=450");
  }

  render() {
    var invoiceStatus = "";
    var downloadAllInvoice="";

    if(this.props.invoiceStatus=="PI") {

      invoiceStatus="(Partially Invoiced)"
    }

    if(this.props.invoiceStatus=="FI") {

      downloadAllInvoice="Download All Invoice"

    }

    var patt = new RegExp("SAP-FAP2");
    var patt1 = new RegExp("SAP-AP");
    var patt2 = new RegExp("QAD-.*");
    var prepaymentUnique = [];
    var advanceInvoice = "";
    var preInvoice = "";

    var headerRow =
      <tr>
        <th><L>Invoice No</L></th>
        <th style={{"textAlign": "right"}}><L>Invoice Date</L></th>
        <th style={{"textAlign": "right"}}><L>Invoice Amount</L></th>
        <th><L>Download Document</L></th>
      </tr>;

    if(patt.test(this.props.data_source) || patt1.test(this.props.data_source) || patt2.test(this.props.data_source) || window.mobileMode) {
      headerRow =
      <tr>
        <th><L>Invoice No</L></th>
        <th style={{"textAlign": "right"}}><L>Invoice Date</L></th>
        <th style={{"textAlign": "right"}}><L>Invoice Amount</L></th>
      </tr>;
    }

    var showPrices = true;
    if (!UserSettings.memberOf('ShowRestrictedFields') || !UserSettings.isValidAcv(this.props.acv, '300') || window.mobileMode) {
      showPrices = false;
    }

    console.log(this.props.invoiceList);

    var invoices=this.props.invoiceList.map(function(row,i){


      var url="/os/ossui/v1/in/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.data_source;

      // CR 15559 - deactivate invoice link for QAD
      if ( row.system == "QAD-IL" || row.system == "QAD-JP" || row.system == "QAD-NL" ||  row.system == "QAD-US" || window.mobileMode ) {
        url = '';
      }

      if (row.pre_payment_advance_invoice && !prepaymentUnique.includes(row.prepayment_advance_inv)) {
        if (row.advance_invoice_date != "") {
           preInvoice = <tr><td>{row.pre_payment_advance_invoice + " - PrePayment Invoice"}</td><td style={{"textAlign": "right"}}>{fmDate(row.pre_payment_invoice_date)}</td><td style={{"textAlign": "right"}}>{''} &nbsp; &nbsp; {''}</td> 
          <td><a className={classString} href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a></td></tr> 
          advanceInvoice = <tr><td>{row.pre_payment_advance_invoice + " - Advance Invoice"}</td><td style={{"textAlign": "right"}}>{fmDate(row.advance_invoice_date)}</td><td style={{"textAlign": "right"}}>{''} &nbsp; &nbsp; {''}</td> 
          <td><a className={classString} href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a></td></tr>
        } else {
          preInvoice = <tr><td>{row.pre_payment_advance_invoice + " - PrePayment Invoice"}</td><td style={{"textAlign": "right"}}>{fmDate(row.pre_payment_invoice_date)}</td><td style={{"textAlign": "right"}}>{''} &nbsp; &nbsp; {''}</td> 
          <td><a className={classString} href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a></td></tr> 
        }
        prepaymentUnique.push(row.pre_payment_advance_invoice);
      }

      var net_price = row.net_price;

      if(patt.test(this.props.data_source) || patt1.test(this.props.data_source) || patt2.test(this.props.data_source) || window.mobileMode) {
        return (
          <tr><td>{row.invoice_no}</td><td style={{"textAlign": "right"}}>{fmDate(row.invo_actual)}</td><td style={{"textAlign": "right"}}>{showPrices ? fmNum(net_price) : ''} &nbsp; &nbsp; {showPrices ? row.currency : ''}</td>
          </tr>
        )
      } else {
        var classString = '';
        if (!showPrices) {
          classString = classString + ' disabledPrice';
        }
        return (
          <tr><td>{row.invoice_no}</td><td style={{"textAlign": "right"}}>{fmDate(row.invo_actual)}</td><td style={{"textAlign": "right"}}>{showPrices ? fmNum(net_price) : ''} &nbsp; &nbsp; {showPrices ? row.currency : ''}</td>
          <td><a className={classString} href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a></td></tr>
        )
      }
    }.bind(this));

    if(this.props.invoiceList.length==0) {
        invoices=
        <tr><td><L>No Invoice found</L></td></tr>
    }

    if (this.props.modalView == "invoices") {
      var reducedTopPadding = ".modal-body { padding: 5px 15px 15px 15px;}";
      return(
        <ModalWithClose id="ossInvoiceModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width="620px" >
          <ModalTitle hideClose={true}>
            <InvoicePopupWrapperClass
              handleDownloadAllInvs={this.handleDownloadAll}
              order={
                {
                  legacy_order_no : this.props.legacy_order_no,
                  order_no        : this.props.order_no,
                  data_source     : this.props.data_source,
                  acv             : this.props.acv
                }
              }/>
          </ModalTitle>
          <style>{reducedTopPadding}</style>
          <ModalBody>
            <div style={{"overflow":"auto","height":"330px"}}>
              <table className="table table-hover table-inv">
                <thead>
                {headerRow}
                </thead>
                <tbody>
                  {preInvoice}
                  {advanceInvoice}
                  {invoices}
                </tbody>
              </table>
            </div>
          </ModalBody>

        </ModalWithClose>      
      );
    } else {
      return(
        <div style={{"overflow":"auto","height":"330px"}}>
          <table className="table table-hover table-inv">
            <thead>
            {headerRow}
            </thead>
            <tbody>
              {preInvoice}
              {advanceInvoice}
              {invoices}
            </tbody>
          </table>
        </div>
      );
    }
  }
};


function ShpTypeIcon ( shipping_type )
{
   if (shipping_type.toLowerCase() == "train"   ) return <img src={train_icon}/>;
   if (shipping_type.toLowerCase() == "rail"    ) return <img src={train_icon}/>;
   if (shipping_type.toLowerCase() == "airplane") return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "air")      return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "vessel"  ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "sea"     ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "ocean"   ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "ship/air") return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "a0"      ) return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "a1"      ) return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "m"       ) return <img src={Shipping_RGB_blue_NT} height="16"/>;
   // M->Truck mapping after discussion with Titus and Oliver, this is for seen for VISTA orders
   return  <img height="16" src={Shipping_RGB_blue_NT} />
}


class ShipmentListPopUp extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    var shipmentStatus = "";
    var OMSystem = this.props.OMSystem;
    var handleTracknTrace = this.props.handleTracknTrace;
    var handlePodImage = this.props.handlePodImage;
    var TATPreURL = this.props.TATPreURL;

    var podImgColHdr = "";
    if ( 1 || OMSystem == "SAP-R01" || OMSystem == "SAP-CPO" || OMSystem == "SAPCPO" || OMSystem == "SAPCPO" ) {
      podImgColHdr = <th style={{"textAlign": "center"}}><L>Download POD</L></th>
    }

    var shipments = this.props.shipmentList.map( function(row,i) {

      if (row.ignore) return <noscript/>;

      var podImgCol = "";
      var podColSpan = "8";

      if ( 1 || OMSystem == "SAP-R01" || OMSystem == "SAP-CPO" || OMSystem == "SAPCPO" || OMSystem == "SAPCPO" ) {

        if ( row.podexists == 1 ) {
          var podImg = <a title='download or view POD scan image' style={{"padding":"3px"}} onClick={(function(a, event){handlePodImage(row.legacy_order_no,row.shipmentno,row.carriername,row.trackingno,row.hpdeliveryno,TATPreURL)}).bind(this)}><img height="18" src={Bill_RGB_green_NT}/></a>;
        } else {
          var podImg = <img height="16" src={Bill_RGB_gray_NT}/>;
        }

        podImgCol = <td style={{"textAlign": "center"}}>{podImg}</td>;
        var podColSpan = "9";
      }

      var tNTButton = <L>{row.trackingno}</L>;
      if (row.tnt_url && row.tnt_url != "") {
        var hurl = row.tnt_url.split("")
           .map(c => c.charCodeAt(0).toString(16).padStart(2, "0"))
           .join("");
        var TNTUrl = `/os/ws/osvHelper?shipment=${row.shipmentno}&order=${row.legacy_order_no}&tracktracepunchout=${hurl}`
        tNTButton = 
                      <a type="button" className="btn btn-primary btn-sm" href={TNTUrl}  target='OSSTandT'>
                        <L>{row.trackingno}</L>&nbsp;<i className="glyphicon glyphicon-new-window"/>
                      </a>;
      }

      if (row.ship_to_addr_6 == "") {
        var ShipAddr = <span>{row.ship_to_addr_1}<br/>{row.ship_to_addr_5}</span>
      } else {
        var ShipAddr = <span>{row.ship_to_addr_1}<br/>{row.ship_to_addr_5}<br/>{row.ship_to_addr_6}</span>
      }

      var now = new Date();
      var t   = new Date(row.sched_delv_date);
      var timediff = ((now - t) / 1000) / 3600.0 / 24;

      var House = house_gray;
   
      var DDate = <span>Planned Delivery {fmDate(row.sched_delv_date)}</span>;
      if (row.deliverydate != "") {
        DDate = <span style={{"color": "green"}}>{podImg} Delivery Date {fmDate(row.deliverydate)}</span>;
        House = house_green;
      } else if (row.pod_at != "") {
        DDate = <span style={{"color": "green"}}>{podImg} Delivery Date {fmDate(row.pod_at)}</span>;
        House = house_green;
      }

      var CommentLine = "";
      if (row.sdd_comment != "") {
        CommentLine  = <span>{T('Comment')}: {T(row.sdd_comment)}</span>;
      }
      
      var leg1line = blue_arrow_right_line;
      var leg1end  = blue_arrow_right_end;

      var leg2line = gray_arrow_right_line;
      var leg2end  = gray_arrow_right_end;

      if (row.deliverydate != "" || row.pod_at != "") {
        var leg2line = blue_arrow_right_line;
        var leg2end  = blue_arrow_right_end;
      }

      var xdockImage = xdock;

      if (  row.xdock_reg_date != "" 
         || row.xdock_reg_date != "" 
         || row.deliverydate   != "" 
         || row.pod_at != ""
      ) {
          var xdockImage = xdock_blue;
      }



      var item_no = row.item_no.replace(/ /g, "\n");
      var product = row.product.replace(/ /g, "\n");

      var product_descr = row.product_descr.replace(/@/g, "\n");
      var shipped_qty = row.shipped_qty.replace(/ /g, "\n");

      var headerRow =
            <tr>
                <th style={{"textAlign": "center"}}><L>Item</L></th>
                <th style={{"textAlign": "center"}}><L>Product</L></th>
                <th style={{"textAlign": "center"}}><L>Description</L></th>
                <th style={{"textAlign": "center"}}><L>Qty</L></th>
            </tr>;

      var prodRow = 
            <tr>
                <td style={{"textAlign": "center", "whiteSpace": "pre-wrap"}}>{item_no}</td>
                <td style={{"textAlign": "center", "whiteSpace": "pre-wrap"}}>{product}</td>
                <td style={{"textAlign": "center", "whiteSpace": "pre-wrap"}}>{product_descr}</td>
                <td style={{"textAlign": "center", "whiteSpace": "pre-wrap"}}>{shipped_qty}</td>
            </tr>;

      if (row.routeDetails.firstShippingType != "" && row.routeDetails.firstShippingType != "?") {
          var leg1shippingType = ShpTypeIcon(row.routeDetails.firstShippingType);
      } else {
          var leg1shippingType = ShpTypeIcon(row.routeDetails.mainShippingType);
      }
      if (row.routeDetails.lastShippingType != "" && row.routeDetails.lastShippingType != "?") {
          var leg2shippingType = ShpTypeIcon(row.routeDetails.lastShippingType);
      } else {
          var leg2shippingType = ShpTypeIcon(row.routeDetails.mainShippingType);
      }
        
      var firstCarrier = row.carriername;
      if (row.routeDetails.firstCarrier && row.routeDetails.firstCarrier != "") {
          firstCarrier = row.routeDetails.firstCarrier;
      } 
      var lastCarrier = row.carriername;
      if (row.routeDetails.lastCarrier && row.routeDetails.lastCarrier != "") {
          lastCarrier = row.routeDetails.lastCarrier;
      } 

      if (row.multi_leg == "Y" ) {

        var logisticTimeline = 
          <table className="logisticTimeline" border="0">

            <tr className="ltDates">
                <td colSpan="2" style={{"textAlign": "left" }}>{fmDate(row.shipped_at)}</td>
                <td colSpan="3" style={{"textAlign": "right"}}>{fmDate(row.xdock_reg_date)}</td> 
                <td></td>                                
                <td colSpan="2" style={{"textAlign": "left" }}>{fmDate(row.xdock_dep_date)}</td>
                <td colSpan="4" style={{"textAlign": "right"}} nowrap="true">{DDate}</td>
            </tr>

      
            <tr className="ltIcons">
                <td rowSpan="2" style={{"verticalAlign":"bottom", "width": "30px"}}><img src={factory}/></td>
                <td colSpan="3" style={{"verticalAlign":"bottom", "textAlign": "center", "width": "38%"}}>{leg1shippingType}</td>
                <td></td>                                                                     
                <td rowSpan="2" style={{"verticalAlign":"bottom", "width": "30px"}}      ><img src={xdockImage} title={T('crossDockImage')} /></td>
                <td colSpan="5" style={{"verticalAlign":"bottom", "textAlign": "center"}}>{leg2shippingType}</td>
                <td rowSpan="2" style={{"verticalAlign":"bottom", "width": "30px"}}      ><img src={House}/></td>
            </tr>
      
            <tr>
              <td><img src={leg1line} width="100%" height="15"/></td>
              <td><img src={leg1line} width="100%" height="15"/></td>
              <td><img src={leg1line} width="100%" height="15"/></td>     
              <td style={{"width": "5px"}}><img src={leg1end}/></td>          
              <td style={{"width": "5px"}}><img src={leg2line} width="100%" height="15"/></td>
              <td><img src={leg2line} width="100%" height="15"/></td>                   
              <td><img src={leg2line} width="100%" height="15"/></td>                   
              <td><img src={leg2line} width="100%" height="15"/></td>                   
              <td style={{"width": "5px"}}><img src={leg2end}/></td>
            </tr>
        
            <tr className="ltLocations">
              <td colSpan="2" style={{"textAlign": "left"  }}>{row.depotcity}, {row.depotcountry}</td>             
              <td colSpan="2" style={{"textAlign": "left"  }} className="ltCarrier">{firstCarrier}</td>
              <td colSpan="3" style={{"textAlign": "center"}}>{T(row.xdock_location)}</td>
              <td colSpan="2" style={{"textAlign": "center"}} className="ltCarrier">{lastCarrier}</td>
              <td colSpan="3" style={{"textAlign": "right", "fontSize":"11px" }} nowrap="true">{ShipAddr}</td>
            </tr>
        
          </table>

      } else {

        /* ---- single leg ---- */

        var logisticTimeline = 
          <table className="logisticTimeline" border="0">

            <tr className="ltDates">
                <td colSpan="2" style={{"textAlign": "left" }}>{fmDate(row.shipped_at)}</td>
                <td colSpan="3" style={{"textAlign": "right"}}></td> 
                <td></td>                                
                <td colSpan="2" style={{"textAlign": "left" }}></td>
                <td colSpan="4" style={{"textAlign": "right"}} nowrap="true">{DDate}</td>
            </tr>

            <tr className="ltIcons">
                <td rowSpan="2" style={{"verticalAlign":"bottom", "width": "30px"}}><img src={factory}/></td>
                <td colSpan="3" style={{"verticalAlign":"bottom", "textAlign": "center", "width": "38%"}}></td>
                <td></td>                                                                     
                <td rowSpan="2" style={{"verticalAlign":"bottom", "width": "0px"}}      ></td>
                <td colSpan="3" style={{"verticalAlign":"bottom", "textAlign": "center"}}>{leg1shippingType}</td>
                <td colSpan="2" ></td>
                <td rowSpan="2" style={{"verticalAlign":"bottom", "width": "30px"}}      ><img src={House}/></td>
            </tr>
      
            <tr>
              <td><img src={leg1line} width="100%" height="15"/></td>
              <td><img src={leg1line} width="100%" height="15"/></td>
              <td><img src={leg1line} width="100%" height="15"/></td>     
              <td style={{"width": "5px"}}><img src={leg1line}/></td>          
              <td style={{"width": "5px"}}><img src={leg2line} width="100%" height="15"/></td>
              <td><img src={leg2line} width="100%" height="15"/></td>                   
              <td><img src={leg2line} width="100%" height="15"/></td>                   
              <td><img src={leg2line} width="100%" height="15"/></td>                   
              <td style={{"width": "5px"}}><img src={leg2end}/></td>
            </tr>
        
            <tr className="ltLocations">
              <td colSpan="2" style={{"textAlign": "left"  }}>{row.depotcity}, {row.depotcountry}</td>             
              <td colSpan="2" style={{"textAlign": "left"  }} className="ltCarrier"></td>
              <td colSpan="3" style={{"textAlign": "center"}}></td>
              <td colSpan="2" style={{"textAlign": "center"}} className="ltCarrier">{lastCarrier}</td>
              <td colSpan="3" style={{"textAlign": "right", "fontSize":"11px" }} nowrap="true">{ShipAddr}</td>
            </tr>
        
          </table>
      }

      return (
        <table className="logisticTimelineWrapper">
          <tbody>
            <tr>
              <th style={{"textAlign": "center", "whiteSpace": "nowrap"}}>Tracking Number: {tNTButton}</th>
              <th style={{"textAlign": "center", "whiteSpace": "nowrap"}}>Shipment: {row.shipmentno}</th>
              <td style={{"textAlign": "left", "width":"58%", "backgroundColor":"#f2f2f2", "paddingLeft":"4px"}}>&nbsp;Route: {row.route} ({row.ftt} days) &nbsp;&nbsp; {CommentLine} </td>           
            </tr>
            <tr>
              <td colSpan="3" style={{"width":"100%", "padding":"10px 4px", "border":"1px solid #999999", "borderBottom":"0px" }}>{logisticTimeline}</td>
            </tr>
            <tr>
              <td colSpan="3" style={{"width":"100%", "padding":"10px 4px", "border":"1px solid #999999", "borderTop":"0px"}}>

                <table className="table tablelight" style={{"width":"65%", "marginBottom":"0px"}}>
                  <thead>
                    {headerRow}
                  </thead>  
                  <tbody>  
                   {prodRow}
                  </tbody>
                </table>

              </td>
            </tr>
          </tbody>        
        </table>
      )
    });

    return(
      <div style={{"overflow":"auto","height":"420px"}}>
        {shipments}
      </div>
    );
  }
};
 
var handleCloseModal = function() {
  window.parent.postMessage('hp_close_orderstatus_widget', '*');
}

var runningCalls = 0;
function reflectActivity (incrDecr)
{
  runningCalls = runningCalls + incrDecr;
  if (runningCalls > 0) {
    $("#spinningIcon").show();
  } else {
    $("#spinningIcon").hide();
  }
}


(function($) {
    'use strict';
    $.fn.tooltipOnOverflow = function() {
      $(this).on("mouseenter", function() {
        if (this.offsetWidth < this.scrollWidth) {
          $(this).attr('title', $(this).text());
        } else {
            $(this).removeAttr("title");
        }
      });
    };
})(jQuery);

/*
//---- get and set local
var Params = getQueryParams(document.location.search);
console.log( Params );

var locale = 'en';
if (Params.language) {
  locale = Params.language.toLowerCase();
}
I18N.setLocale(locale);


var b2bparameters = null;
if (Params.b2bparameters) {
  b2bparameters = Params.b2bparameters;
}


//---- show a loading screen first ...

$('#ossOrderModal').modal('hide');

ReactDOM.render(
  <ModalWidgetWaiting
    size={"large"}/>
  , document.getElementById('mainbody')
);

if (Params.lookupValue == "" || Params.lookupValue == undefined){

  ReactDOM.render(
    <OSWidgetMainScreen
      size={"large"}
      type={"default"}
      order={"order"}
      searchQry={"searchQry"}/>
    , document.getElementById('mainbody')
  );

} else {
  GET("../ossui/v1/in/widget/order", Params, function(resp) {

    if (resp.status == 'N') {

      alert(resp.message);

    } else

      if (resp.status == 'E') {

        $('#ossOrderModal').modal( { backdrop: 'static'} ); 

        if (resp.code == 401) { 
          $('#errorPaneText').html(T('warn_unauthorized'));
          $('#errorPane').show();
        }

      } else {
        // now show everything
        $('#ossOrderModal').modal('hide');

        ReactDOM.render(
          <OSWidgetInt
            order={resp.data}
            b2bparameters={b2bparameters} />
          , document.getElementById('mainbody')
        );

        $('#ossOrderModal').modal( { backdrop: 'static'} );
      }
  });
}

$('#ossOrderModal').modal( { backdrop: 'static'} );
$('td, th, h3').tooltipOnOverflow();

var state = {
  order     : "",
  searchQry : ""
}*/
